(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 9803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrow);

/***/ }),

/***/ 84915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgQuote(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.264 19.552c0 3.648 2.4 5.568 5.088 5.568 2.976 0 5.76-2.496 5.76-5.664 0-2.592-1.824-4.32-4.032-4.32h-.768c1.056-3.072 4.512-6.336 8.064-8.064L26.4 4c-5.952 2.976-11.136 9.504-11.136 15.552zM0 19.552C0 23.2 2.304 25.12 5.088 25.12c2.976 0 5.76-2.496 5.76-5.664 0-2.592-1.92-4.32-4.128-4.32h-.768c1.056-3.072 4.608-6.336 8.064-8.064L11.136 4C5.184 6.976 0 13.504 0 19.552z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgQuote);

/***/ }),

/***/ 72496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgStar);

/***/ }),

/***/ 78581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(12715);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ DefaultLogoReel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _svg_logos_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68953);



function DefaultLogoReel(param) {
    var _showPretext = param.showPretext, showPretext = _showPretext === void 0 ? true : _showPretext, pretext = param.pretext, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto max-w-full px-6 text-center", className),
        children: [
            showPretext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mb-8 text-lg font-semibold text-haiti",
                children: pretext || "Trusted by teams of all sizes to deliver content to millions across the world"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_logos_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mx-auto block max-w-full"
            })
        ]
    }));
}


/***/ }),

/***/ 12715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Layout/Vanilla.tsx + 22 modules
var Vanilla = __webpack_require__(1635);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/Slider/index.tsx + 1 modules
var Slider = __webpack_require__(71839);
// EXTERNAL MODULE: ./src/components/LogoReel.tsx
var LogoReel = __webpack_require__(63016);
// EXTERNAL MODULE: ./src/svg/icons/star.svg
var star = __webpack_require__(72496);
// EXTERNAL MODULE: ./src/components/Ratings.module.css
var Ratings_module = __webpack_require__(46467);
var Ratings_module_default = /*#__PURE__*/__webpack_require__.n(Ratings_module);
;// CONCATENATED MODULE: ./src/components/Ratings.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Stars(param) {
    var value = param.value;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-2 flex justify-center",
        children: new Array(value).fill(0).map(function(_, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "px-0.5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(star/* default */.Z, {
                    className: "w-5 text-yellow-500"
                })
            }, index);
        })
    }));
}
function Rating(param) {
    var platform = param.platform, url = param.url, value = param.value;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center",
        children: url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "block text-sm font-medium hover:text-cornflower",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                    value: value
                }),
                platform
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                    value: value
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mb-2 block text-sm font-medium",
                    children: platform
                })
            ]
        })
    }));
}
function Ratings(param) {
    var ratings = param.ratings;
    var Component = function(rating, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Rating, _objectSpread({}, rating), index);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Ratings_module_default()).grid,
        children: ratings.map(Component)
    }));
};

// EXTERNAL MODULE: ./src/components/Slider/context.tsx
var context = __webpack_require__(51188);
// EXTERNAL MODULE: ./src/components/Authors.js
var Authors = __webpack_require__(56794);
// EXTERNAL MODULE: ./src/components/renderers/Paragraph.tsx
var Paragraph = __webpack_require__(37324);
// EXTERNAL MODULE: ./src/svg/icons/quote.svg
var quote = __webpack_require__(84915);
;// CONCATENATED MODULE: ./src/components/SliderTestimonial.js








function SliderTestimonial() {
    var ref = (0,context/* useSliderState */.xu)(), activeIndex = ref.activeIndex, items = ref.items;
    var containerWidth = "".concat(items.length * 100, "%");
    var translateValue = function() {
        var width = 100 / items.length;
        return "-".concat(activeIndex * width, "%");
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-48 bg-whisper py-4 md:h-auto md:w-1/3 md:py-0 md:px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "relative flex flex-auto flex-col",
                    children: items.map(function(item, index) {
                        var isActive = activeIndex === index;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()('absolute bottom-0 left-0 right-0 top-0 flex h-full w-full items-center justify-center transition-opacity duration-300 md:flex-col', {
                                'z-0 opacity-0': !isActive,
                                'z-10 opacity-100': isActive
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:mx-auto md:mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: item.company.logo.url,
                                        title: item.company.name,
                                        width: 128,
                                        height: 128,
                                        objectFit: "contain",
                                        alt: item.company.name
                                    })
                                }),
                                item.company.caseStudy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/case-studies/".concat(item.company.caseStudy.slug),
                                    appearance: "minimal",
                                    colour: "pink",
                                    children: "Read Case Study →"
                                })
                            ]
                        }, index));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex transform flex-col overflow-hidden rounded-r-lg bg-cornflower md:w-2/3 md:translate-x-12 md:-skew-x-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-1 transition-transform duration-300",
                    style: {
                        width: containerWidth,
                        transform: "translateX(".concat(translateValue(), ")")
                    },
                    children: items.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "flex flex-1 transform md:skew-x-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col items-center justify-center px-8 py-8 md:px-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative z-20 rounded-lg bg-white p-6 text-haiti shadow-image",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pin-t pin-l absolute -mt-3 -ml-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quote/* default */.Z, {
                                                        className: "w-10 text-whisper"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative -mt-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        className: "text-sm italic",
                                                        children: item.author.bio
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "-ml-3 flex items-center justify-between",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "-ml-px flex-grow",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Authors/* default */.Z, {
                                                    people: [
                                                        item.author
                                                    ],
                                                    showTitle: true
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./public/images/home/hero.png
/* harmony default export */ var hero = ({"src":"/_next/static/media/hero.740dc982.png","height":1242,"width":2260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEX3+Pr5+fv+/v7o6u/8/f3y8fPo6e3m7/H39/n7/P1Jyzg9AAAACXRSTlPO/u381KO6vfIAHQzHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVQImRXBiQ0AIBDDsKTHo+6/MMLmmCRzwVEFOm2Fvfj2AwZWAFj1/UG8AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/sections/home/hero-form.tsx

/* eslint-disable jsx-a11y/label-has-associated-control */ 



function hero_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hero_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hero_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HeroForm(param1) {
    var className = param1.className;
    var onSubmit = function onSubmit(param) {
        var email = param.email;
        if (!email) return;
        window.sessionStorage.setItem("email", email);
        router.push("/contact");
    };
    var router = (0,next_router.useRouter)();
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.errors;
    var hasError = !!errors.email;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: classnames_default()("flex w-full flex-col items-center md:flex-row", className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full md:max-w-xs",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "email",
                                className: "sr-only block text-sm font-medium text-gray-700",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative rounded-r rounded-l md:rounded-r-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", hero_form_objectSpread({
                                    type: "email",
                                    name: "email",
                                    id: "email",
                                    placeholder: "Enter email",
                                    ref: register({
                                        required: true,
                                        pattern: {
                                            value: /^\S+@\S+$/i,
                                            message: "Invalid email"
                                        }
                                    }),
                                    className: "focus:outline-none form-input block w-full rounded-r rounded-l border-none bg-catskill-white px-4 text-rock-blue ring-0 focus:ring-0 sm:text-sm md:rounded-r-none md:px-6"
                                }, hasError && {
                                    'aria-invalid': "true",
                                    'aria-describedby': "email-error"
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        colour: "purple",
                        className: "mt-3 w-full rounded-r rounded-l !px-6 md:mt-0 md:w-auto md:rounded-l-none",
                        type: "submit",
                        children: "Request a demo"
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                id: "email-error",
                children: "Please enter a valid email address"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/sections/home/hero.tsx




function hero_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hero_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hero_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var heroFeatures = [
    {
        id: 1,
        text: "Build your production-ready Content API within minutes"
    },
    {
        id: 2,
        text: "Remote data fetching to federate content from external sources"
    },
    {
        id: 3,
        text: "Leading GraphQL APIs for Querying, Mutations, and Assets"
    }, 
];
function DataPattern(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", hero_objectSpread({
        width: "230",
        height: "146",
        viewBox: "0 0 230 146",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 0h2v2H0zM24 0h2v2h-2zM48 0h2v2h-2zM72 0h2v2h-2zM96 0h2v2h-2zM120 0h2v2h-2zM144 0h2v2h-2zM168 0h2v2h-2zM192 0h2v2h-2zM216 0h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F0F2F7",
                d: "M12 12h2v2h-2zM36 12h2v2h-2zM60 12h2v2h-2zM84 12h2v2h-2zM108 12h2v2h-2zM132 12h2v2h-2zM156 12h2v2h-2zM180 12h2v2h-2zM204 12h2v2h-2zM228 12h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 24h2v2H0zM24 24h2v2h-2zM48 24h2v2h-2zM72 24h2v2h-2zM96 24h2v2h-2zM120 24h2v2h-2zM144 24h2v2h-2zM168 24h2v2h-2zM192 24h2v2h-2zM216 24h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F0F2F7",
                d: "M12 36h2v2h-2zM36 36h2v2h-2zM60 36h2v2h-2zM84 36h2v2h-2zM108 36h2v2h-2zM132 36h2v2h-2zM156 36h2v2h-2zM180 36h2v2h-2zM204 36h2v2h-2zM228 36h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 48h2v2H0zM24 48h2v2h-2zM48 48h2v2h-2zM72 48h2v2h-2zM96 48h2v2h-2zM120 48h2v2h-2zM144 48h2v2h-2zM168 48h2v2h-2zM192 48h2v2h-2zM216 48h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F0F2F7",
                d: "M12 60h2v2h-2zM36 60h2v2h-2zM60 60h2v2h-2zM84 60h2v2h-2zM108 60h2v2h-2zM132 60h2v2h-2zM156 60h2v2h-2zM180 60h2v2h-2zM204 60h2v2h-2zM228 60h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 72h2v2H0zM24 72h2v2h-2zM48 72h2v2h-2zM72 72h2v2h-2zM96 72h2v2h-2zM120 72h2v2h-2zM144 72h2v2h-2zM168 72h2v2h-2zM192 72h2v2h-2zM216 72h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F0F2F7",
                d: "M12 84h2v2h-2zM36 84h2v2h-2zM60 84h2v2h-2zM84 84h2v2h-2zM108 84h2v2h-2zM132 84h2v2h-2zM156 84h2v2h-2zM180 84h2v2h-2zM204 84h2v2h-2zM228 84h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 96h2v2H0zM24 96h2v2h-2zM48 96h2v2h-2zM72 96h2v2h-2zM96 96h2v2h-2zM120 96h2v2h-2zM144 96h2v2h-2zM168 96h2v2h-2zM192 96h2v2h-2zM216 96h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F0F2F7",
                d: "M12 108h2v2h-2zM36 108h2v2h-2zM60 108h2v2h-2zM84 108h2v2h-2zM108 108h2v2h-2zM132 108h2v2h-2zM156 108h2v2h-2zM180 108h2v2h-2zM204 108h2v2h-2zM228 108h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 120h2v2H0zM24 120h2v2h-2zM48 120h2v2h-2zM72 120h2v2h-2zM96 120h2v2h-2zM120 120h2v2h-2zM144 120h2v2h-2zM168 120h2v2h-2zM192 120h2v2h-2zM216 120h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F0F2F7",
                d: "M12 132h2v2h-2zM36 132h2v2h-2zM60 132h2v2h-2zM84 132h2v2h-2zM108 132h2v2h-2zM132 132h2v2h-2zM156 132h2v2h-2zM180 132h2v2h-2zM204 132h2v2h-2zM228 132h2v2h-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#090E24",
                d: "M0 144h2v2H0zM24 144h2v2h-2zM48 144h2v2h-2zM72 144h2v2h-2zM96 144h2v2h-2zM120 144h2v2h-2zM144 144h2v2h-2zM168 144h2v2h-2zM192 144h2v2h-2zM216 144h2v2h-2z"
            })
        ]
    })));
}
function Hero(param) {
    var page = param.page;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mx-auto max-w-6xl px-4 md:px-6 lg:grid lg:grid-cols-2 lg:gap-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto w-full max-w-3xl text-haiti lg:mx-0 lg:max-w-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-3xl font-bold leading-tight md:text-5xl",
                        children: page.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-7 text-base leading-normal md:text-lg",
                        children: page.subTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-8 space-y-4 lg:space-y-6",
                        children: heroFeatures.map(function(feature) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                className: "flex items-center text-base font-semibold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                opacity: "0.2",
                                                cx: "9",
                                                cy: "9",
                                                r: "9",
                                                fill: "#F5487F"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                r: "3.52174",
                                                transform: "matrix(1 0 0 -1 9.00001 8.99975)",
                                                fill: "#F5487F"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "ml-4",
                                        children: feature.text
                                    })
                                ]
                            }, feature.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroForm, {
                        className: "mt-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://app.graphcms.com/signup",
                        rel: "noopener noreferrer",
                        className: "group mt-6 flex flex-col font-medium text-light-haiti sm:block lg:mt-12",
                        children: [
                            "Create a free-forever developer account.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-rose",
                                children: [
                                    "Get Started",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                        children: "→"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:mx-auto sm:max-w-3xl sm:px-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-12 sm:relative sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:mt-0 lg:w-1/2 lg:py-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative sm:px-0 lg:h-full lg:max-w-6xl lg:pl-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden sm:block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataPattern, {
                                        className: "absolute -bottom-3 right-1/2 ml-3 lg:left-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataPattern, {
                                        className: "absolute -top-4 -right-12",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:h-[621px] lg:w-[1130px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: hero,
                                    quality: 100,
                                    objectFit: "cover",
                                    priority: true,
                                    alt: "graphcms"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/sections/home/Logos.tsx



function Logos_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Logos_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Logos_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Logos(_param) {
    var title = _param.title, className = _param.className, logos = _param.logos, rest = _objectWithoutProperties(_param, [
        "title",
        "className",
        "logos"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", Logos_objectSpread({
            className: "mt-10 lg:mt-30"
        }, rest, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: classnames_default()("text-center text-base font-medium md:text-lg", className),
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mt-10 grid w-full max-w-4xl grid-cols-7 justify-items-center md:flex md:flex-wrap md:justify-center md:gap-y-10",
                    children: logos.map(function(param) {
                        var icon = param.icon, id = param.id;
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                            className: "flex h-6 w-6 items-center justify-center md:h-full md:w-1/4",
                            children: /*#__PURE__*/ (0,react.cloneElement)(icon, {
                                className: classnames_default()((ref = icon.props) === null || ref === void 0 ? void 0 : ref.className)
                            })
                        }, id);
                    })
                })
            ]
        }))
    }));
};

// EXTERNAL MODULE: ./src/components/USPCardRedesigned.tsx
var USPCardRedesigned = __webpack_require__(71985);
;// CONCATENATED MODULE: ./src/components/sections/home/HomeSectionHero.tsx



function SectionHero(param) {
    var badge = param.badge, title = param.title, description = param.description, cta = param.cta, colors = param.colors;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            badge && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: classnames_default()("mb-6 text-sm font-medium uppercase tracking-wide", (colors === null || colors === void 0 ? void 0 : colors.badge) || "text-azure-blue"),
                children: badge
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: classnames_default()("text-3xl font-bold leading-snug lg:text-5xl", (colors === null || colors === void 0 ? void 0 : colors.title) || "text-zodiac"),
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: classnames_default()("mt-6 text-base md:text-lg", (colors === null || colors === void 0 ? void 0 : colors.text) || "text-zodiac"),
                children: description
            }),
            cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4 inline-flex space-x-4 lg:mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: cta.href,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: classnames_default()("group w-5/6 text-base font-medium sm:w-full", (colors === null || colors === void 0 ? void 0 : colors.badge) || "text-azure-blue"),
                        children: [
                            cta.label,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                children: "→"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/reakit/es/Tab/TabState.js + 2 modules
var TabState = __webpack_require__(65419);
// EXTERNAL MODULE: ./src/styles/pages/home.module.css
var home_module = __webpack_require__(80529);
var home_module_default = /*#__PURE__*/__webpack_require__.n(home_module);
// EXTERNAL MODULE: ./node_modules/reakit/es/Tab/Tab.js + 4 modules
var Tab = __webpack_require__(49973);
// EXTERNAL MODULE: ./src/components/sections/home/Tab.module.css
var Tab_module = __webpack_require__(34591);
var Tab_module_default = /*#__PURE__*/__webpack_require__.n(Tab_module);
;// CONCATENATED MODULE: ./src/components/sections/home/Tab.tsx




function Tab_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tab_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tab_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Tab_Tab(param) {
    var activeColor = param.activeColor, children = param.children, tab = param.tab, id = param.id, className = param.className;
    var isActive = tab.selectedId === id;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* Tab */.O, Tab_objectSpread({}, tab, {
        id: id,
        className: classnames_default()("focus:outline-none relative inline-block pb-3 text-sm font-medium uppercase tracking-wide", isActive ? (Tab_module_default()).tab : null, isActive ? activeColor : null, className),
        children: children
    })));
};

// EXTERNAL MODULE: ./node_modules/reakit/es/Tab/TabList.js + 3 modules
var TabList = __webpack_require__(51693);
;// CONCATENATED MODULE: ./src/components/sections/home/TabList.tsx



function TabList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TabList_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = TabList_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function TabList_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TabList_TabList(_param) {
    var children = _param.children, tab = _param.tab, withBottomBorder = _param.withBottomBorder, className = _param.className, rest = TabList_objectWithoutProperties(_param, [
        "children",
        "tab",
        "withBottomBorder",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(TabList/* TabList */.t, TabList_objectSpread({}, tab, {
        className: classnames_default()("relative flex w-full overflow-hidden lg:overflow-hidden", className)
    }, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("scrolling-touch absolute top-0 right-0 left-0 bottom-0 h-full w-auto overflow-y-hidden overflow-x-scroll whitespace-nowrap lg:relative lg:overflow-x-hidden", {
                'shadow-none md:shadow-border': withBottomBorder
            }),
            children: children
        })
    })));
};

// EXTERNAL MODULE: ./node_modules/reakit/es/Tab/TabPanel.js
var TabPanel = __webpack_require__(39030);
// EXTERNAL MODULE: ./node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(39920);
;// CONCATENATED MODULE: ./src/components/sections/home/TabPanel.tsx



function TabPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TabPanel_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = TabPanel_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function TabPanel_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TabPanel_TabPanel(_param) {
    var tab = _param.tab, id = _param.id, children = _param.children, rest = TabPanel_objectWithoutProperties(_param, [
        "tab",
        "id",
        "children"
    ]);
    var isActive = tab.selectedId === id;
    var spring = {
        from: {
            opacity: 0,
            transform: "translateY(-10%)",
            pointerEvents: "none",
            zIndex: 0
        },
        to: {
            opacity: isActive ? 1 : 0,
            transform: isActive ? "translateY(0px)" : "translateY(-10%)",
            pointerEvents: isActive ? "" : "none",
            zIndex: isActive ? 1 : 0
        }
    };
    var styles = (0,react_spring_esm.useSpring)(spring);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_esm.animated.div, {
        style: styles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* TabPanel */.x, TabPanel_objectSpread({}, tab, rest, {
            children: children
        }))
    }));
};

;// CONCATENATED MODULE: ./src/components/sections/home/CreatorsTabs.tsx









function CreatorsTab() {
    var tabCreators = (0,TabState/* useTabState */.x)({
        selectedId: "content-ui"
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((home_module_default()).gridCreators, (home_module_default()).gridTabs, "my-8 pt-1 md:mt-0 md:pt-0 lg:mb-12"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabList_TabList, {
                    tab: tabCreators,
                    "aria-label": "GraphCMS for content creators",
                    withBottomBorder: true,
                    className: "h-full items-center justify-center text-light-haiti",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabCreators,
                            id: "content-ui",
                            activeColor: "text-rose",
                            children: "Content UI"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabCreators,
                            id: "localization",
                            className: "mx-8",
                            activeColor: "text-rose",
                            children: "Localization"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabCreators,
                            id: "ui-extensions",
                            activeColor: "text-rose",
                            children: "UI Extensions"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabCreators,
                        id: "content-ui",
                        className: classnames_default()((home_module_default()).gridCreators, "focus:outline-none lg:min-h-[548px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/content-ui.svg",
                                alt: "GraphCMS Content UI with asset picker, rich text, and string fields",
                                width: 802,
                                height: 616
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "Graphcms For Content Creators",
                                    title: "Finally A CMS That Works With You",
                                    description: "Deliver perfect customer experiences every time. With a fast, lightweight, and intuitive content management studio at your fingertips, GraphCMS let’s you deliver your most ambitious ideas the way you envision them.",
                                    colors: {
                                        badge: "text-rose"
                                    },
                                    cta: {
                                        href: "/for-content-creators",
                                        label: "Explore GraphCMS for Content Creators"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabCreators,
                        id: "localization",
                        className: classnames_default()((home_module_default()).gridCreators, "focus:outline-none lg:min-h-[548px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/localization.svg",
                                alt: "Example of localized field for four languages, English, German, French (France), and French (Canada)",
                                width: 716,
                                height: 525
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "Graphcms For Content Creators",
                                    title: "Make Your Customers Feel At Home",
                                    description: "GraphCMS provides localization out of the box. Granular field-based localizations, fallbacks, locale-based publishing, and granular locale based permissions, create content for the world on your terms.",
                                    colors: {
                                        badge: "text-rose"
                                    },
                                    cta: {
                                        href: "/for-content-creators",
                                        label: "Explore GraphCMS for Content Creators"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabCreators,
                        id: "ui-extensions",
                        className: classnames_default()((home_module_default()).gridCreators, "focus:outline-none lg:min-h-[548px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/ui-extensions.svg",
                                alt: "GraphCMS management UI with three fields: product name, reference, and promotion",
                                width: 741,
                                height: 492
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "Graphcms For Content Creators",
                                    title: "Extensibility To Make It Yours",
                                    description: "Combining UI Extensions with Content Based Permissions lets you extend the basic functionality of the GraphCMS web app. Build on our UI to bring in your favorite integrations, or personalize the interface to suit your preferences.",
                                    colors: {
                                        badge: "text-rose"
                                    },
                                    cta: {
                                        href: "/for-content-creators",
                                        label: "Explore GraphCMS for Content Creators"
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/sections/home/BusinessesTabs.tsx









function BusinessesTabs() {
    var tabBusinesses = (0,TabState/* useTabState */.x)({
        selectedId: "team-efficiency"
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((home_module_default()).gridBusinesses, (home_module_default()).gridTabs, "my-8 pt-1 md:mt-0 md:pt-0 lg:mb-12"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabList_TabList, {
                    tab: tabBusinesses,
                    "aria-label": "Graphcms For Businesses",
                    withBottomBorder: true,
                    className: "col-start-1 h-full items-center justify-center text-light-haiti lg:col-start-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabBusinesses,
                            activeColor: "text-azure-blue",
                            id: "team-efficiency",
                            children: "Team Efficiency"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabBusinesses,
                            activeColor: "text-azure-blue",
                            id: "scalability",
                            className: "mx-8",
                            children: "Scalability"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabBusinesses,
                            activeColor: "text-azure-blue",
                            id: "time-to-market",
                            children: "Time to Market"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabBusinesses,
                        id: "team-efficiency",
                        className: classnames_default()((home_module_default()).gridBusinesses, "focus:outline-none lg:min-h-[453px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "Graphcms For Businesses",
                                    title: "Let All Your Investments Work Together",
                                    description: "Break down your silos by federating your content. GraphCMS can Integrate all your existing backend services and business processes to deliver cutting-edge digital experiences from a unified content layer.",
                                    colors: {
                                        badge: "text-azure-blue"
                                    },
                                    cta: {
                                        href: "/for-businesses",
                                        label: "Explore GraphCMS for Businesses"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/team-efficiency.svg",
                                alt: "Integrate all your existing backends and services to deliver content from a single source",
                                width: 522,
                                height: 452
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabBusinesses,
                        id: "scalability",
                        className: classnames_default()((home_module_default()).gridBusinesses, "focus:outline-none lg:min-h-[453px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "Graphcms For Businesses",
                                    title: "We’ll Scale With You In Every Direction",
                                    description: "GraphCMS is used by ambitious teams across the world, powering modern SaaS products, multilingual streaming platforms, and high-volume publishing portals.",
                                    colors: {
                                        badge: "text-azure-blue"
                                    },
                                    cta: {
                                        href: "/for-businesses",
                                        label: "Explore GraphCMS for Businesses"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/scalability.svg",
                                alt: "Scalability illustration with information as daily traffic, uptime, active projects, APIs federated, and orders processed",
                                width: 582,
                                height: 475
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabBusinesses,
                        id: "time-to-market",
                        className: classnames_default()((home_module_default()).gridBusinesses, "focus:outline-none lg:min-h-[453px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "Graphcms For Businesses",
                                    title: "Focus On Your Business Model",
                                    description: "Rapidly validate and innovate on your business model to match the speed of business. Stop compromising on your goals of delivering high-performance digital experiences because of legacy web technologies.",
                                    colors: {
                                        badge: "text-azure-blue"
                                    },
                                    cta: {
                                        href: "/for-businesses",
                                        label: "Explore GraphCMS for Businesses"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/time-to-market.svg",
                                alt: "Time to the market illustration showing a workflow that integrates the team and services with GraphCMS",
                                width: 608,
                                height: 377
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/utils/demo-for-engineering.ts
var demo_for_engineering = __webpack_require__(36574);
// EXTERNAL MODULE: ./src/components/renderers/Code.module.css
var Code_module = __webpack_require__(3518);
var Code_module_default = /*#__PURE__*/__webpack_require__.n(Code_module);
// EXTERNAL MODULE: ./src/components/renderers/CodeBlock.tsx + 2 modules
var CodeBlock = __webpack_require__(21955);
;// CONCATENATED MODULE: ./src/components/sections/home/Playground.tsx






function Playground_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Playground_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Playground_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Playground_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Playground_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Playground_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Playground_Tab(_param) {
    var children = _param.children, isActive = _param.isActive, className = _param.className, rest = Playground_objectWithoutProperties(_param, [
        "children",
        "isActive",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* Tab */.O, Playground_objectSpread({}, rest, {
        className: classnames_default()("focus:outline-none rounded p-3 text-center text-xs font-medium uppercase tracking-wider lg:text-sm", {
            'bg-light-bunting text-white': isActive,
            'text-light-haiti': !isActive
        }, className),
        children: children
    })));
}
function NavTab(_param) {
    var isActive = _param.isActive, children = _param.children, rest = Playground_objectWithoutProperties(_param, [
        "isActive",
        "children"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* Tab */.O, Playground_objectSpread({
        className: classnames_default()("focus:outline-none border-b pb-1 text-left text-sm", {
            'border-transparent text-light-haiti': !isActive,
            'border-white text-white': isActive
        })
    }, rest, {
        children: children
    })));
}
function CodeTab(param) {
    var response = param.response, query = param.query;
    var tab = (0,TabState/* useTabState */.x)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("h-72 flex-shrink-0 overflow-auto rounded border border-light-bunting bg-big-stone dark:bg-gray-900 lg:h-84", (Code_module_default()).code),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sticky top-0 z-10 bg-big-stone px-3 py-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabList/* TabList */.t, Playground_objectSpread({}, tab, {
                        "aria-label": "Query and response",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Playground_Tab, Playground_objectSpread({}, tab, {
                                id: "gql-query",
                                isActive: tab.selectedId === "gql-query",
                                className: "mr-2",
                                children: "Query"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Playground_Tab, Playground_objectSpread({}, tab, {
                                id: "response",
                                isActive: tab.selectedId === "response",
                                children: "Response"
                            }))
                        ]
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* TabPanel */.x, Playground_objectSpread({}, tab, {
                    className: "focus:outline-none text-sm",
                    style: {
                        height: "calc(100% - 70px)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBlock/* default */.Z, {
                        className: "graphql",
                        noCopy: true,
                        children: query || ""
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* TabPanel */.x, Playground_objectSpread({}, tab, {
                    className: "focus:outline-none text-sm",
                    style: {
                        height: "calc(100% - 70px)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBlock/* default */.Z, {
                        className: "json",
                        noCopy: true,
                        children: response || ""
                    })
                }))
            ]
        })
    }));
}
function Nav(param) {
    var items = param.items, label = param.label;
    var tab = (0,TabState/* useTabState */.x)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabList_TabList, {
                tab: tab,
                "aria-label": "".concat(label, " code examples"),
                className: "mb-6 h-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "space-x-3",
                    children: items.map(function(item) {
                        var isActive = tab.selectedId === item.label;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NavTab, Playground_objectSpread({
                            isActive: isActive,
                            id: item.label
                        }, tab, {
                            children: item.label
                        }), item.label));
                    })
                })
            }),
            items.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TabPanel/* TabPanel */.x, Playground_objectSpread({}, tab, {
                    className: "focus:outline-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeTab, {
                        response: item.response,
                        query: item.query
                    })
                }), item.label);
            })
        ]
    }));
}
function Playground(param) {
    var queries = param.queries, mutations = param.mutations;
    var tab = (0,TabState/* useTabState */.x)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full overflow-auto text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabList/* TabList */.t, Playground_objectSpread({}, tab, {
                "aria-label": "Queries and Mutations examples",
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Playground_Tab, Playground_objectSpread({}, tab, {
                        isActive: tab.selectedId === "queries",
                        id: "queries",
                        className: "mr-2",
                        children: "Queries"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Playground_Tab, Playground_objectSpread({}, tab, {
                        isActive: tab.selectedId === "mutations",
                        id: "mutations",
                        children: "Mutations"
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* TabPanel */.x, Playground_objectSpread({}, tab, {
                className: "focus:outline-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                    items: queries,
                    label: "Queries"
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* TabPanel */.x, Playground_objectSpread({}, tab, {
                className: "focus:outline-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                    items: mutations,
                    label: "Mutations"
                })
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/sections/home/EngineeringTabs.tsx











function EngineeringTabs() {
    var tabEng = (0,TabState/* useTabState */.x)({
        selectedId: "queries-mutations"
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((home_module_default()).gridEng, (home_module_default()).gridTabs, "my-8 pt-1 md:mt-0 md:pt-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabList_TabList, {
                    tab: tabEng,
                    "aria-label": "Graphcms For Engineering teams",
                    withBottomBorder: true,
                    className: "col-start-1 h-full items-center justify-center text-light-haiti lg:col-start-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabEng,
                            id: "queries-mutations",
                            activeColor: "text-cornflower",
                            children: "Queries & Mutations"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabEng,
                            id: "structured-content",
                            className: "mx-8",
                            activeColor: "text-cornflower",
                            children: "Structured Content"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_Tab, {
                            tab: tabEng,
                            id: "content-federation",
                            activeColor: "text-cornflower",
                            children: "External Data Sourcing"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabEng,
                        id: "queries-mutations",
                        className: classnames_default()((home_module_default()).gridEng, "focus:outline-none lg:min-h-[462px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "GraphCMS For Engineering teams",
                                    title: "All Your Content One API Call Away",
                                    description: "Meet the industry’s most robust GraphQL APIs to boost developer productivity. All your content is hosted in the data center of your choice, and served from the world’s fastest Edge CDN.",
                                    colors: {
                                        badge: "text-cornflower",
                                        text: "text-whisper",
                                        title: "text-white"
                                    },
                                    cta: {
                                        href: "/for-engineering",
                                        label: "Explore GraphCMS for Engineering Teams"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Playground, {
                                queries: demo_for_engineering/* queries */.o$,
                                mutations: demo_for_engineering/* mutations */.P$
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabEng,
                        id: "structured-content",
                        className: classnames_default()((home_module_default()).gridEng, "focus:outline-none lg:min-h-[462px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "GraphCMS For Engineering teams",
                                    title: "Become A Content Architect",
                                    description: "Easy but expressive content modeling allows you to structure your content within minutes using our intuitive schema builder. Environments help you evolve your content model safely.",
                                    colors: {
                                        badge: "text-cornflower",
                                        text: "text-whisper",
                                        title: "text-white"
                                    },
                                    cta: {
                                        href: "/for-engineering",
                                        label: "Explore GraphCMS for Engineering Teams"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/structured-content.svg",
                                alt: "GraphCMS schema with three models, Actor, Show, and Episode, alongside their field types",
                                width: 575,
                                height: 380
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPanel_TabPanel, {
                        tab: tabEng,
                        id: "content-federation",
                        className: classnames_default()((home_module_default()).gridEng, "focus:outline-none lg:min-h-[462px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                    badge: "GraphCMS For Engineering teams",
                                    title: "Meet Content Federation",
                                    description: "Build your ultimate content pipeline. GraphCMS allows API extensions and remote joins to fetch content and data from any external source.",
                                    colors: {
                                        badge: "text-cornflower",
                                        text: "text-whisper",
                                        title: "text-white"
                                    },
                                    cta: {
                                        href: "/for-engineering",
                                        label: "Explore GraphCMS for Engineering Teams"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/home/content-federation.svg",
                                alt: "GraphQL Query fetching movies with a title from GraphCMS, rating from IMDb, a poster from Bynder, and prices from Shopify",
                                width: 518,
                                height: 291
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/lib/scroll.ts
var lib_scroll = __webpack_require__(44497);
;// CONCATENATED MODULE: ./src/svg/icons/vercel.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVercel(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 30 26",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15 .52l14.4 24.914H.6z",
    fill: "#fff"
  })));
}

/* harmony default export */ var vercel = (SvgVercel);
;// CONCATENATED MODULE: ./src/svg/icons/zapier.svg
var zapier_path;

function zapier_extends() { zapier_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return zapier_extends.apply(this, arguments); }



function SvgZapier(props) {
  return /*#__PURE__*/react.createElement("svg", zapier_extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), zapier_path || (zapier_path = /*#__PURE__*/react.createElement("path", {
    d: "M29.043 12.488h-8.449l5.937-5.936c-.456-.685-.913-1.142-1.37-1.827a13.062 13.062 0 01-1.827-1.599L17.4 9.063V.843a7.763 7.763 0 00-2.284-.228 7.033 7.033 0 00-2.284.228v8.45L6.666 3.126c-.709.406-1.33.95-1.827 1.598-.457.685-1.142 1.142-1.598 1.827l5.936 5.936H.957L.73 14.772c-.05.768.028 1.54.228 2.283h8.45L3.242 23.22a12.24 12.24 0 003.424 3.425l5.937-5.937v8.45a7.767 7.767 0 002.284.227c.768.05 1.54-.027 2.283-.228V20.71l5.936 5.937a6.164 6.164 0 001.827-1.598 13.068 13.068 0 001.598-1.827l-5.937-5.937h8.45A7.764 7.764 0 0029.271 15a8.562 8.562 0 00-.228-2.512zM18.54 14.772a11.574 11.574 0 01-.457 2.968 6.852 6.852 0 01-2.968.457 11.579 11.579 0 01-2.969-.457 6.852 6.852 0 01-.457-2.968c.023-1.005.177-2.003.457-2.969a6.85 6.85 0 012.969-.457c1.005.023 2.003.177 2.968.457.264.97.417 1.965.457 2.969z",
    fill: "#fff"
  })));
}

/* harmony default export */ var zapier = (SvgZapier);
;// CONCATENATED MODULE: ./src/svg/icons/jira.svg
var jira_path, _path2, _path3, _defs;

function jira_extends() { jira_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return jira_extends.apply(this, arguments); }



function SvgJira(props) {
  return /*#__PURE__*/react.createElement("svg", jira_extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jira_path || (jira_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.952 28.8c2.787-2.787 2.787-7.366 0-10.153l-9.357-9.29-4.247 4.247c-.464.464-.464 1.194 0 1.593L13.952 28.8zM27.555 13.604L13.952 0l-.067.066a7.13 7.13 0 000 10.087l9.357 9.29 4.247-4.247c.53-.464.53-1.194.066-1.592z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M13.952 10.087a7.13 7.13 0 010-10.087L4.197 9.688l5.044 5.044 4.711-4.645z",
    fill: "url(#jira_svg__paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M18.597 14.002l-4.645 4.645c2.787 2.787 2.787 7.365 0 10.152l9.755-9.754L18.597 14z",
    fill: "url(#jira_svg__paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "jira_svg__paint0_linear",
    x1: 13.719,
    y1: 5.273,
    x2: 7.835,
    y2: 11.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.068,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "jira_svg__paint1_linear",
    x1: 14.317,
    y1: 23.341,
    x2: 20.761,
    y2: 16.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.068,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.908,
    stopColor: "#fff"
  })))));
}

/* harmony default export */ var jira = (SvgJira);
;// CONCATENATED MODULE: ./src/svg/icons/gatsby-cloud.svg
var gatsby_cloud_path;

function gatsby_cloud_extends() { gatsby_cloud_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gatsby_cloud_extends.apply(this, arguments); }



function SvgGatsbyCloud(props) {
  return /*#__PURE__*/react.createElement("svg", gatsby_cloud_extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), gatsby_cloud_path || (gatsby_cloud_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.001.608C6.991.608.608 6.991.608 15S6.991 29.394 15 29.394s14.393-6.383 14.393-14.393S23.01.608 15 .608zM3.737 15.126l11.14 11.14c-6.134 0-11.14-5.007-11.14-11.14zm13.767 10.889L3.988 12.498C5.112 7.492 9.619 3.737 15 3.737a11.371 11.371 0 019.137 4.632L22.51 9.744a9.189 9.189 0 00-7.635-4.004 9.066 9.066 0 00-8.636 6.132l11.765 11.766c2.88-1.002 5.131-3.504 5.757-6.51h-4.881v-2.127h7.385c0 5.382-3.755 9.888-8.762 11.014z",
    fill: "#fff"
  })));
}

/* harmony default export */ var gatsby_cloud = (SvgGatsbyCloud);
;// CONCATENATED MODULE: ./src/svg/icons/slack-colour.svg
var _g;

function slack_colour_extends() { slack_colour_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return slack_colour_extends.apply(this, arguments); }



function SvgSlackColour(props) {
  return /*#__PURE__*/react.createElement("svg", slack_colour_extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 29 29",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M10.538 0a2.876 2.876 0 00-2.874 2.88 2.877 2.877 0 002.875 2.879h2.875V2.88A2.88 2.88 0 0010.538 0c.001 0 .001 0 0 0zm0 7.68H2.874A2.877 2.877 0 000 10.56a2.877 2.877 0 002.873 2.88h7.665a2.877 2.877 0 002.875-2.88 2.877 2.877 0 00-2.875-2.88z",
    fill: "#36c5f0"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.742 10.56a2.877 2.877 0 00-2.874-2.88 2.877 2.877 0 00-2.875 2.88v2.88h2.875a2.878 2.878 0 002.875-2.88zm-7.664 0V2.88A2.878 2.878 0 0018.204 0a2.877 2.877 0 00-2.875 2.88v7.68a2.877 2.877 0 002.874 2.88 2.878 2.878 0 002.875-2.88z",
    fill: "#2eb67d"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.203 28.8a2.877 2.877 0 002.875-2.88 2.877 2.877 0 00-2.875-2.879h-2.875v2.88a2.879 2.879 0 002.875 2.88zm0-7.681h7.665a2.877 2.877 0 002.875-2.88 2.877 2.877 0 00-2.874-2.88h-7.665a2.877 2.877 0 00-2.875 2.88 2.876 2.876 0 002.874 2.88z",
    fill: "#ecb22e"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 18.24a2.877 2.877 0 002.875 2.879 2.877 2.877 0 002.874-2.88v-2.88H2.875A2.877 2.877 0 000 18.24zm7.665 0v7.68a2.877 2.877 0 002.873 2.88 2.877 2.877 0 002.875-2.88v-7.678a2.875 2.875 0 10-5.748-.002z",
    fill: "#e01e5a"
  }))));
}

/* harmony default export */ var slack_colour = (SvgSlackColour);
// EXTERNAL MODULE: ./src/svg/icons/slack.svg
var slack = __webpack_require__(31358);
;// CONCATENATED MODULE: ./src/svg/icons/shopify.svg
var _clipPath, shopify_g;

function shopify_extends() { shopify_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shopify_extends.apply(this, arguments); }



function SvgShopify(props) {
  return /*#__PURE__*/react.createElement("svg", shopify_extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 26 29",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/react.createElement("clipPath", {
    id: "shopify_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 0h25.252v28.8H0z"
  }))), shopify_g || (shopify_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#shopify_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M22.072 5.656a.277.277 0 00-.25-.232c-.104-.009-2.306-.172-2.306-.172l-1.697-1.687c-.168-.168-.496-.116-.624-.079l-.856.264C15.83 2.28 14.927.93 13.34.93c-.043 0-.088 0-.134.003-.45-.596-1.01-.855-1.492-.855-3.695 0-5.46 4.619-6.014 6.966l-2.586.803c-.802.25-.827.276-.933 1.031-.079.572-2.176 16.79-2.176 16.79l16.341 3.062 8.854-1.916S22.092 5.8 22.072 5.656zM15.436 4.03l-1.383.428.001-.299c0-.913-.127-1.649-.33-2.232.817.102 1.362 1.032 1.712 2.103zM12.71 2.108c.227.57.375 1.387.375 2.49v.16l-2.856.884c.55-2.122 1.58-3.147 2.481-3.534zm-1.098-1.04c.16 0 .32.055.474.16-1.184.558-2.453 1.962-2.99 4.764l-2.257.7c.628-2.138 2.119-5.623 4.773-5.623z",
    fill: "#95bf46"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.822 5.424c-.104-.009-2.306-.172-2.306-.172l-1.698-1.687a.42.42 0 00-.236-.108l-1.235 25.272 8.853-1.915S22.092 5.8 22.072 5.656a.277.277 0 00-.25-.232z",
    fill: "#5e8e3e"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.34 10.316l-1.092 3.248s-.956-.511-2.129-.511c-1.719 0-1.805 1.079-1.805 1.35 0 1.484 3.866 2.052 3.866 5.526 0 2.734-1.733 4.494-4.071 4.494-2.805 0-4.24-1.746-4.24-1.746l.752-2.482s1.474 1.266 2.718 1.266c.813 0 1.144-.64 1.144-1.108 0-1.934-3.172-2.02-3.172-5.2 0-2.675 1.92-5.265 5.797-5.265 1.494 0 2.232.428 2.232.428z",
    fill: "#fff"
  }))));
}

/* harmony default export */ var shopify = (SvgShopify);
;// CONCATENATED MODULE: ./src/svg/icons/bynder.svg
var bynder_path;

function bynder_extends() { bynder_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bynder_extends.apply(this, arguments); }



function SvgBynder(props) {
  return /*#__PURE__*/react.createElement("svg", bynder_extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 29 22",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bynder_path || (bynder_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.816.072c-2.016 0-3.888.864-5.112 2.304L7.56 11.52 4.968 8.928c-.432-.504-.72-1.152-.72-1.8 0-1.584 1.224-2.808 2.808-2.808.72 0 1.296.216 1.8.72l.288.288.36.36 2.232-2.232.648-.648-.576-.576-.216-.216C10.296.72 8.64.072 6.84.072 3.096.072 0 3.096 0 6.84c0 1.728.648 3.312 1.656 4.536l5.832 5.904 12.24-12.24c.504-.432 1.152-.72 1.8-.72a2.735 2.735 0 012.736 2.736c0 .72-.216 1.296-.72 1.8l-7.992 8.136c-.288.36-.792.504-1.224.504-.504 0-.936-.216-1.224-.504l-.648-.576-2.88 2.88.576.576c1.08 1.08 2.52 1.728 4.104 1.728s3.024-.648 4.104-1.728l8.496-8.496c1.008-1.152 1.656-2.808 1.656-4.536.144-3.744-2.952-6.768-6.696-6.768z",
    fill: "#fff"
  })));
}

/* harmony default export */ var bynder = (SvgBynder);
;// CONCATENATED MODULE: ./src/svg/icons/asana.svg
var asana_g, asana_defs;

function asana_extends() { asana_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return asana_extends.apply(this, arguments); }



function SvgAsana(props) {
  return /*#__PURE__*/react.createElement("svg", asana_extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), asana_g || (asana_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#asana_svg__clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M2.707 17.954c-.949 0-1.718-.786-1.718-1.756s.77-1.756 1.718-1.756c.95 0 1.718.786 1.718 1.756s-.769 1.756-1.718 1.756zm1.724.223c0 .16.275.612.613.612h.219c.084 0 .154-.07.154-.154V13.83h-.001a.154.154 0 00-.153-.146h-.678a.154.154 0 00-.154.146v.39c-.415-.511-1.07-.723-1.726-.723a2.701 2.701 0 100 5.403c.656 0 1.371-.255 1.726-.724zm2.605-.688a2.5 2.5 0 001.42.465c.452 0 .92-.234.92-.642 0-.545-1.019-.63-1.659-.847-.64-.217-1.19-.667-1.19-1.395 0-1.113.992-1.573 1.918-1.573.587 0 1.192.193 1.585.47.135.103.053.22.053.22l-.375.536c-.042.06-.13.108-.221.047-.253-.167-.534-.328-1.042-.328-.629 0-.905.261-.905.585 0 .388.442.51.96.642.903.243 1.889.536 1.889 1.643 0 .981-.918 1.588-1.933 1.588-.769 0-1.423-.22-1.972-.622-.115-.115-.035-.221-.035-.221l.373-.532c.076-.1.172-.065.214-.036zm8.434.688c0 .16.275.612.613.612h.219c.085 0 .154-.07.154-.154V13.83h-.001a.154.154 0 00-.153-.146h-.678a.154.154 0 00-.153.146h-.001v.39c-.415-.511-1.07-.723-1.726-.723a2.701 2.701 0 100 5.402c.656 0 1.372-.254 1.726-.723zm-1.724-.223c-.948 0-1.718-.786-1.718-1.756s.77-1.756 1.718-1.756c.95 0 1.718.786 1.718 1.756s-.769 1.756-1.718 1.756zm8.78.388v-2.486c0-1.402-.884-2.348-2.294-2.348-.673 0-1.224.39-1.419.724v-.005.004c-.001-.338-.276-.536-.614-.536h-.218a.155.155 0 00-.154.155v4.805h.001c.005.081.072.146.153.146h.678l.03-.003c.005 0 .009-.003.013-.004l.015-.005c.007-.002.012-.005.018-.009l.008-.004a.162.162 0 00.019-.015l.003-.003a.153.153 0 00.047-.103h.001v-2.838a1.363 1.363 0 012.727 0v2.373-.001.466h.002c.004.081.07.146.153.146h.677l.03-.003c.005 0 .009-.002.012-.003.006-.002.012-.003.017-.006l.016-.008.01-.005a.172.172 0 00.039-.038.153.153 0 00.03-.082v-.314zm5.285-.165c0 .16.275.612.613.612h.218c.085 0 .155-.07.155-.154V13.83h-.001a.155.155 0 00-.154-.146h-.677a.154.154 0 00-.153.146h-.001v.39c-.416-.511-1.07-.723-1.727-.723a2.701 2.701 0 000 5.402c.657 0 1.372-.254 1.726-.723zm-1.724-.223c-.949 0-1.718-.786-1.718-1.756s.77-1.756 1.718-1.756c.949 0 1.718.786 1.718 1.756s-.77 1.756-1.718 1.756z",
    fill: "#283343"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.519 5.327a2.367 2.367 0 100 4.734 2.367 2.367 0 000-4.734zm-6.15 0a2.367 2.367 0 100 4.734 2.367 2.367 0 000-4.734zm5.442-2.96a2.367 2.367 0 11-4.735 0 2.367 2.367 0 014.735 0z",
    fill: "url(#asana_svg__paint0_radial)"
  }))), asana_defs || (asana_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "asana_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.21285 0 0 6.66692 14.444 5.499)"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.999,
    stopColor: "#F95353"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "asana_svg__clip0"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h28.8v19.008H0z"
  })))));
}

/* harmony default export */ var asana = (SvgAsana);
;// CONCATENATED MODULE: ./src/svg/icons/netlify.svg
var netlify_path;

function netlify_extends() { netlify_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return netlify_extends.apply(this, arguments); }



function SvgNetlify(props) {
  return /*#__PURE__*/react.createElement("svg", netlify_extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), netlify_path || (netlify_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.184 9.777l-.01-.004a.043.043 0 01-.017-.01.08.08 0 01-.02-.066l.557-3.403 2.61 2.61-2.715 1.155a.06.06 0 01-.023.005h-.011a.076.076 0 01-.014-.012 1.234 1.234 0 00-.357-.275zm3.786-.207l2.79 2.79c.58.58.87.87.976 1.206.016.05.03.1.04.15l-6.67-2.824-.011-.005c-.027-.01-.058-.023-.058-.05 0-.027.032-.04.059-.051l.008-.004zm3.691 5.042c-.144.27-.424.552-.9 1.027l-3.146 3.146-4.07-.847-.021-.005c-.036-.005-.074-.012-.074-.044a1.23 1.23 0 00-.472-.86c-.016-.016-.012-.042-.007-.065l.001-.01.766-4.7.003-.015c.004-.036.01-.078.043-.078a1.246 1.246 0 00.835-.479c.006-.007.01-.015.02-.02.023-.01.05 0 .074.01l6.948 2.94zm-4.77 4.897l-5.173 5.174.885-5.444.001-.007a.1.1 0 01.005-.02c.007-.018.026-.025.044-.032l.008-.004c.194-.083.366-.21.5-.372.018-.02.039-.04.066-.043a.067.067 0 01.02 0l3.644.748zm-6.269 6.269l-.583.583-6.447-9.318a.313.313 0 00-.008-.01c-.01-.014-.02-.028-.018-.044 0-.011.008-.021.015-.03l.008-.01c.02-.028.036-.057.054-.088l.014-.025.002-.002c.01-.017.02-.034.037-.043.015-.007.036-.005.053-.001l7.143 1.473c.02.003.038.011.054.024.01.01.012.02.014.03a1.266 1.266 0 00.74.847c.02.01.012.032.002.056a.187.187 0 00-.01.032l-1.07 6.526zm-1.218 1.217c-.43.426-.683.651-.97.742a1.44 1.44 0 01-.868 0c-.336-.107-.626-.396-1.205-.976l-6.475-6.475 1.691-2.623a.108.108 0 01.029-.034c.018-.013.044-.007.065 0 .389.117.805.096 1.18-.06.02-.007.039-.012.054.001a.138.138 0 01.02.024l6.48 9.402zM5.261 19.661l-1.485-1.485 2.933-1.251a.06.06 0 01.024-.005c.025 0 .039.024.052.046.03.046.06.09.094.133l.009.011c.009.013.003.025-.006.036l-1.62 2.515zM3.12 17.52l-1.88-1.88c-.32-.32-.551-.551-.712-.75l5.714 1.185a.397.397 0 00.021.003c.036.006.074.012.074.045 0 .037-.042.053-.078.067l-.017.007zm-2.92-3.597a1.44 1.44 0 01.064-.356c.107-.336.396-.625.977-1.205l2.404-2.405c1.108 1.607 2.218 3.212 3.331 4.814.02.026.041.055.019.077-.105.116-.21.242-.285.38a.115.115 0 01-.036.045c-.009.005-.02.003-.03 0h-.001l-6.444-1.35zm4.089-4.61l3.234-3.233c.303.133 1.41.6 2.399 1.018.748.316 1.43.604 1.646.698.021.009.04.017.05.039.006.013.003.03 0 .043a1.441 1.441 0 00.377 1.316c.021.022 0 .053-.02.08l-.01.015-3.283 5.085a.1.1 0 01-.03.036c-.018.01-.042.006-.062 0a1.643 1.643 0 00-.391-.053 2.15 2.15 0 00-.376.046c-.015.002-.028.005-.04-.004a.151.151 0 01-.032-.037zm3.887-3.887L12.36 1.24c.58-.58.87-.87 1.205-.975.283-.09.586-.09.868 0 .336.106.626.396 1.206.975l.907.908-2.977 4.61a.11.11 0 01-.03.035c-.018.012-.043.007-.065 0a1.51 1.51 0 00-1.382.266c-.02.02-.048.01-.073-.002-.389-.169-3.413-1.447-3.845-1.63zm9.004-2.646l2.749 2.749-.662 4.102v.011c-.001.01-.003.019-.006.027-.008.015-.022.018-.036.022a1.318 1.318 0 00-.41.209c-.007.008-.015.016-.028.018a.082.082 0 01-.031-.005l-4.189-1.78-.008-.004c-.027-.01-.058-.023-.058-.05a1.583 1.583 0 00-.223-.66c-.02-.033-.043-.067-.026-.101zm-2.831 6.196l3.927 1.663c.021.01.045.02.055.042a.077.077 0 010 .041.97.97 0 00-.022.19v.11c0 .027-.028.039-.054.05l-.008.002c-.622.266-8.734 3.725-8.746 3.725s-.025 0-.037-.012c-.022-.022 0-.052.02-.08a.898.898 0 00.01-.014l3.226-4.997.006-.009c.019-.03.04-.064.075-.064l.032.005c.074.01.139.02.204.02.49 0 .943-.238 1.217-.646a.114.114 0 01.024-.029c.02-.014.049-.007.07.003zM9.85 15.588l8.841-3.77s.013 0 .026.012c.048.048.089.08.128.11l.02.013c.018.01.036.022.037.04l-.001.018-.758 4.653-.002.019c-.005.036-.01.077-.044.077a1.244 1.244 0 00-.989.61l-.003.005c-.01.017-.02.033-.036.041-.016.008-.035.005-.05.001l-7.052-1.454c-.007-.002-.11-.374-.117-.375z",
    fill: "#fff"
  })));
}

/* harmony default export */ var netlify = (SvgNetlify);
;// CONCATENATED MODULE: ./src/svg/icons/webhooks-2.svg
var webhooks_2_path;

function webhooks_2_extends() { webhooks_2_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return webhooks_2_extends.apply(this, arguments); }



function SvgWebhooks2(props) {
  return /*#__PURE__*/react.createElement("svg", webhooks_2_extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), webhooks_2_path || (webhooks_2_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.365 5.793a1.199 1.199 0 012.083.014l3.183 5.69a5.993 5.993 0 11-.917 11.079l-.241-.129 1.171-2.09a3.596 3.596 0 10.15-6.35l-.185.1-.02-.034-.964.539-4.268-7.635a1.198 1.198 0 01.008-1.184zm-8.922 6.875l1.581 1.801a3.595 3.595 0 105.956 2.979l.01-.216.018-.001.001-1.25h8.386a1.198 1.198 0 110 2.397h-6.13A5.992 5.992 0 112.243 12.85zM12.403.4a5.993 5.993 0 015.987 5.732l.005.26h-2.397a3.596 3.596 0 10-5.537 3.027l.104.062 1.148.64-4.256 7.641h-.001l-.008.016c-.307.533-.961.74-1.512.502l-.125-.063a1.198 1.198 0 01-.439-1.637l-.009.016 3.145-5.649A5.993 5.993 0 0112.403.4z",
    fill: "#fff"
  })));
}

/* harmony default export */ var webhooks_2 = (SvgWebhooks2);
;// CONCATENATED MODULE: ./src/svg/icons/google-drive.svg
var google_drive_path, google_drive_path2, google_drive_path3, _path4;

function google_drive_extends() { google_drive_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return google_drive_extends.apply(this, arguments); }



function SvgGoogleDrive(props) {
  return /*#__PURE__*/react.createElement("svg", google_drive_extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 29 24",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), google_drive_path || (google_drive_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.153 6.392l2.504-2.503.167-1.054C17.262-1.314 10.01-.843 5.897 3.816 4.755 5.11 3.907 6.723 3.456 8.389l.896-.126 5.007-.826.387-.395c2.227-2.446 5.992-2.775 8.564-.694z",
    fill: "#ea4335"
  })), google_drive_path2 || (google_drive_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M25.223 8.316a11.278 11.278 0 00-3.4-5.482L18.31 6.348a6.245 6.245 0 012.293 4.954v.624c1.727 0 3.127 1.4 3.127 3.127 0 1.727-1.4 3.092-3.127 3.092H14.34l-.615.668v3.75l.615.589h6.263c4.492.035 8.162-3.543 8.197-8.035a8.134 8.134 0 00-3.577-6.801z",
    fill: "#4285f4"
  })), google_drive_path3 || (google_drive_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M8.085 23.152h6.255v-5.007H8.085a3.07 3.07 0 01-1.282-.28l-.887.272-2.521 2.503-.22.852c1.414 1.068 3.139 1.668 4.91 1.66z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M8.085 6.91a8.134 8.134 0 00-4.91 14.582l3.628-3.628a3.127 3.127 0 114.137-4.137l3.628-3.628a8.125 8.125 0 00-6.483-3.188z",
    fill: "#fbbc05"
  })));
}

/* harmony default export */ var google_drive = (SvgGoogleDrive);
;// CONCATENATED MODULE: ./src/svg/icons/spotify.svg
var spotify_path;

function spotify_extends() { spotify_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return spotify_extends.apply(this, arguments); }



function SvgSpotify(props) {
  return /*#__PURE__*/react.createElement("svg", spotify_extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 29 29",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), spotify_path || (spotify_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.4 0C6.447 0 0 6.447 0 14.4s6.447 14.4 14.4 14.4c7.954 0 14.4-6.447 14.4-14.4C28.8 6.448 22.355 0 14.4 0zm6.604 20.77a.897.897 0 01-1.235.297C16.39 19 12.133 18.534 7.12 19.678a.898.898 0 01-.399-1.75c5.486-1.254 10.19-.714 13.987 1.605.423.26.557.812.297 1.235zm1.763-3.922a1.123 1.123 0 01-1.544.37c-3.871-2.38-9.772-3.068-14.35-1.678a1.124 1.124 0 01-1.401-.748 1.124 1.124 0 01.749-1.4c5.23-1.587 11.73-.819 16.176 1.913.528.325.695 1.016.37 1.543zm.151-4.083C18.277 10.01 10.62 9.755 6.188 11.1a1.347 1.347 0 11-.781-2.578c5.086-1.544 13.542-1.246 18.886 1.927.641.38.85 1.206.47 1.845a1.346 1.346 0 01-1.844.471z",
    fill: "#fff"
  })));
}

/* harmony default export */ var spotify = (SvgSpotify);
// EXTERNAL MODULE: ./src/svg/icons/arrow.svg
var arrow = __webpack_require__(9803);
;// CONCATENATED MODULE: ./src/components/icons/Oracle.tsx

function Oracle() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "129",
                height: "18",
                viewBox: "0 0 129 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Oracle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M55.69 11.178h8.524l-4.507-7.252-8.272 13.111H47.67L57.732 1.288a2.378 2.378 0 011.975-1.02c.782 0 1.511.37 1.936.994l10.101 15.775H67.98l-1.777-2.93h-8.63l-1.883-2.93zm39.108 2.93V.425h-3.195v15.02c0 .411.159.81.464 1.114.305.305.716.477 1.166.477h14.569l1.883-2.93H94.797zm-52.855-2.453c3.102 0 5.621-2.506 5.621-5.608a5.624 5.624 0 00-5.621-5.62H27.966v16.61h3.194V3.358h10.571a2.682 2.682 0 012.678 2.69A2.682 2.682 0 0141.73 8.74l-9.007-.013 9.537 8.312h4.64l-6.416-5.383h1.458zM8.307 17.037C3.72 17.037 0 13.325 0 8.74 0 4.152 3.721.427 8.307.427h9.655c4.586 0 8.305 3.725 8.305 8.312 0 4.586-3.719 8.298-8.305 8.298H8.307zm9.44-2.93a5.37 5.37 0 005.377-5.369 5.38 5.38 0 00-5.377-5.382H8.521A5.382 5.382 0 003.143 8.74a5.37 5.37 0 005.377 5.368h9.227zm60.665 2.93c-4.586 0-8.312-3.712-8.312-8.298 0-4.587 3.726-8.312 8.312-8.312H89.88l-1.87 2.93h-9.386a5.386 5.386 0 00-5.382 5.382c0 2.969 2.413 5.368 5.382 5.368h11.52l-1.882 2.93h-9.85zm39.068-2.93a5.368 5.368 0 01-5.17-3.91h13.654l1.883-2.93H112.31a5.384 5.384 0 015.17-3.91h9.373l1.895-2.93h-11.48c-4.587 0-8.312 3.724-8.312 8.311s3.725 8.299 8.312 8.299h9.85l1.882-2.93h-11.52z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.508 30.017A10.465 10.465 0 013 19.509C3 13.67 7.67 9 13.508 9h12.314C31.66 9 36.33 13.67 36.33 19.509c0 5.838-4.67 10.508-10.508 10.508H13.508zm11.995-3.715a6.772 6.772 0 006.793-6.793 6.772 6.772 0 00-6.793-6.794H13.827a6.772 6.772 0 00-6.793 6.794c0 3.715 3.078 6.793 6.793 6.793h11.676z",
                    fill: "#9DA6C7"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Adobe.tsx

function Adobe() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "129",
                height: "32",
                viewBox: "0 0 129 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Adobe"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M48.915 30.925l1.759-8.174h6.153l1.714 8.174h4.088L56.343 1.3h-4.79L44.87 30.925h4.044zm6.066-18.549l1.362 7.078h-5.186l1.407-7.078c.394-1.89.835-4.614 1.142-6.768h.176c.307 2.11.703 4.746 1.099 6.768zm23.084 13.056V.51h-4.132v11.12h-.088c-.747-1.625-2.11-2.417-3.823-2.417-3.386 0-6.594 3.56-6.594 11.121 0 6.636 2.418 10.945 6.374 10.945 2.153 0 3.78-1.452 4.483-2.946h.132l.263 2.593h3.56a110.197 110.197 0 01-.175-5.494zm-4.176-9.056c.044.441.044.925.044 1.32v5.715c0 .482-.044 1.01-.132 1.362-.704 2.549-1.934 3.032-2.857 3.032-2.198 0-3.34-3.076-3.34-7.472 0-3.957.878-7.56 3.472-7.56 1.494 0 2.593 1.67 2.813 3.603zm6.677 3.914c0 7.34 3.078 10.988 7.341 10.988h.043c3.252 0 7.428-2.593 7.428-11.077 0-7.209-3.032-10.989-7.252-10.989-3.912 0-7.56 3.297-7.56 11.078zm10.593-.044c0 3.252-.572 7.78-3.12 7.78h-.044c-2.681 0-3.297-4.22-3.297-7.78 0-3.21.527-7.78 3.253-7.78 2.637 0 3.208 4.57 3.208 7.78zM102 .51h-4.13v24.92c0 1.628-.089 4.046-.177 5.495h3.56l.221-2.681h.174c.924 1.89 2.111 3.034 4.221 3.034 3.516 0 6.637-3.737 6.637-11.384 0-6.55-2.286-10.682-5.934-10.682-1.89 0-3.385.836-4.484 2.77H102V.51zm.176 24.174c-.132-.35-.176-.834-.176-1.32v-5.976c0-.439.044-1.01.131-1.45.308-1.539 1.407-3.165 2.77-3.165 2.462 0 3.428 3.297 3.428 7.384 0 4.396-.923 7.648-3.384 7.648-.835 0-2.11-.527-2.769-3.12zm21.349 3.252c-2.505 0-4.878-1.362-4.922-6.856l10.021.044c.043-.571.088-1.231.088-2.285 0-5.364-2.066-9.628-6.505-9.628-4.44 0-7.648 4.308-7.648 11.297 0 6.594 2.813 10.638 8.175 10.638 1.89 0 3.824-.352 5.099-1.012l-.615-2.989c-.924.44-2.198.791-3.693.791zM121.9 12.334c1.625 0 2.944 2.021 2.9 5.801h-6.153c.131-2.68 1.098-5.801 3.253-5.801zM33.928 1.379H21.586l12.342 29.546V1.38zM.54 1.38h12.351L.54 30.925V1.38zm24.563 29.546l-7.864-18.657-5.397 12.715h5.756l2.352 5.942h5.153z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#adobe_svg__clip0)",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: "#9DA6C7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M30.715 3.763h1.829l-.058.324h-.343c-.171 0-.285-.038-.285-.038v.59c0 .21-.057.42-.057.629 0 .21-.058.419-.058.533h-.456v-.533c0-.21.057-.42.057-.629 0-.228.056-.495.056-.59h-.457a.833.833 0 00-.228.038v-.324zm2.057 0h.628c0 .114.057.229.057.286 0 .095.114.266.172.476 0 .057.057.21.057.323.057.21.171.42.171.42 0-.115.114-.267.172-.476.056-.153.171-.381.228-.534.057-.171.171-.38.171-.495h.686v.648c0 .228-.057.533-.057.742v.648H34.6V4.848c0-.17.057-.323.057-.438v-.209l-.628 1.6h-.458c0-.114-.114-.323-.114-.476-.057-.267-.171-.476-.171-.533 0-.114-.114-.324-.172-.533v.533c0 .152-.057.362-.057.533v.476H32.6c0-.21.058-.476.058-.704 0-.19.056-.458.056-.686 0-.21.058-.42.058-.648zM10.793 36.198H9.574l-.476-1.714H6.851l-.476 1.714H5.194l2.076-7.58h1.333l2.19 7.58zm-2.038-2.952l-.8-2.857-.742 2.857h1.542zm6.419 2.952h-1.029v-.781c-.171.343-.4.572-.61.667-.209.114-.437.248-.666.248-.419 0-.838-.286-1.143-.763-.343-.437-.495-1.199-.495-2.094 0-.914.153-1.715.438-2.19.305-.457.743-.743 1.258-.743.4 0 .819.285 1.18.8v-2.724h1.067v7.58zm-2.895-2.857c0 .571.076 1.086.171 1.314.172.343.42.572.705.572.267 0 .476-.172.648-.381.17-.286.304-.762.304-1.333 0-.61-.095-1.124-.266-1.41-.153-.286-.42-.476-.686-.476-.228 0-.438.19-.628.42-.172.285-.248.723-.248 1.294zm3.77 0c0-.438.058-.914.23-1.352.19-.457.438-.8.742-1.029.324-.247.724-.418 1.105-.418.59 0 1.143.285 1.505.8.4.57.61 1.333.61 2.133s-.21 1.523-.61 2.038c-.42.533-.915.819-1.505.819-.362 0-.724-.134-1.067-.343-.342-.229-.59-.572-.78-.99-.172-.439-.229-1.01-.229-1.582v-.076zm1.067.133c0 .572.058 1.01.229 1.296.19.285.476.456.743.456.247 0 .533-.17.704-.456.19-.286.305-.724.305-1.296 0-.571-.114-1.047-.305-1.333-.17-.323-.457-.514-.704-.514-.267 0-.533.19-.686.476-.171.324-.286.8-.286 1.371zm3.962 2.724v-7.58h1.066v2.723c.305-.514.743-.8 1.162-.8.495 0 .914.286 1.238.743.324.476.514 1.2.514 2.133 0 .915-.19 1.715-.514 2.152-.343.477-.762.763-1.18.763-.23 0-.477-.134-.687-.248-.228-.095-.438-.381-.552-.667v.78h-1.047zm1.066-2.857c0 .571.096 1.086.19 1.314.172.343.458.572.763.572.266 0 .476-.172.628-.381.171-.229.266-.762.266-1.333 0-.61-.095-1.124-.266-1.41-.152-.286-.42-.476-.686-.476-.247 0-.457.19-.628.42-.171.285-.267.723-.267 1.294zm6.152 1.143l1.067.171c-.115.572-.381 1.048-.648 1.257-.304.23-.724.42-1.162.42a1.756 1.756 0 01-1.543-.915c-.266-.476-.38-1.142-.38-1.904 0-.895.152-1.657.494-2.171.343-.515.838-.8 1.372-.8.59 0 1.066.285 1.39.8.362.57.572 1.428.572 2.514h-2.761c0 .476.057.8.247 1.047.171.229.381.324.61.324.19 0 .362-.038.438-.172.094-.114.21-.342.304-.571zm.096-1.524c0-.4-.153-.761-.267-.971-.153-.23-.381-.362-.59-.362-.249 0-.477.19-.59.42-.191.228-.249.57-.249.913h1.695zM5.003 3h9.142L5.003 25.265V3zm15.37 0h9.256v21.978L20.373 3zm-3.01 8.513l5.048 13.351h-3.124l-2.152-4.227h-3.428l3.656-9.124z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "adobe_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(5 3)",
                                d: "M0 0h30.117v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/ActiveCampaign.tsx

function ActiveCampaign() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "191",
                height: "21",
                viewBox: "0 0 191 21",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ActiveCampaign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M143.291 0.887072C143.98 0.887072 144.126 1.30029 144.126 1.64772V2.92683H142.809C142.15 2.92683 142.012 2.53335 142.012 2.20326V0.888268H143.291V0.887072ZM143.18 5.07782C143.726 5.07782 144.014 5.35289 144.014 5.87494V16.6113H142.827V16.5695C142.402 16.5312 142.123 16.2226 142.123 15.7771V5.07782H143.18ZM80.3495 13.4491C80.7562 13.8181 80.8728 13.9718 80.8769 13.9784L80.9242 14.0412L80.8704 14.098C79.0393 16.0157 77.2005 16.8338 74.7212 16.8338C70.2709 16.8338 66.9144 13.3822 66.9144 8.80512C66.9144 4.28189 70.36 0.73877 74.7583 0.73877C77.7769 0.73877 79.4424 1.92758 80.7926 3.21207L80.8584 3.27427L80.7974 3.34124C80.7944 3.34483 80.4584 3.71798 80.1271 4.04927C79.7503 4.46846 79.2384 4.36561 78.9251 4.09113C77.6466 3.01832 76.3107 2.5184 74.7212 2.5184C71.391 2.5184 68.88 5.18964 68.88 8.73037C68.88 12.2549 71.446 15.0165 74.7212 15.0165C76.3717 15.0165 77.6119 14.55 79.001 13.4061C79.3431 13.1023 79.9178 13.0174 80.3495 13.4491ZM108.542 4.78121C111.207 4.78121 112.862 6.56443 112.862 9.4354V16.5372H111.879C111.112 16.5372 111.008 16.0588 111.008 15.5912V9.80616C111.008 7.69643 109.974 6.48729 108.171 6.48729C106.648 6.48729 105.111 7.54753 105.111 9.91739V16.5372H104.092C103.553 16.5372 103.257 16.2406 103.257 15.7024V9.76908C103.257 7.71378 102.197 6.48729 100.421 6.48729C98.6475 6.48729 97.3613 7.9452 97.3613 9.95446V15.7024C97.3613 16.3691 97.0688 16.5001 96.5635 16.5001H95.5069V4.96659H96.5265C97.0802 4.96659 97.3977 5.28353 97.3977 5.83787V6.65293C98.1093 5.65428 99.114 4.70766 100.977 4.70766C103.141 4.70766 104.175 6.0077 104.624 6.88017C105.627 5.46891 106.911 4.78121 108.541 4.78121H108.542ZM121.93 4.81829C124.599 4.81829 127.437 6.91725 127.437 10.8072C127.437 14.6978 124.599 16.7967 121.929 16.7967C120.209 16.7967 118.818 16.0702 117.684 14.577V20.0606H116.627C116.105 20.0606 115.829 19.7717 115.829 19.2258V5.04074H116.738C117.356 5.04074 117.683 5.35469 117.683 5.94909V7.1391C118.818 5.57774 120.21 4.81829 121.93 4.81829ZM125.508 10.8072C125.508 7.97091 123.54 6.48729 121.596 6.48729C119.618 6.48729 117.572 8.08932 117.572 10.7701C117.572 13.4743 119.617 15.0906 121.596 15.0906C123.9 15.0906 125.508 13.3295 125.508 10.8072ZM156.252 5.87554C156.252 5.31343 156.767 5.00367 157.123 5.00367H158.143V14.4789C158.143 18.0495 156.014 20.097 152.302 20.097C150.357 20.097 148.606 19.5547 147.093 18.4854L147.029 18.4394L147.065 18.3682C147.069 18.3593 147.181 18.1368 147.476 17.6566C147.634 17.3995 147.837 17.2799 148.062 17.2829C148.248 17.2877 148.454 17.3684 148.753 17.552C149.827 18.1512 151.036 18.4657 152.265 18.4657C154.822 18.4657 156.288 17.0257 156.288 14.516V13.4461C155.074 14.9262 153.645 15.6468 151.931 15.6468C149.298 15.6468 146.498 13.7422 146.498 10.2134C146.498 8.63947 147.096 7.21565 148.183 6.20504C149.182 5.27635 150.547 4.74354 151.931 4.74354C154.112 4.74354 155.467 5.84265 156.252 6.85446V5.87554ZM156.326 10.2881C156.326 7.81902 154.234 6.48669 152.266 6.48669C150.041 6.48669 148.426 8.07018 148.426 10.2511C148.426 12.4182 150.077 14.0519 152.266 14.0519C154.262 14.0519 156.326 12.6442 156.326 10.2881ZM166.877 4.81829C169.568 4.81829 171.308 6.63021 171.308 9.4348V16.5737H170.177C169.658 16.5737 169.417 16.3213 169.417 15.7771V9.84323C169.417 7.76461 168.273 6.52437 166.357 6.52437C164.403 6.52437 163.038 7.94998 163.038 9.99154L163.076 16.5737H161.184V5.04074H162.204C162.638 5.04074 163.075 5.28712 163.075 5.83787V6.81977C163.981 5.49103 165.258 4.81829 166.877 4.81829ZM134.39 4.89244C137.546 4.89244 139.304 6.53094 139.342 9.50836V16.5372H138.321C137.777 16.5372 137.524 16.2956 137.524 15.7771V14.9967C136.508 16.176 135.122 16.7967 133.5 16.7967C130.532 16.7967 129.179 14.9029 129.179 13.1436C129.179 10.8222 130.984 9.49102 134.131 9.49102H136.04V10.1398C136.04 10.6762 135.767 10.937 135.206 10.937H134.279C132.21 10.937 131.071 11.7078 131.071 13.1065C131.071 14.5973 132.503 15.276 133.834 15.276C135.972 15.276 137.523 14.0202 137.523 12.2908V9.54603C137.523 7.62049 136.358 6.56084 134.242 6.56084C133.288 6.56084 132.429 6.73067 131.457 7.111C131.104 7.2288 130.674 7.21864 130.521 6.83652C130.405 6.54043 130.293 6.24259 130.186 5.94311L130.158 5.86298L130.235 5.8271C131.659 5.18067 132.94 4.89244 134.39 4.89244ZM87.7001 4.89244C90.8551 4.89244 92.6138 6.53094 92.6515 9.50836V16.5372H91.6313C91.0871 16.5372 90.8336 16.2956 90.8336 15.7771V14.9967C89.8182 16.176 88.4326 16.7967 86.8102 16.7967C83.8418 16.7967 82.4897 14.9029 82.4897 13.1436C82.4897 10.8222 84.2945 9.49102 87.4411 9.49102H89.3368V10.1398C89.3368 10.6762 89.0635 10.937 88.5026 10.937H87.5888C85.5198 10.937 84.3812 11.7078 84.3812 13.1065C84.3812 14.5973 85.8134 15.276 87.1439 15.276C89.2824 15.276 90.8336 14.0202 90.8336 12.2908V9.54603C90.8336 7.62049 89.6681 6.56084 87.5518 6.56084C86.598 6.56084 85.7392 6.73067 84.7669 7.111C84.4117 7.23 83.9835 7.21864 83.8316 6.83652C83.7152 6.54053 83.6036 6.24269 83.4968 5.94311L83.4669 5.86179L83.5464 5.8271C84.6473 5.34153 85.9121 4.89244 87.7001 4.89244ZM190.37 9.17527C190.787 9.46829 191 9.83068 191 10.2511V10.4598C190.995 10.7845 190.879 11.2413 190.37 11.6235L190.368 11.6247C190.123 11.7999 187.627 13.5287 184.985 15.3597C182.401 17.1507 179.489 19.169 179.133 19.4207V19.7119L178.96 19.4213C178.952 19.4064 178.944 19.3938 178.953 19.3735H178.947V17.8534C178.947 17.3349 179.005 17.0855 179.582 16.701C180.064 16.3913 187.693 11.1008 188.706 10.4C187.701 9.70211 180.17 4.47384 179.654 4.09591L179.593 4.05166C179.211 3.77538 178.911 3.55772 178.911 2.98244V1.17291L179.056 1.27457C179.506 1.58792 190.075 8.95461 190.37 9.17527ZM183.764 11.2216C183.502 11.2216 183.243 11.1307 182.971 10.9495C182.311 10.5088 178.924 8.1539 178.89 8.12998L178.851 8.10247V6.94117C178.851 6.67446 178.965 6.46337 179.167 6.36111C179.383 6.25108 179.652 6.28696 179.888 6.45799C180.398 6.78569 185.325 10.205 185.375 10.2403L185.486 10.3174L185.373 10.3934C185.373 10.3934 185.04 10.6152 184.67 10.8736C184.354 11.1056 184.058 11.2216 183.764 11.2216ZM26.4648 13.9305C26.8266 14.2923 27.012 14.4418 27.0138 14.4436L27.0885 14.5034L27.0264 14.5764C26.1252 15.627 24.7809 16.8338 22.3572 16.8338C19.0958 16.8338 16.4419 14.147 16.4419 10.8443C16.4419 7.46501 19.0401 4.81829 22.3572 4.81829C24.2212 4.81829 25.6378 5.44499 26.9498 6.85027L27.0072 6.91246L26.9504 6.97525C26.7441 7.20369 26.533 7.42793 26.3165 7.6468C25.953 8.00919 25.5714 7.98826 25.0787 7.57803C24.4137 7.03864 23.564 6.48669 22.3201 6.48669C20.1058 6.48669 18.3704 8.38473 18.3704 10.8072C18.3704 13.2303 20.1542 15.1283 22.4308 15.1283C23.4814 15.1283 24.446 14.7366 25.2987 13.9652C25.5493 13.7643 26.0702 13.5358 26.4648 13.9311V13.9305ZM38.7859 0.88767C39.293 0.88767 39.6201 1.22972 39.6201 1.75955V2.92743H38.3039C37.6449 2.92743 37.5062 2.53395 37.5062 2.20386V0.888268H38.7859V0.88767ZM38.6376 5.07841C39.1836 5.07841 39.4718 5.35349 39.4718 5.87554V16.6119H38.2854V16.5701C37.8596 16.5318 37.5804 16.2232 37.5804 15.7777V5.07782H38.6376V5.07841ZM50.8271 5.69016C51.0095 5.25243 51.3408 5.04014 51.8395 5.04014H53.1312L53.0744 5.16991C53.0289 5.27396 48.5476 15.5589 48.364 15.9625C48.1696 16.3907 47.8892 16.5737 47.4269 16.5737H47.2039C46.7267 16.5737 46.4301 16.4822 46.2286 15.9978C46.0462 15.5959 41.5642 5.23688 41.5193 5.13223L41.4631 5.00247H42.7907C43.2972 5.00247 43.6506 5.23449 43.8408 5.69016C43.9753 6.09381 46.7853 12.9115 47.3151 14.1978C47.8461 12.9121 50.6603 6.09082 50.8271 5.69016ZM62.4462 10.1213C62.5538 10.1213 62.6333 10.0926 62.6794 10.0358C62.744 9.95984 62.7595 9.82171 62.7254 9.63633C62.5723 7.72633 61.1934 6.44902 59.2935 6.44902C57.4087 6.44902 55.937 8.00081 55.7145 10.2224C55.7139 10.2289 55.6781 10.4849 55.6781 10.8437C55.6781 11.1666 55.7139 11.4219 55.7139 11.4243C55.9507 13.6847 57.5229 15.2013 59.6272 15.2013C60.8489 15.2013 61.8476 14.8335 62.68 14.0758C62.9012 13.8546 63.3216 13.7176 63.7647 14.0717C64.0637 14.3336 64.3233 14.556 64.3233 14.556L64.3962 14.6182L64.3316 14.6888C62.9796 16.1718 61.5175 16.8332 59.5901 16.8332C56.303 16.8332 53.8237 14.2421 53.8237 10.8072C53.8237 7.37113 56.2073 4.78061 59.3677 4.78061C62.253 4.78061 64.3765 6.73606 64.6522 9.64829C64.6982 10.2708 64.5577 10.7767 64.2455 11.1128C63.9429 11.4387 63.4873 11.6043 62.8911 11.6043C61.8769 11.6043 59.4287 11.6079 57.3202 11.6414L57.2263 11.6426V10.9178C57.2263 10.4191 57.5241 10.1207 58.0234 10.1207H62.4462V10.1213ZM9.12779 1.45935C9.34785 1.93655 15.8122 16.298 15.8779 16.4427L15.9366 16.5737H14.8291C14.5935 16.5737 13.8771 16.5737 13.5948 15.9631C13.3903 15.5188 8.66135 4.7854 7.96768 3.21088L4.58781 10.7887H9.59063V11.6235C9.59063 12.167 9.19596 12.5318 8.60813 12.5318H3.83733C3.65733 12.9289 2.54566 15.3729 2.34115 15.8154C2.05411 16.3488 1.71923 16.5743 1.21871 16.5743H0L0.0586034 16.4427C0.124383 16.2968 6.66166 1.75416 6.80817 1.42407C7.01148 1.0569 7.33859 0.849996 7.70875 0.849996H8.15365C8.65417 0.849996 8.89935 1.00368 9.12659 1.45756L9.12779 1.45995V1.45935ZM34.8296 14.9411C34.9342 15.0189 35.0586 15.1755 35.0586 15.4793C35.0586 15.8878 35.0227 16.2173 35.0215 16.2316L35.0156 16.2812L34.9707 16.304C34.3823 16.5988 33.4416 16.7961 32.6296 16.7961C30.5133 16.7961 29.3478 15.63 29.3478 13.5137V0.924148H30.2567C30.8308 0.924148 31.2016 1.2662 31.2016 1.79602V5.07782H33.8166C34.2896 5.07782 34.7991 5.3505 34.7991 5.94909V6.74622H31.2022L31.2392 13.2548C31.2392 14.4484 31.8444 15.0536 33.0374 15.0536C33.4291 15.0536 33.7101 14.9848 34.1257 14.8718C34.4008 14.7892 34.658 14.8144 34.8296 14.9417V14.9411Z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "40",
                height: "40",
                fill: "#9DA6C7",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 288 288",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Layer_1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M146.6 150.7c2.6 0 5.2-1 8-3.1 3.3-2.3 6.2-4.2 6.2-4.2l1-.7-1-.7c-.4-.3-43.9-30.5-48.4-33.4-2.1-1.5-4.5-1.8-6.4-.9-1.8.9-2.8 2.8-2.8 5.1v10.3l.4.2c.3.2 30.2 21 36 24.9 2.4 1.7 4.7 2.5 7 2.5z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M204.9 132.6c-2.6-1.9-95.9-67-99.9-69.8l-1.3-.9v16c0 5.1 2.7 7 6 9.4 0 0 71.6 49.9 80.5 56-8.9 6.2-76.3 52.9-80.6 55.6-5.1 3.4-5.6 5.6-5.6 10.2v17.2s98.7-70.6 100.8-72.2c4.5-3.4 5.5-7.4 5.6-10.3V142c.1-3.6-1.8-6.8-5.5-9.4z"
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/AWS.tsx

function AWS() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 70 42",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-10 w-10 md:h-[42px] md:w-[70px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Amazon Web Services"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.727 15.203c0 .861.093 1.56.256 2.072.186.512.42 1.07.745 1.676.116.186.163.372.163.535 0 .233-.14.466-.442.699l-1.467.978c-.21.14-.42.21-.605.21-.233 0-.466-.117-.699-.327a7.204 7.204 0 01-.838-1.094 18.027 18.027 0 01-.722-1.374c-1.816 2.142-4.097 3.213-6.844 3.213-1.956 0-3.516-.558-4.657-1.676-1.14-1.117-1.722-2.607-1.722-4.47 0-1.979.698-3.585 2.118-4.796 1.42-1.21 3.306-1.816 5.704-1.816.792 0 1.606.07 2.468.186.861.117 1.746.303 2.677.513v-1.7c0-1.77-.372-3.003-1.094-3.725-.745-.722-2.002-1.07-3.795-1.07-.815 0-1.653.092-2.514.302-.862.21-1.7.465-2.515.791a6.68 6.68 0 01-.814.303c-.163.047-.28.07-.373.07-.326 0-.489-.233-.489-.722v-1.14c0-.373.047-.653.163-.816.117-.162.326-.325.652-.488.815-.42 1.793-.769 2.933-1.048C9.157.186 10.368.047 11.648.047c2.77 0 4.796.628 6.1 1.885C19.028 3.19 19.68 5.1 19.68 7.66v7.543h.047zm-9.452 3.538c.768 0 1.56-.14 2.398-.419.838-.279 1.583-.791 2.211-1.49.373-.442.652-.93.792-1.49.14-.558.233-1.234.233-2.025v-.978a19.432 19.432 0 00-2.142-.396 17.547 17.547 0 00-2.188-.14c-1.56 0-2.701.303-3.47.932-.768.629-1.14 1.513-1.14 2.677 0 1.094.28 1.91.861 2.468.559.582 1.374.861 2.445.861zm18.695 2.515c-.42 0-.699-.07-.885-.233-.186-.14-.35-.466-.489-.908L22.125 2.12c-.14-.466-.21-.769-.21-.932 0-.372.187-.582.56-.582h2.28c.443 0 .746.07.909.233.186.14.326.466.465.908l3.912 15.412 3.631-15.412c.117-.466.257-.768.443-.908s.512-.233.931-.233h1.862c.443 0 .745.07.932.233.186.14.349.466.442.908l3.679 15.599 4.027-15.599c.14-.466.303-.768.466-.908.186-.14.489-.233.908-.233h2.165c.373 0 .582.187.582.582 0 .117-.023.233-.047.373-.023.14-.07.326-.162.582l-5.611 17.996c-.14.466-.303.769-.49.908-.185.14-.488.233-.884.233h-2.002c-.442 0-.745-.07-.931-.233-.187-.163-.35-.465-.443-.93L35.931 5.098l-3.586 14.993c-.116.465-.256.768-.442.931-.186.163-.512.233-.931.233H28.97zm29.916.628c-1.21 0-2.421-.14-3.585-.419-1.164-.279-2.072-.582-2.678-.93-.372-.21-.628-.443-.721-.653a1.643 1.643 0 01-.14-.652v-1.187c0-.489.186-.722.535-.722.14 0 .28.024.42.07.14.047.349.14.582.233.791.35 1.653.629 2.56.815.932.186 1.84.28 2.771.28 1.467 0 2.607-.257 3.4-.77.79-.511 1.21-1.256 1.21-2.21 0-.653-.21-1.188-.629-1.63-.419-.443-1.21-.839-2.351-1.211l-3.376-1.048c-1.7-.535-2.957-1.327-3.725-2.374C52.39 8.45 51.995 7.31 51.995 6.1c0-.978.21-1.84.628-2.585A5.986 5.986 0 0154.3 1.606c.698-.535 1.49-.93 2.42-1.21C57.653.116 58.63 0 59.655 0c.513 0 1.048.023 1.56.093.536.07 1.025.163 1.514.256.465.117.907.233 1.327.373.419.14.744.28.977.419.326.186.56.372.699.582.14.186.21.442.21.768v1.094c0 .49-.187.745-.536.745-.186 0-.489-.093-.885-.279-1.327-.605-2.817-.908-4.47-.908-1.327 0-2.374.21-3.096.652-.722.442-1.095 1.117-1.095 2.072 0 .652.233 1.21.699 1.653.466.442 1.327.885 2.56 1.28l3.307 1.048c1.676.535 2.887 1.28 3.609 2.235.721.954 1.07 2.049 1.07 3.26 0 1-.21 1.909-.605 2.7a6.261 6.261 0 01-1.7 2.049c-.721.582-1.583 1-2.584 1.303a11.069 11.069 0 01-3.329.49zM63.286 33.2c-7.66 5.656-18.788 8.66-28.357 8.66-13.41 0-25.493-4.96-34.619-13.2-.722-.653-.07-1.537.792-1.025 9.871 5.727 22.047 9.196 34.642 9.196 8.498 0 17.834-1.77 26.425-5.401 1.28-.582 2.374.838 1.117 1.77z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66.476 29.567c-.978-1.257-6.472-.605-8.963-.302-.745.093-.862-.56-.187-1.048 4.377-3.073 11.571-2.188 12.41-1.164.837 1.048-.234 8.241-4.331 11.687-.629.536-1.234.256-.955-.442.932-2.305 3.004-7.497 2.026-8.73z",
                fill: "#fff"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Salesforce.tsx

function Salesforce() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "72",
        height: "50",
        viewBox: "0 0 72 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Salesforce"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.09 1.6c-3.526 0-6.714 1.48-9.004 3.866A13.773 13.773 0 0019.121.046c-7.615 0-13.79 6.166-13.79 13.771 0 1.947.406 3.8 1.135 5.477A11.993 11.993 0 00.54 29.666c0 6.613 5.306 11.974 11.85 11.974.836 0 1.65-.087 2.436-.254 1.798 4.878 6.483 8.356 11.98 8.356 5.278 0 9.808-3.206 11.751-7.779a11.137 11.137 0 004.896 1.127c4.194 0 7.848-2.311 9.766-5.732.992.2 2.002.302 3.015.3 8.453 0 15.306-6.912 15.306-15.44 0-8.527-6.853-15.44-15.306-15.44-2.204 0-4.299.47-6.191 1.316C47.865 4.214 43.776 1.6 39.089 1.6zm3.764 15.939a3.541 3.541 0 00-.407-.097 3.223 3.223 0 00-.56-.043c-.744 0-1.33.21-1.742.625-.41.413-.688 1.041-.827 1.867l-.05.279h-.935s-.114-.004-.138.119l-.153.857c-.01.08.025.132.134.132h.91l-.923 5.15a6.385 6.385 0 01-.247 1.014c-.09.255-.178.447-.287.586-.105.134-.205.233-.377.29-.141.048-.305.07-.484.07-.1 0-.232-.016-.33-.036a.976.976 0 01-.222-.072s-.107-.04-.149.066l-.306.836c-.028.082.013.146.064.165.122.042.212.07.377.11.228.054.421.057.602.057.378 0 .724-.054 1.01-.157.288-.104.539-.285.761-.53.24-.265.39-.542.534-.921.143-.374.265-.84.362-1.382l.928-5.246h1.355s.114.004.138-.12l.153-.856c.01-.082-.024-.132-.134-.132h-1.316l.007-.04a5.44 5.44 0 01.21-.889c.065-.185.187-.335.289-.439a.863.863 0 01.345-.214c.13-.043.279-.063.442-.063.123 0 .245.014.337.034.128.027.177.041.21.051.135.04.154.001.18-.063l.314-.864c.033-.093-.047-.133-.075-.144zm-18.385 8.9c0 .069-.05.125-.119.125h-1.09c-.07 0-.118-.056-.118-.125v-8.783c0-.068.048-.124.117-.124h1.091c.07 0 .119.056.119.124v8.783zm-13.645-.622c-.036.096-.001.13.02.15l.01.01c.107.078.214.137.322.198l.04.023.045.024c.724.385 1.407.497 2.122.497 1.457 0 2.361-.775 2.361-2.022v-.024c0-1.153-1.02-1.572-1.978-1.874l-.125-.04v-.001c-.723-.235-1.345-.437-1.345-.912v-.025c0-.407.364-.706.929-.706a4.2 4.2 0 011.85.473s.141.091.193-.045l.296-.797c.027-.077-.021-.134-.07-.164-.548-.333-1.304-.56-2.087-.56h-.146c-1.333 0-2.263.806-2.263 1.96v.024c0 1.217 1.026 1.611 1.988 1.886l.155.048h.002c.7.215 1.302.4 1.302.894v.024c0 .451-.392.787-1.025.787-.246 0-1.03-.005-1.876-.54a3.446 3.446 0 01-.146-.091 3.199 3.199 0 00-.095-.06c-.041-.026-.146-.072-.191.066l-.287.797zm21.322 0c-.037.096-.002.13.02.15a.147.147 0 01.01.01c.106.078.213.137.32.197l.085.049c.725.384 1.408.496 2.123.496 1.457 0 2.361-.775 2.361-2.022v-.024c0-1.153-1.02-1.572-1.978-1.874l-.125-.04v-.001c-.723-.235-1.345-.437-1.345-.912v-.025c0-.407.364-.706.929-.706a4.2 4.2 0 011.85.473s.141.091.193-.045l.296-.797c.027-.077-.021-.134-.07-.164-.548-.333-1.304-.56-2.087-.56h-.146c-1.333 0-2.263.806-2.263 1.96v.024c0 1.217 1.026 1.611 1.988 1.886l.155.048h.003c.7.216 1.302.401 1.302.894v.024c0 .451-.393.787-1.026.787-.246 0-1.03-.005-1.876-.54a4.071 4.071 0 01-.191-.12l-.049-.03c-.026-.018-.15-.066-.192.065l-.287.797zM46.7 23.374c0 .705-.131 1.26-.39 1.653-.256.388-.644.577-1.184.577-.54 0-.926-.188-1.178-.577-.255-.392-.384-.948-.384-1.653 0-.704.13-1.258.384-1.646.252-.385.637-.572 1.178-.572.54 0 .928.187 1.185.572.258.388.389.942.389 1.646zm1.216-1.306a2.927 2.927 0 00-.553-1.056 2.675 2.675 0 00-.934-.71c-.371-.173-.81-.261-1.303-.261-.493 0-.932.088-1.303.26a2.688 2.688 0 00-.935.71 2.974 2.974 0 00-.553 1.056c-.118.402-.178.84-.178 1.307 0 .466.06.906.178 1.307.12.402.305.758.554 1.056.248.297.563.535.934.704.372.169.81.255 1.303.255.493 0 .93-.086 1.303-.255a2.61 2.61 0 00.934-.704c.247-.297.434-.653.553-1.056.12-.402.179-.842.179-1.307 0-.465-.06-.905-.18-1.306zm9.983 3.348c-.04-.118-.155-.074-.155-.074-.177.068-.365.13-.565.162a4.402 4.402 0 01-.667.048c-.588 0-1.056-.175-1.39-.521-.336-.346-.524-.905-.522-1.662.002-.689.168-1.207.466-1.601.296-.392.748-.594 1.35-.594.5 0 .883.058 1.284.184 0 0 .096.042.141-.084l.096-.264v-.002c.065-.177.126-.345.203-.565.032-.092-.047-.132-.075-.143a4.744 4.744 0 00-.811-.204 6.092 6.092 0 00-.913-.062c-.51 0-.966.087-1.355.261a2.807 2.807 0 00-.979.71c-.26.297-.46.653-.592 1.055a4.204 4.204 0 00-.198 1.309c0 1.008.272 1.823.81 2.42.537.599 1.346.903 2.4.903.622 0 1.262-.126 1.72-.307 0 0 .089-.043.05-.145l-.298-.824zm2.127-2.717c.058-.392.166-.717.333-.971.252-.385.636-.597 1.176-.597.54 0 .897.213 1.153.597.17.254.244.594.273.97h-2.935zm4.093-.86a2.555 2.555 0 00-.527-.964c-.265-.285-.524-.484-.78-.595a3.009 3.009 0 00-1.18-.24c-.514 0-.98.087-1.358.265-.38.178-.698.42-.948.723-.25.301-.438.66-.557 1.068-.12.406-.181.848-.181 1.314 0 .474.063.916.187 1.314.125.4.326.753.597 1.045.27.295.618.525 1.034.686.414.16.917.243 1.494.242 1.189-.004 1.814-.27 2.072-.412.046-.025.09-.07.035-.197l-.27-.754c-.04-.112-.154-.07-.154-.07l-.08.03c-.292.112-.718.275-1.609.273-.638 0-1.112-.19-1.408-.483-.304-.302-.453-.745-.48-1.37l4.116.004s.108-.002.12-.107v-.01l.002-.009c.018-.133.121-.889-.125-1.754zm-37.051.86c.059-.392.166-.717.333-.971.252-.385.636-.597 1.176-.597.54 0 .897.213 1.154.597.169.254.243.594.272.97h-2.935zm4.092-.86a2.555 2.555 0 00-.526-.964c-.265-.285-.524-.484-.78-.595a3.008 3.008 0 00-1.18-.24c-.513 0-.98.087-1.358.265-.38.178-.698.42-.948.723-.25.301-.438.66-.557 1.068-.12.406-.181.848-.181 1.314 0 .474.063.916.187 1.314.125.4.326.753.597 1.045.27.295.618.525 1.034.686.414.16.917.243 1.494.242 1.188-.004 1.815-.27 2.072-.412.046-.025.09-.07.035-.197l-.268-.754c-.042-.112-.156-.07-.156-.07a4.174 4.174 0 00-.08.03c-.292.112-.718.275-1.61.273-.637 0-1.11-.19-1.407-.483-.304-.302-.453-.745-.48-1.37l4.116.004s.108-.002.12-.107l.002-.02c.018-.135.12-.889-.126-1.753zm-12.987 3.555c-.161-.129-.183-.161-.238-.244-.081-.127-.122-.307-.122-.535 0-.362.119-.622.367-.797-.003 0 .354-.309 1.193-.298.59.009 1.117.096 1.117.096v1.87s-.522.113-1.11.148c-.838.05-1.21-.242-1.207-.24zm1.637-2.892a9.164 9.164 0 00-.642-.02c-.353 0-.694.045-1.014.131-.321.086-.61.22-.86.399-.248.177-.452.41-.596.678-.146.271-.22.59-.22.949 0 .364.063.68.189.94.125.26.306.476.537.643.228.167.51.289.838.363.323.074.689.111 1.09.111.421 0 .842-.034 1.25-.104.403-.069.899-.169 1.036-.2.096-.024.193-.048.288-.074.102-.025.094-.135.094-.135L21.8 22.42c0-.825-.22-1.437-.654-1.817-.432-.378-1.068-.569-1.89-.569a6.78 6.78 0 00-1.103.102s-.899.174-1.269.463c0 0-.08.051-.036.164l.29.783c.037.101.135.067.135.067s.032-.012.068-.034c.792-.43 1.793-.417 1.793-.417.445 0 .787.089 1.018.266.224.172.339.432.339.98v.174c-.354-.05-.679-.08-.679-.08zm33.192-2.12a.11.11 0 00-.062-.148 3.57 3.57 0 00-.69-.119c-.516-.03-.803.056-1.06.171-.255.116-.538.302-.696.513v-.5c0-.07-.05-.126-.118-.126h-1.055c-.07 0-.119.056-.119.126v6.138c0 .068.057.125.126.125h1.081a.125.125 0 00.124-.125V23.37c0-.412.046-.822.137-1.08.089-.255.21-.46.36-.606.15-.146.322-.248.509-.305.19-.059.402-.078.552-.078.215 0 .452.055.452.055.079.01.123-.039.15-.11.07-.189.27-.752.31-.864z",
                fill: "#9DA6C7"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/SAP.tsx

function SAP() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "69",
            height: "35",
            viewBox: "0 0 69 35",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "SAP"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M34.687 34.894H0v-34h68.702l-34.015 34zm-.673-27.611l6.723.001c6.588 0 9.545 2.306 9.545 7.329 0 4.512-3.092 7.202-8.335 7.202H39.66v6.493h-9.949l-1.075-3.105a11.062 11.062 0 01-3.496.545c-1.344 0-2.554-.21-3.63-.57l-.941 3.13h-6.185l.673-1.806a.457.457 0 00-.137.104c-.033.033-.066.067-.132.103-1.48 1.234-3.496 1.913-5.781 1.956l-.404.003c-2.689 0-5.378-.756-7.663-2.041l2.15-4.148c2.286 1.335 3.63 1.635 5.513 1.6 1.076-.023 1.748-.205 2.286-.688a1.52 1.52 0 00.403-1.054c0-1.081-1.479-1.585-3.361-2.167-1.613-.472-3.227-1.116-4.706-2.105C1.747 16.892.941 15.418.941 13.341c0-1.51.672-2.872 1.613-3.945 1.479-1.542 3.899-2.472 6.857-2.472 2.42.003 5.378.703 7.663 1.811l-2.42 4.097c-2.42-1.154-3.63-1.266-4.974-1.334-2.017-.108-2.958.613-2.958 1.398-.135.947 1.882 1.812 3.63 2.401 2.823.877 6.319 2.048 6.857 5.436l5.109-13.45h5.78l5.916 16.082V7.283zM22.99 20.668a6.06 6.06 0 002.151.385c.807 0 1.479-.132 2.151-.363l-2.151-6.787-2.151 6.765zm16.671-3.506h1.479c2.017 0 3.63-.657 3.63-2.755 0-2.04-1.613-2.7-3.63-2.7h-1.479v5.455z",
                    fill: "#9DA6C7"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/DynamicYield.tsx

function DynamicYield() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "192",
                height: "35",
                viewBox: "0 0 192 35",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Dynamic Yield"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.635.686c-1.121.364-2.668 1.03-3.437 1.48-4.52 2.65-7.85 7.838-8.27 12.887l-.152 1.819h16.079V0l-1.09.013c-.6.007-2.009.31-3.13.673zm6.256 3.823v4.509h6.982c3.84 0 6.98-.082 6.98-.182 0-.488-2.77-3.975-3.855-4.853C26.245 1.758 22.244 0 19.93 0h-1.04v4.509zm30.834 4.845c0 3.097-.023 3.223-.52 2.774-.778-.705-2.538-1.366-3.615-1.359-1.325.009-3.161.902-4.066 1.977-1.284 1.526-1.784 3.261-1.628 5.65.21 3.2 1.427 5.184 3.788 6.17 1.878.785 4.368.393 5.813-.915.486-.44.52-.42.52.302 0 .75.05.773 1.745.773h1.745V6.109h-3.782v3.245zm68.069-1.79v1.454H121.575V6.109H117.794v1.454zm36.361 0v1.454h3.491V6.109h-3.491v1.454zm18.908 7.853v9.309h3.49V6.109h-3.49v9.308zm14.544-6.063c0 3.097-.023 3.223-.52 2.774-.778-.705-2.538-1.366-3.616-1.359-2.234.015-4.724 2.006-5.422 4.335-.183.61-.331 1.944-.329 2.965.006 3.948 2.579 6.948 5.96 6.948 1.154 0 2.904-.646 3.698-1.366.487-.44.52-.42.52.302 0 .75.05.773 1.745.773h1.746V6.109h-3.782v3.245zm-113.156 1.72c-.4.167-1.087.648-1.527 1.069l-.8.765v-1.854h-3.491v13.672h3.742l.093-4.793c.084-4.382.144-4.843.692-5.39.33-.33 1.059-.674 1.621-.765.82-.133 1.192-.02 1.874.566l.85.732.103 4.825.103 4.825h3.431l-.001-5.31c0-5.827-.202-6.705-1.814-7.886-.92-.675-3.728-.938-4.876-.457zm11.627.117c-.725.234-1.677.8-2.115 1.257-.79.825-1.468 2.48-1.146 2.802.092.092.93.167 1.864.167 1.314 0 1.697-.098 1.697-.436 0-.884 1.106-1.6 2.472-1.6 1.427 0 2.473.723 2.473 1.71 0 .88-.651 1.191-3.448 1.644-3.112.503-4.435 1.07-5.09 2.178-.647 1.096-.61 3.123.078 4.252 1.154 1.893 5.076 2.413 7.483.993 1.027-.606 1.028-.606 1.182-.02.133.509.393.588 1.938.588h1.784l-.088-5.309c-.101-6.075-.337-6.932-2.164-7.863-1.46-.744-5.142-.937-6.92-.363zm15.571.03c-.48.25-1.167.729-1.527 1.066l-.654.614v-1.847h-3.491v13.672H99.758v-4.378c0-5.646.322-6.385 2.771-6.385 1.694 0 1.884.607 1.884 6.028v4.735H108.194v-4.638c0-4.408.033-4.677.663-5.409.901-1.047 2.662-1.13 3.447-.161.483.596.545 1.214.545 5.44v4.768H116.63l-.006-5.164c-.006-4.442-.084-5.333-.559-6.38-.724-1.594-1.946-2.24-4.276-2.259-1.604-.013-1.912.086-3.005.963l-1.217.977-.452-.644c-.954-1.363-3.775-1.878-5.466-.998zm25.38-.043c-2.95 1.053-4.426 3.346-4.413 6.857.009 2.58.662 4.096 2.369 5.506 1.413 1.168 2.965 1.577 5.279 1.393 2.307-.183 3.959-1.23 4.91-3.11 1.056-2.087.945-2.334-1.055-2.334-1.631 0-1.727.04-2.076.884-.498 1.201-1.35 1.734-2.773 1.734-1.391 0-2.306-.781-2.757-2.352-.864-3.014.537-6.084 2.777-6.084 1.359 0 2.064.394 2.616 1.463.421.815.549.864 2.216.864h1.77l-.197-.8c-.845-3.428-4.967-5.341-8.666-4.021zm35.853.172c-2.778 1.296-4.162 3.406-4.196 6.394-.055 4.762 2.998 7.62 7.686 7.195 2.04-.185 3.497-.988 4.519-2.492 1.112-1.638.978-2.085-.626-2.085-1.078 0-1.54.173-2.337.873-.792.695-1.263.873-2.312.873-.725 0-1.582-.142-1.905-.315-.542-.29-1.411-1.882-1.411-2.585 0-.194 1.697-.3 4.809-.3 3.855 0 4.839-.081 4.965-.408.284-.742-.456-3.767-1.197-4.886-1.69-2.555-5.227-3.557-7.995-2.264zm-143.99 6.976v7.272h13.703l.699-1.527c1.258-2.748 1.683-5.026 1.509-8.072-.087-1.52-.322-3.254-.52-3.854l-.363-1.091H18.89v7.272zm35.268-6.923c5.7 14.938 5.626 14.562 2.905 14.72l-1.522.088v3.169h1.755c2.08 0 3.544-.544 4.213-1.566.464-.709 5.765-14.577 6.135-16.052.174-.695.143-.708-1.684-.708h-1.863l-1.416 4.51c-.778 2.481-1.492 4.434-1.587 4.341-.094-.093-.826-2.09-1.626-4.438L58.016 11.2l-2-.087c-1.546-.067-1.968 0-1.856.291zm63.764.021c-.078.204-.107 3.248-.063 6.764l.078 6.392 1.818.087 1.818.086v-13.7h-1.754c-1.153 0-1.803.128-1.897.371zm21.824.139c1.677 4.264 4.808 12.883 4.808 13.237 0 .843-.858 1.38-2.203 1.38h-1.288v3.2h1.755c2.089 0 3.544-.545 4.224-1.583.472-.722 5.743-14.521 6.122-16.027.176-.705.151-.716-1.683-.716h-1.862l-1.418 4.518c-.78 2.485-1.512 4.415-1.626 4.29-.115-.125-.842-2.158-1.617-4.518l-1.407-4.29h-2.003c-1.789 0-1.981.054-1.802.509zm14.407 6.327v6.836h3.491V11.054h-3.491v6.836zM48.697 14.362c.679.679 1.316 2.387 1.316 3.528 0 1.14-.637 2.848-1.316 3.528-.82.82-2.565.935-3.563.236-1.878-1.316-2.215-5.13-.614-6.954.779-.887 1.08-1.028 2.194-1.028.972 0 1.464.17 1.983.69zm118.706.024c.393.393.715 1.047.715 1.454v.74h-2.747c-1.51 0-2.821-.12-2.912-.268-.092-.148-.009-.616.184-1.039.754-1.655 3.484-2.164 4.76-.887zm19.175-.024c.68.679 1.317 2.387 1.317 3.528 0 1.14-.637 2.848-1.317 3.528-.958.958-2.697.944-3.858-.034-1.933-1.626-1.814-5.773.211-7.34.82-.634 2.874-.455 3.647.318zm-95.255 4.96c0 .96-.192 1.514-.753 2.181-.65.773-.946.895-2.161.895-1.64 0-2.322-.516-2.322-1.759 0-1.061.81-1.616 2.763-1.89.8-.113 1.651-.315 1.891-.45.24-.136.47-.25.509-.255.04-.005.073.57.073 1.278zm-90.317.531c.78 3.76 2.635 7.103 5.284 9.524C9.206 32.042 9 32.36 9 25.172v-6.264H.81l.196.945zm10.099 5.952l.078 6.897 1.6.479c.88.264 2.156.565 2.836.67l1.236.19V18.908h-5.828l.078 6.897zm7.786 5.03c0 2.48.088 3.2.39 3.2 1.085 0 5.098-1.264 6.677-2.103.986-.523 2.582-1.7 3.545-2.615l1.751-1.662-6.181-.01-6.182-.01v3.2z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.172 30.957a6.654 6.654 0 004.78-2.462h-4.78v2.462zM.114 24.707a6.664 6.664 0 003.169 5.28v-5.28H.113zM6.364 17.649a6.667 6.667 0 00-6.25 6.25h6.25v-6.25zM12.707 21.273a6.668 6.668 0 00-5.535-3.624v3.624h5.535zM13.055 22.08H7.172v5.607h5.34s1.678-2.323.543-5.606zM8.46 9.101v2.475h-.01a1.46 1.46 0 00-.628-.55 1.945 1.945 0 00-.837-.187c-.363 0-.682.072-.956.215-.267.138-.5.332-.684.57a2.498 2.498 0 00-.412.818c-.093.312-.14.636-.139.961a3.55 3.55 0 00.14.995c.085.305.224.591.41.847.183.246.42.446.694.584.28.143.606.215.976.215.325 0 .617-.06.875-.177.259-.118.468-.311.627-.58h.02v.632h1.287V9.101H8.46zm-.005 4.922c-.034.18-.098.354-.19.512-.088.148-.211.27-.36.358-.149.09-.335.134-.558.134-.21 0-.39-.046-.54-.138a1.19 1.19 0 01-.373-.364 1.56 1.56 0 01-.215-.511 2.512 2.512 0 01-.067-.573c0-.198.02-.395.062-.588.038-.178.106-.348.201-.502a1.06 1.06 0 01.368-.354c.153-.089.341-.133.564-.133.223 0 .408.044.554.133.145.088.267.207.359.35.095.151.162.32.196.496a3.015 3.015 0 010 1.18zM12.477 17.409c-.261.172-.625.258-1.09.258a6.01 6.01 0 01-.416-.014 19.23 19.23 0 01-.415-.034v-1.118l.392.038c.133.013.267.016.401.01.178-.02.31-.09.397-.21a.678.678 0 00.129-.402.814.814 0 00-.058-.306l-1.73-4.636h1.444l1.118 3.384h.02l1.08-3.384h1.404l-2.064 5.554c-.147.401-.35.688-.612.86zM16.743 10.996v.656h.028c.082-.137.182-.263.298-.373.11-.104.237-.19.374-.255.133-.064.273-.113.417-.147.14-.033.284-.05.428-.05a3.06 3.06 0 01.497.038c.137.02.271.058.4.111.11.046.216.106.313.177.09.067.17.146.239.235.068.09.126.189.171.293.049.113.086.23.112.35.028.132.048.265.06.4.014.139.021.286.021.44v3.049h-1.389v-2.79a2.635 2.635 0 00-.047-.535 1.142 1.142 0 00-.144-.379.59.59 0 00-.265-.225 1.014 1.014 0 00-.413-.076 1.251 1.251 0 00-.477.083.757.757 0 00-.325.247c-.082.11-.145.255-.186.436a2.95 2.95 0 00-.062.649v2.59h-1.338v-4.924h1.287zM25.038 15.462a5.115 5.115 0 01-.038-.638v-2.562c0-.298-.067-.538-.2-.719a1.37 1.37 0 00-.514-.423 2.307 2.307 0 00-.695-.205c-.25-.035-.5-.052-.753-.052-.273 0-.546.027-.814.08-.256.05-.502.141-.728.272a1.622 1.622 0 00-.533.504c-.14.21-.22.473-.238.79h1.352c.025-.266.114-.456.266-.57.153-.115.362-.172.629-.172.113 0 .226.008.338.024a.75.75 0 01.276.095c.08.049.146.118.19.2a.717.717 0 01.072.348c.006.14-.035.246-.124.319a.913.913 0 01-.362.166 3.61 3.61 0 01-.523.086c-.197.019-.397.044-.6.076a5.748 5.748 0 00-.605.129c-.19.05-.37.131-.533.242-.16.113-.29.261-.381.434-.099.18-.148.41-.148.69 0 .254.043.473.129.657.081.179.203.335.357.457.158.124.34.215.533.267.214.059.435.087.657.086.304 0 .605-.045.895-.134.29-.087.552-.248.762-.466a2.004 2.004 0 00.095.476h1.372c-.064-.102-.108-.254-.134-.457zm-1.401-1.458c-.002.102-.01.205-.024.306a1.026 1.026 0 01-.13.377.896.896 0 01-.324.32c-.147.09-.354.135-.621.134-.106 0-.212-.009-.316-.028a.767.767 0 01-.268-.1.512.512 0 01-.181-.197.637.637 0 01-.067-.305c0-.128.022-.233.067-.316a.613.613 0 01.177-.205.893.893 0 01.258-.13c.098-.031.199-.057.3-.076.109-.019.217-.035.326-.048.108-.012.212-.028.31-.047.094-.018.187-.042.277-.072a.607.607 0 00.216-.12v.507zM26.692 10.996v.656h.019c.086-.122.185-.235.296-.337.106-.097.224-.181.35-.251.128-.07.265-.123.407-.157a2.18 2.18 0 01.91-.007c.141.03.279.075.41.135.128.06.244.145.34.25.104.114.188.245.249.386a1.89 1.89 0 01.26-.303 2.36 2.36 0 01.339-.266 1.46 1.46 0 01.413-.185 1.81 1.81 0 01.483-.062c.127 0 .253.008.378.024.119.015.236.039.35.071.108.03.213.072.312.123a1.27 1.27 0 01.477.421c.064.096.118.198.16.305.047.12.08.245.1.372.024.145.035.293.035.44v3.309H31.64v-2.807l-.009-.24a5.083 5.083 0 00-.014-.228 1.155 1.155 0 00-.036-.205.87.87 0 00-.07-.177.653.653 0 00-.451-.33 1.256 1.256 0 00-.517.004.688.688 0 00-.204.082.824.824 0 00-.362.476c-.023.069-.04.14-.05.212a2.99 2.99 0 00-.025.226 1.771 1.771 0 00-.004.228v2.759h-1.364v-2.778c-.004-.073-.005-.146-.007-.219a10.917 10.917 0 00-.007-.216 1.317 1.317 0 00-.081-.397.609.609 0 00-.447-.373 1.328 1.328 0 00-.286-.028.671.671 0 00-.111.01c-.042.008-.09.019-.142.033a.752.752 0 00-.156.062.948.948 0 00-.15.1.783.783 0 00-.138.146 1.042 1.042 0 00-.195.457 1.52 1.52 0 00-.022.33v2.873h-1.364v-4.924h1.262zM34.722 9.101H33.36v1.111h1.363v-1.11zM34.722 10.995H33.36v4.924h1.363v-4.924zM37.574 11.858c-.218 0-.4.05-.547.149-.147.099-.27.23-.36.383-.094.16-.16.336-.196.518a2.691 2.691 0 000 1.107c.035.177.098.347.187.504.085.149.205.276.35.369a.961.961 0 00.537.143c.326 0 .576-.09.752-.273.176-.182.287-.426.331-.733h1.314c-.09.658-.346 1.16-.767 1.505-.422.345-.962.518-1.62.518-.35.004-.696-.06-1.022-.187a2.262 2.262 0 01-1.299-1.323 2.774 2.774 0 01-.182-1.021 3.304 3.304 0 01.168-1.069c.104-.315.272-.606.494-.853.221-.243.493-.434.796-.56.313-.135.67-.202 1.073-.202.287-.001.573.037.849.115.261.072.508.19.728.35.214.156.392.355.523.585.134.233.21.51.23.829H38.58c-.09-.57-.425-.854-1.006-.854zM20.783 16.879h-1.389v1.11h1.389v-1.11zM16.391 25.187c-.261.172-.624.258-1.09.258-.14 0-.278-.005-.415-.015a19.88 19.88 0 01-.416-.033v-1.118l.392.038c.133.012.267.016.401.01.179-.02.31-.09.397-.21a.677.677 0 00.129-.402.815.815 0 00-.057-.306l-1.73-4.636h1.443l1.118 3.384h.02l1.08-3.384h1.405l-2.065 5.553c-.147.402-.35.689-.612.86zM20.783 18.773h-1.389v4.924h1.389v-4.924zM27.652 16.879h-1.364v6.818h1.364v-6.818zM25.433 19.56a2.174 2.174 0 00-.763-.65c-.31-.16-.672-.24-1.089-.24-.372 0-.712.066-1.018.198a2.366 2.366 0 00-1.302 1.364 2.854 2.854 0 00-.18 1.023c-.004.355.056.707.175 1.041.11.303.278.58.498.815.22.23.488.41.786.525.309.123.656.185 1.041.185.556 0 1.03-.126 1.42-.379.392-.252.683-.672.872-1.26h-1.184c-.044.152-.164.296-.36.432-.195.135-.429.203-.7.203-.38 0-.67-.098-.872-.293-.202-.196-.312-.512-.331-.947h3.532a3.46 3.46 0 00-.095-1.09 2.667 2.667 0 00-.43-.927zm-3.017 1.158c.009-.11.03-.22.062-.325a.998.998 0 01.525-.616c.144-.074.324-.11.54-.11.332 0 .579.089.741.267.163.179.276.44.34.784h-2.208zM31.641 16.904v2.475h-.01a1.47 1.47 0 00-.631-.554 1.957 1.957 0 00-.843-.188c-.366 0-.687.072-.963.217a2.066 2.066 0 00-.69.573 2.514 2.514 0 00-.413.824c-.094.314-.14.64-.14.968-.001.338.046.676.14 1.001.086.307.226.596.414.853.184.248.423.449.698.587.283.145.61.217.983.217.327 0 .621-.06.881-.178.26-.119.47-.313.63-.583h.02v.606h1.263v-6.818H31.64zm-.001 4.93c-.034.18-.099.354-.191.512-.088.148-.21.27-.359.358-.15.09-.336.134-.559.134-.21 0-.39-.046-.54-.139a1.188 1.188 0 01-.373-.363 1.56 1.56 0 01-.215-.511 2.51 2.51 0 01-.066-.573c-.001-.198.02-.395.062-.588.037-.178.105-.348.2-.502.092-.146.219-.267.368-.354.153-.089.341-.133.564-.133.223 0 .408.044.554.133.145.088.268.207.359.35.096.151.162.32.196.496a3.014 3.014 0 010 1.18zM4.091 24.707v5.727a6.62 6.62 0 002.273.548V24.707H4.09z",
                    fill: "#9DA6C7"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/GoogleAnalytics.tsx

function GoogleAnalytics() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "209",
                height: "33",
                viewBox: "0 0 209 33",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Google Analytics"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M125.494 11.736l2.913 7.647h-5.645l2.732-7.647zm-1.092-2.55l-6.374 16.753h2.368l1.639-4.553h7.101l1.639 4.553h2.368L126.77 9.186h-2.368zm34.413 16.753H161V9.186h-2.185V25.94zm-22.404-9.834c.729-1.093 2.185-2.003 3.642-2.003 2.913 0 4.371 2.003 4.371 4.917v7.101h-2.185v-6.737c0-2.368-1.274-3.277-2.913-3.277-1.821 0-3.096 1.82-3.096 3.46v6.373h-2.185V14.285h2.185l.182 1.82h-.001zm9.834 6.374c0-2.55 2.368-4.006 5.099-4.006 1.639 0 2.732.365 3.096.73v-.365c0-1.821-1.457-2.732-2.914-2.732-1.273 0-2.367.546-2.731 1.639l-1.998-.912c.365-1.092 1.821-2.731 4.742-2.731 2.732 0 5.099 1.639 5.099 4.916v6.92h-2.003V24.29h-.182c-.546.91-1.821 2.003-3.824 2.003-2.367 0-4.37-1.457-4.37-3.824l-.014.01zm8.208-1.466s-.91-.729-2.732-.729c-2.185 0-3.096 1.274-3.096 2.185 0 1.274 1.274 1.821 2.368 1.821 1.639 0 3.459-1.456 3.459-3.277",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M164.09 31.036l2.549-6.016-4.552-10.561h2.185l3.459 8.012 3.46-8.012h2.184l-7.1 16.577h-2.185zm32.046-12.745c-.547-1.458-1.821-2.368-3.095-2.368-1.821 0-3.459 1.64-3.459 4.006 0 2.367 1.639 4.006 3.459 4.006 1.274 0 2.55-.91 3.096-2.185l1.821 1.093c-.91 2.003-2.732 3.277-4.917 3.277-3.095 0-5.645-2.732-5.645-6.19 0-3.643 2.55-6.192 5.645-6.192 2.185 0 4.006 1.274 4.917 3.277l-1.821 1.274-.001.002z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M203.965 26.302c2.913 0 4.37-1.639 4.37-3.642 0-4.37-6.373-2.732-6.373-5.28 0-.91.729-1.456 2.003-1.456s2.549.546 3.096 1.457l1.274-1.274c-.729-.91-2.732-2.185-4.552-2.185-2.732 0-4.188 1.639-4.188 3.642 0 4.188 6.555 2.732 6.555 4.916 0 1.093-.729 1.822-2.185 1.822s-2.185-.91-2.913-1.822l-1.639 1.274c1.093 1.093 2.732 2.55 4.552 2.55v-.002zm-20.758-.364h2.185V14.285h-2.185v11.654-.001z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M184.119 8.64c.91 0 1.456.729 1.456 1.456 0 .91-.729 1.457-1.456 1.457-.728 0-1.457-.729-1.457-1.457 0-.727.729-1.456 1.457-1.456zm-3.095 15.478l.364 1.64h-2.185c-2.003 0-2.913-1.457-2.913-3.643V16.47h-2.185v-2.184h2.185v-3.46h2.185v3.46h2.549v2.184h-2.549v6.016c0 1.64 1.274 1.64 2.549 1.64v-.008z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M46.825 15.923v2.732h6.373c-.182 1.457-.729 2.55-1.456 3.277-.91.91-2.368 2.003-4.917 2.003-3.824 0-6.92-3.096-6.92-7.102 0-3.824 3.096-7.101 6.92-7.101 2.185 0 3.642.91 4.742 1.82l1.82-1.82C51.75 8.275 49.747 7 46.834 7 41.553 7 37 11.37 37 16.65c0 5.281 4.545 9.65 9.826 9.65 2.913 0 5.098-.91 6.737-2.731 1.821-1.821 2.368-4.188 2.368-6.191 0-.547 0-1.274-.182-1.64H46.83l-.006.185zm16.206-2.178c-3.46 0-6.192 2.55-6.192 6.192 0 3.642 2.732 6.19 6.192 6.19s6.191-2.731 6.191-6.19c0-3.642-2.732-6.192-6.191-6.192zm0 10.015c-1.821 0-3.46-1.64-3.46-3.824 0-2.185 1.64-3.824 3.46-3.824s3.46 1.457 3.46 3.824-1.64 3.824-3.46 3.824zm29.862-8.74c-.729-.73-1.82-1.457-3.46-1.457-3.095 0-5.826 2.732-5.826 6.191 0 3.46 2.732 6.19 5.827 6.19 1.456 0 2.732-.728 3.277-1.456h.181v.91c0 2.368-1.273 3.643-3.276 3.643-1.64 0-2.732-1.274-3.096-2.185l-2.367.91c.729 1.639 2.549 3.642 5.462 3.642 3.277 0 6.016-1.821 6.016-6.555V13.564h-2.55v1.457l-.188-.002zm-3.095 8.74c-1.822 0-3.277-1.64-3.277-3.824 0-2.185 1.456-3.824 3.277-3.824 1.82 0 3.276 1.64 3.276 3.824 0 2.185-1.456 3.824-3.276 3.824zM76.505 13.745c-3.46 0-6.192 2.55-6.192 6.192 0 3.642 2.732 6.19 6.192 6.19s6.191-2.731 6.191-6.19c.182-3.642-2.732-6.192-6.191-6.192zm0 10.015c-1.821 0-3.46-1.64-3.46-3.824 0-2.185 1.64-3.824 3.46-3.824s3.46 1.457 3.46 3.824-1.64 3.824-3.46 3.824zM97.627 7.183h2.732V26.12h-2.732V7.183zm10.197 16.57c-1.456 0-2.367-.729-3.095-1.821l8.376-3.46-.365-.729c-.546-1.456-2.184-4.005-5.279-4.005-3.277 0-5.827 2.549-5.827 6.191 0 3.46 2.732 6.19 6.191 6.19 2.913 0 4.552-1.82 5.28-2.731l-2.185-1.457c-.729 1.093-1.639 1.821-3.096 1.821v.001zm-.181-7.648c1.092 0 2.002.546 2.367 1.457l-5.645 2.367c0-2.732 1.821-3.824 3.277-3.824h.001zM20.625 3.938v24.75c0 2.769 1.913 4.312 3.938 4.312 1.875 0 3.937-1.313 3.937-4.313V4.125C28.5 1.586 26.625 0 24.562 0c-2.062 0-3.937 1.75-3.937 3.938zM10.313 16.5v12.188c0 2.769 1.912 4.312 3.937 4.312 1.875 0 3.938-1.313 3.938-4.313v-12c0-2.538-1.875-4.125-3.938-4.125s-3.938 1.75-3.938 3.938zM3.938 33a3.938 3.938 0 100-7.875 3.938 3.938 0 000 7.875z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#Google_Analytics_svg__clip0)",
                        fill: "#9DA6C7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M35.108 32.158a4.142 4.142 0 01-4.63 4.135 4.248 4.248 0 01-3.625-4.305V7.333a4.25 4.25 0 013.632-4.305 4.142 4.142 0 014.623 4.135v24.995zM9.128 28.072a4.128 4.128 0 110 8.257 4.128 4.128 0 010-8.257zM19.99 15.561a4.248 4.248 0 00-4.014 4.34V30.99c0 3.01 1.324 4.836 3.264 5.225a4.135 4.135 0 004.957-4.064V19.71a4.142 4.142 0 00-4.136-4.15h-.07z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "Google_Analytics_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(5 3)",
                                d: "M0 0h30.108v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Segment.tsx

function Segment() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "139",
                height: "39",
                viewBox: "0 0 139 39",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Segment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M58.19 18.912l-2.327-.5c-1.181-.251-1.825-.966-1.825-2.041 0-1.36 1.181-2.362 2.792-2.362 2.183 0 2.827 1.61 3.006 2.112.036.18.18.287.323.395a.696.696 0 00.465.035l1.24-.43c.323-.107.465-.43.395-.751-.323-1.11-1.517-3.724-5.441-3.724-2.938 0-5.406 2.255-5.406 4.904 0 2.29 1.517 3.971 4.009 4.51l2.206.5c1.36.287 2.148 1.11 2.148 2.183 0 1.395-1.144 2.254-2.971 2.254-2.149 0-3.221-1.431-3.472-2.758a.714.714 0 00-.287-.43.786.786 0 00-.5-.072l-1.36.43a.657.657 0 00-.43.68c.43 2.183 2.206 4.547 6.049 4.547 3.221 0 5.654-2.113 5.654-4.904-.036-2.289-1.575-3.971-4.296-4.582l.028.004zm11.238-2.255c-2.613 0-5.334 2.183-5.334 5.87 0 1.755.573 3.294 1.683 4.368 1.002 1.003 2.4 1.575 3.902 1.575 2.255 0 4.045-1.182 4.868-3.15a.607.607 0 000-.5c-.072-.144-.215-.287-.358-.323l-1.11-.394c-.323-.108-.644.035-.752.322-.465 1.11-1.36 1.683-2.648 1.683-1.539 0-2.72-1.039-2.937-2.579 0-.036 0-.072.036-.108 0 0 .036-.035.107-.035h7.268c.322 0 .606-.251.606-.573v-.322c0-3.616-2.04-5.834-5.334-5.834h.003zm2.648 4.404c0 .035 0 .071-.036.107 0 0-.036.036-.108.036h-4.975c-.036 0-.072-.036-.107-.036 0 0-.036-.036-.036-.107a2.578 2.578 0 012.578-2.077c1.517 0 2.483.786 2.685 2.077h-.001zm14.341-4.08h-1.324a.635.635 0 00-.606.645c0 .071-.072.107-.072.107-.036 0-.072.036-.108 0-.68-.607-1.61-.93-2.826-.93-2.972 0-5.12 2.288-5.12 5.405 0 3.116 2.15 5.405 5.12 5.405 1.11 0 2.076-.358 2.792-1.002.036-.036.108-.036.108-.036.035 0 .071.036.071.108v.464c0 2.183-.965 3.172-3.006 3.172-1.29 0-2.326-.786-2.613-2.04a.752.752 0 00-.287-.395.716.716 0 00-.465-.072l-1.289.287a.615.615 0 00-.465.751c.465 2.255 2.506 3.795 5.083 3.795 1.934 0 3.4-.572 4.367-1.754.786-.965 1.218-2.289 1.218-3.83v-9.459c.036-.323-.251-.607-.572-.607l-.006-.013zm-4.626 8.377c-1.754 0-2.827-1.218-2.827-3.15s1.11-3.15 2.827-3.15c1.646 0 2.792 1.241 2.792 3.15 0 1.908-1.144 3.15-2.792 3.15zm20.261-8.666c-1.467 0-2.648.552-3.436 1.575-.036.036-.072.072-.108.072-.036 0-.072-.036-.072-.036-.644-1.003-1.79-1.611-3.113-1.611-1.039 0-2.077.359-2.758 1.003a.27.27 0 01-.144.035c-.036 0-.071-.035-.071-.107a.625.625 0 00-.607-.607h-1.29a.625.625 0 00-.606.607v9.88c0 .359.287.607.607.607h1.323a.625.625 0 00.607-.607v-6.05c0-1.467.896-2.433 2.206-2.433 1.754 0 2.005 1.36 2.005 2.183v6.302c0 .358.287.606.607.606h1.324a.625.625 0 00.607-.607V21.42c0-1.431.896-2.434 2.206-2.434 1.754 0 2.005 1.36 2.005 2.183v6.302c0 .359.287.607.607.607h1.324a.625.625 0 00.606-.607v-6.517c.036-2.937-1.897-4.275-3.866-4.275l.037.014zm11.313-.035c-2.613 0-5.334 2.183-5.334 5.87 0 1.755.573 3.294 1.683 4.368 1.002 1.003 2.399 1.575 3.902 1.575 2.255 0 4.045-1.182 4.868-3.15a.617.617 0 000-.5c-.072-.144-.215-.287-.359-.323l-1.11-.394c-.322-.108-.644.035-.751.322-.465 1.11-1.36 1.683-2.648 1.683-1.539 0-2.721-1.039-2.937-2.579 0-.036 0-.072.036-.108 0 0 .036-.035.107-.035h7.267c.323 0 .607-.251.607-.573v-.322c.036-3.616-2.005-5.834-5.334-5.834h.003zm-2.434 4.547c-.036 0-.071-.036-.107-.036 0 0-.036-.036-.036-.107a2.577 2.577 0 012.578-2.077c1.432 0 2.434.786 2.648 2.077 0 .035 0 .071-.036.107 0 0-.036.036-.107.036h-4.94zm15.607-4.512c-1.11 0-2.076.394-2.826 1.11-.036.036-.108.036-.144.036-.036 0-.072-.036-.072-.108v-.071a.625.625 0 00-.606-.607h-1.29a.625.625 0 00-.606.607v9.88a.6.6 0 00.606.607h1.324a.625.625 0 00.607-.607v-5.833c0-1.29.572-2.685 2.206-2.685 1.467 0 2.207.823 2.207 2.434v6.012a.6.6 0 00.606.607h1.324a.625.625 0 00.607-.607v-6.335c.072-2.758-1.467-4.44-3.972-4.44h.029zm10.288 2.65h1.538a.625.625 0 00.607-.606V17.59a.625.625 0 00-.607-.607h-1.552c-.072 0-.108-.071-.108-.107v-2.612a.626.626 0 00-.607-.607h-1.144a.625.625 0 00-.607.607v1.36c0 .644-.251 1.395-1.395 1.395h-.251a.625.625 0 00-.607.607v1.145c0 .322.287.606.607.606h1.289c.072 0 .143.072.143.108v5.477c0 2.005 1.218 3.257 3.222 3.257.551 0 .965-.072 1.181-.107a.613.613 0 00.465-.607v-1.038a.575.575 0 00-.215-.465c-.143-.106-.323-.18-.465-.144-.143 0-.286.036-.394.036-.896 0-1.241-.322-1.241-1.217v-5.19c.036-.072.072-.144.143-.144l-.002-.002zM26.044 26.495H2.007A2.013 2.013 0 010 24.488c0-1.104.903-2.007 2.007-2.007h24.037c1.104 0 2.007.903 2.007 2.007a2.013 2.013 0 01-2.007 2.007zM20.925 38.79c-1.957 0-3.914-.301-5.77-.853-1.055-.352-1.657-1.456-1.305-2.51.35-1.053 1.455-1.655 2.508-1.304 1.456.452 3.011.702 4.567.702 6.825 0 12.746-4.365 14.703-10.889.301-1.054 1.455-1.656 2.509-1.355 1.054.301 1.656 1.456 1.355 2.51-2.56 8.179-9.986 13.699-18.567 13.699zM39.793 16.309H15.756A2.013 2.013 0 0113.75 14.3c0-1.103.903-2.007 2.007-2.007h24.037c1.104 0 2.007.904 2.007 2.008a2.013 2.013 0 01-2.007 2.007zM4.266 16.309c-.2 0-.401-.05-.602-.1-1.054-.302-1.656-1.456-1.355-2.51C4.869 5.52 12.295 0 20.926 0c1.957 0 3.914.301 5.77.853 1.054.351 1.657 1.455 1.305 2.51-.35 1.053-1.455 1.655-2.509 1.304a15.5 15.5 0 00-4.566-.703c-6.825 0-12.746 4.366-14.703 10.89-.301.903-1.104 1.455-1.957 1.455zM32.819 8.681a2.007 2.007 0 100-4.014 2.007 2.007 0 000 4.014zM8.983 34.173a2.007 2.007 0 100-4.014 2.007 2.007 0 000 4.014z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#Segment_svg__clip0)",
                        fill: "#9DA6C7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M23.766 25.327H4.6c-.88 0-1.6-.72-1.6-1.6 0-.881.72-1.601 1.6-1.601h19.166c.88 0 1.6.72 1.6 1.6 0 .88-.72 1.6-1.6 1.6zM19.685 35.13c-1.56 0-3.121-.24-4.601-.68-.84-.28-1.32-1.16-1.04-2.001.28-.84 1.16-1.32 2-1.04 1.16.36 2.4.56 3.641.56 5.442 0 10.163-3.481 11.724-8.683.24-.84 1.16-1.32 2-1.08.84.24 1.32 1.16 1.08 2-2.04 6.522-7.962 10.924-14.804 10.924zM34.73 17.204H15.564c-.88 0-1.6-.72-1.6-1.6 0-.88.72-1.6 1.6-1.6H34.73c.88 0 1.6.72 1.6 1.6 0 .88-.72 1.6-1.6 1.6zM6.401 17.204c-.16 0-.32-.04-.48-.08-.84-.24-1.32-1.16-1.08-2C6.88 8.602 12.803 4.2 19.685 4.2c1.56 0 3.12.24 4.601.68.84.28 1.32 1.161 1.04 2.001-.28.84-1.16 1.32-2 1.04-1.16-.36-2.4-.56-3.641-.56-5.442 0-10.163 3.481-11.724 8.683-.24.72-.88 1.16-1.56 1.16zM29.168 11.123a1.6 1.6 0 100-3.201 1.6 1.6 0 000 3.2zM10.162 31.449a1.6 1.6 0 100-3.201 1.6 1.6 0 000 3.2z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "Segment_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(3 3)",
                                d: "M0 0h33.33v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Slack.tsx

function Slack() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 99 26",
                width: 99,
                height: 26,
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Slack"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M31.672 20.617l1.235-2.87c1.335.997 3.113 1.516 4.867 1.516 1.295 0 2.115-.5 2.115-1.255-.02-2.115-7.758-.46-7.817-5.762-.02-2.693 2.372-4.768 5.762-4.768 2.015 0 4.027.499 5.464 1.635l-1.156 2.93c-1.315-.839-2.95-1.437-4.506-1.437-1.058 0-1.755.5-1.755 1.137.02 2.075 7.817.938 7.897 6.003 0 2.752-2.333 4.689-5.683 4.689-2.455-.004-4.708-.582-6.423-1.818zm47.445-3.908a3.586 3.586 0 01-3.113 1.813 3.564 3.564 0 01-3.568-3.568 3.566 3.566 0 013.568-3.568c1.335 0 2.495.737 3.113 1.814l3.41-1.893c-1.276-2.273-3.731-3.83-6.523-3.83a7.482 7.482 0 000 14.96 7.436 7.436 0 006.522-3.828l-3.41-1.9zM45.492 1.273h4.27v20.88h-4.27V1.274zm38.71 0v20.88h4.268V15.89l5.065 6.265H99l-6.443-7.441L98.52 7.77h-5.228l-4.827 5.762V1.273h-4.265z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.446 16.748c-.618 1.018-1.893 1.774-3.33 1.774a3.563 3.563 0 01-3.569-3.568 3.566 3.566 0 013.568-3.568c1.438 0 2.713.796 3.33 1.834v3.528zm0-8.973V9.47c-.697-1.176-2.432-1.996-4.25-1.996-3.75 0-6.7 3.31-6.7 7.46s2.95 7.5 6.7 7.5c1.814 0 3.549-.815 4.25-1.995v1.695h4.268V7.774h-4.268z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.287 16.728a2.63 2.63 0 01-2.633 2.634A2.632 2.632 0 01.02 16.728a2.632 2.632 0 012.633-2.633h2.633v2.633zm1.315 0a2.63 2.63 0 012.633-2.633 2.63 2.63 0 012.634 2.633v6.582a2.63 2.63 0 01-2.634 2.633 2.63 2.63 0 01-2.633-2.633v-6.582zM9.235 6.16A2.63 2.63 0 016.6 3.525 2.63 2.63 0 019.235.892a2.63 2.63 0 012.633 2.634v2.633H9.235zm0 1.334a2.63 2.63 0 012.633 2.633 2.63 2.63 0 01-2.633 2.634H2.633A2.632 2.632 0 010 10.127a2.632 2.632 0 012.633-2.633h6.602zM19.785 10.127a2.63 2.63 0 012.633-2.633 2.63 2.63 0 012.634 2.633 2.63 2.63 0 01-2.634 2.634h-2.633v-2.634zm-1.315 0a2.63 2.63 0 01-2.633 2.634 2.63 2.63 0 01-2.634-2.634V3.526A2.63 2.63 0 0115.836.892a2.63 2.63 0 012.634 2.634v6.601zM15.836 20.677a2.63 2.63 0 012.634 2.633 2.63 2.63 0 01-2.633 2.633 2.63 2.63 0 01-2.634-2.633v-2.633h2.633zm0-1.315a2.63 2.63 0 01-2.633-2.634 2.63 2.63 0 012.633-2.633h6.602a2.63 2.63 0 012.633 2.633 2.63 2.63 0 01-2.633 2.634h-6.601z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#Slack_svg__clip0)",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: "#9DA6C7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M15.196 3a3.329 3.329 0 00-3.326 3.332 3.33 3.33 0 003.327 3.333h3.327V6.334A3.332 3.332 0 0015.196 3zm0 8.888h-8.87A3.33 3.33 0 003 15.22a3.33 3.33 0 003.325 3.334h8.87a3.33 3.33 0 003.328-3.332 3.33 3.33 0 00-3.327-3.334zM36.263 15.22a3.33 3.33 0 00-3.327-3.332 3.33 3.33 0 00-3.327 3.332v3.334h3.327a3.33 3.33 0 003.327-3.334zm-8.87 0V6.332A3.33 3.33 0 0024.067 3a3.33 3.33 0 00-3.327 3.332v8.888a3.33 3.33 0 003.326 3.334 3.33 3.33 0 003.327-3.334zM24.066 36.33a3.33 3.33 0 003.327-3.332 3.33 3.33 0 00-3.327-3.333h-3.327v3.333a3.331 3.331 0 003.327 3.332zm0-8.89h8.87a3.33 3.33 0 003.327-3.332 3.33 3.33 0 00-3.325-3.333h-8.87a3.33 3.33 0 00-3.328 3.332 3.329 3.329 0 003.326 3.334zM3 24.108a3.33 3.33 0 003.327 3.333 3.33 3.33 0 003.327-3.333v-3.332H6.327A3.33 3.33 0 003 24.108zm8.87 0v8.888a3.33 3.33 0 003.326 3.334 3.33 3.33 0 003.327-3.332V24.11a3.327 3.327 0 10-6.652-.003s0 .002 0 0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "Slack_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(3 3)",
                                d: "M0 0h33.263v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Zapier.tsx

function Zapier() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "79",
                height: "36",
                viewBox: "0 0 79 36",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Zapier"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M47.3863 15.5894H45.43C45.3898 15.4293 45.3598 15.2436 45.3398 15.0327C45.3 14.6224 45.3 14.2092 45.3398 13.7989C45.3598 13.5886 45.3898 13.403 45.43 13.2419H50.3057V28.6811C50.0616 28.7235 49.8155 28.7535 49.5683 28.7709C49.3228 28.7897 49.0768 28.7997 48.8305 28.8007C48.5947 28.7992 48.359 28.7893 48.1238 28.7709C47.8768 28.7534 47.6308 28.7233 47.3868 28.6806V15.5888V15.5891L47.3863 15.5894ZM64.3598 19.472C64.3598 18.9101 64.2845 18.3735 64.1344 17.8615C63.9837 17.3502 63.7623 16.9039 63.4723 16.5225C63.1807 16.1416 62.8098 15.8354 62.3583 15.6048C61.907 15.374 61.3702 15.2585 60.7482 15.2585C59.5244 15.2585 58.5863 15.6302 57.9344 16.3722C57.2823 17.1144 56.8863 18.1476 56.7456 19.472H64.36H64.3598ZM56.7156 21.6989C56.7558 23.3842 57.1922 24.6184 58.0248 25.4004C58.8571 26.1828 60.0863 26.5746 61.7114 26.5746C63.1355 26.5746 64.4899 26.3235 65.774 25.8219C65.9341 26.1228 66.0644 26.4891 66.1649 26.9204C66.2634 27.3404 66.3239 27.7685 66.3454 28.1993C65.6837 28.481 64.9558 28.6907 64.1639 28.8315C63.3708 28.9715 62.4932 29.0422 61.5308 29.0422C60.1258 29.0422 58.9218 28.8459 57.9192 28.4551C56.9158 28.0634 56.0882 27.5116 55.4361 26.7997C54.7842 26.0877 54.3075 25.2449 54.0065 24.2716C53.7058 23.2988 53.5549 22.2303 53.5549 21.0666C53.5549 19.923 53.7003 18.8545 53.9913 17.8612C54.2817 16.8686 54.7291 16.0057 55.3303 15.2734C55.9325 14.5408 56.6897 13.9592 57.6027 13.5278C58.5152 13.0964 59.5935 12.8804 60.838 12.8804C61.9012 12.8804 62.8341 13.0613 63.6369 13.4223C64.4391 13.7834 65.1114 14.28 65.6533 14.912C66.1949 15.5442 66.6061 16.2966 66.8871 17.1689C67.1678 18.042 67.3088 18.9898 67.3088 20.0133C67.3088 20.2943 67.2981 20.59 67.2782 20.9009C67.2617 21.1669 67.2417 21.4328 67.2182 21.6983H56.715L56.7153 21.6988L56.7156 21.6989ZM70.5908 13.2419C70.8003 13.2039 71.0111 13.1739 71.2228 13.1518C71.423 13.1322 71.6341 13.122 71.8548 13.122C72.0755 13.122 72.2959 13.1322 72.5169 13.1518C72.7375 13.1722 72.9383 13.2024 73.119 13.2419C73.1786 13.543 73.2389 13.9397 73.2989 14.4307C73.359 14.9224 73.3896 15.3384 73.3896 15.6796C73.8108 14.9977 74.3676 14.4055 75.0595 13.9038C75.7518 13.4025 76.6395 13.1514 77.7228 13.1514C77.8832 13.1514 78.0487 13.1567 78.2193 13.1668C78.3653 13.1746 78.5113 13.1894 78.6557 13.2115C78.6956 13.3923 78.7263 13.5832 78.7461 13.7835C78.7659 13.984 78.7759 14.1948 78.7759 14.4154C78.7759 14.6563 78.761 14.9073 78.731 15.1676C78.7021 15.4191 78.667 15.67 78.6259 15.9198C78.4633 15.8798 78.2965 15.8596 78.129 15.8597H77.7225C77.1809 15.8597 76.6641 15.935 76.1726 16.0853C75.6807 16.236 75.2396 16.5019 74.8484 16.8827C74.4575 17.2642 74.1462 17.786 73.9159 18.4481C73.6847 19.1102 73.5696 19.9629 73.5696 21.006V28.6806C73.3255 28.723 73.0794 28.7533 72.8322 28.7707C72.5617 28.7908 72.3157 28.8006 72.0952 28.8006C71.849 28.7996 71.6031 28.7896 71.3577 28.7707C71.1006 28.752 70.8445 28.722 70.5901 28.6808V13.2421L70.5908 13.2419ZM49.469 4.99815C49.469 5.35836 49.404 5.71562 49.277 6.05272C48.9398 6.1797 48.5824 6.24479 48.2221 6.24486H48.2177C47.8574 6.2449 47.5 6.17987 47.1628 6.05287C47.0356 5.71572 46.9705 5.35834 46.9705 4.99799V4.99328C46.9705 4.62203 47.0387 4.26648 47.162 3.93839C47.4993 3.81123 47.8568 3.74618 48.2172 3.74641H48.2213C48.5927 3.74641 48.9481 3.81454 49.2762 3.93839C49.4033 4.27556 49.4684 4.63295 49.4682 4.99328V4.99799H49.4687L49.469 4.99815ZM53.1463 4.16303H50.2303L52.292 2.10114C51.9678 1.64582 51.5698 1.2479 51.1144 0.923809L49.0523 2.9857V0.0695408C48.7782 0.0234188 48.5006 0.000158482 48.2226 0H48.2172C47.9344 0 47.6573 0.0241744 47.3873 0.0695408V2.9857L45.3248 0.923652C45.0976 1.08532 44.8844 1.26574 44.6874 1.46303L44.6865 1.46397C44.4895 1.6611 44.3093 1.87428 44.1476 2.10129L46.2101 4.16303H43.2935C43.2935 4.16303 43.2241 4.71088 43.2241 4.99406V4.99752C43.2241 5.2807 43.2481 5.55824 43.2936 5.8284H46.2103L44.1474 7.88998C44.4719 8.34523 44.8699 8.74323 45.3252 9.06762L47.3875 7.00588V9.9222C47.6571 9.96741 47.9337 9.99127 48.2163 9.99158H48.2234C48.5011 9.99133 48.7783 9.96812 49.0522 9.9222V7.00588L51.1146 9.06809C51.3417 8.90627 51.5551 8.72586 51.7524 8.52872H51.7528C51.9497 8.33137 52.1299 8.11804 52.2916 7.89092L50.2298 5.82855H53.1465C53.1917 5.55855 53.2155 5.28196 53.2155 4.9994V4.99218C53.2155 4.71433 53.1923 4.43727 53.1465 4.16334V4.16303H53.1463ZM0.288086 28.2599L8.41384 15.6195H1.25098C1.19102 15.2585 1.16103 14.8576 1.16103 14.416C1.16103 13.9948 1.19149 13.6032 1.25161 13.2418H12.8381L12.9888 13.6338L4.8029 26.3037H12.4769C12.537 26.7051 12.5673 27.116 12.5673 27.5372C12.5673 27.9391 12.5372 28.3201 12.477 28.6811H0.438784L0.288086 28.2595V28.2599ZM23.732 21.4278C23.431 21.3881 23.0497 21.3484 22.5884 21.3077C22.1269 21.268 21.7357 21.2476 21.4151 21.2476C20.1709 21.2476 19.223 21.4784 18.5713 21.9399C17.9188 22.4017 17.5934 23.1036 17.5934 24.0465C17.5934 24.6484 17.7033 25.1199 17.9241 25.4609C18.1445 25.8025 18.4207 26.0627 18.7517 26.2434C19.0829 26.4239 19.4487 26.5344 19.8498 26.5746C20.2508 26.6147 20.6323 26.6346 20.9933 26.6346C21.4549 26.6346 21.9313 26.6095 22.4229 26.5592C22.9143 26.5095 23.3507 26.434 23.7321 26.3337V21.4278H23.732ZM23.732 18.509C23.732 17.3248 23.431 16.5022 22.8293 16.0407C22.2272 15.5792 21.3545 15.3484 20.211 15.3484C19.5082 15.3484 18.8516 15.404 18.2398 15.5142C17.6344 15.6228 17.0363 15.7684 16.4487 15.9501C16.0673 15.288 15.8773 14.496 15.8773 13.5725C16.5586 13.3521 17.3108 13.1817 18.1339 13.0613C18.9564 12.9407 19.7488 12.8804 20.5116 12.8804C22.5177 12.8804 24.0425 13.3372 25.0859 14.2501C26.1288 15.1637 26.651 16.6231 26.651 18.6291V28.2898C25.9483 28.4502 25.0959 28.6156 24.0929 28.7863C23.0786 28.9575 22.0518 29.0431 21.0232 29.0422C20.0402 29.0422 19.152 28.9522 18.3599 28.7715C17.5672 28.5905 16.895 28.3003 16.3434 27.8984C15.7911 27.4975 15.3654 26.9858 15.064 26.364C14.7632 25.7419 14.6127 24.9896 14.6127 24.1066C14.6127 23.2442 14.7882 22.4866 15.1394 21.8342C15.4844 21.1897 15.9737 20.6335 16.5691 20.2092C17.171 19.7785 17.8631 19.457 18.6456 19.2466C19.4283 19.0358 20.2505 18.9303 21.1133 18.9303C21.7553 18.9303 22.282 18.9457 22.6934 18.9758C23.1044 19.0057 23.4507 19.0408 23.7317 19.081V18.5092L23.732 18.509ZM32.8806 26.1525C33.2605 26.2929 33.6539 26.3938 34.0545 26.4536C34.4557 26.514 34.9769 26.544 35.6195 26.544C36.3416 26.544 37.0034 26.429 37.6053 26.1982C38.2074 25.9679 38.7239 25.6114 39.1553 25.1297C39.5866 24.6484 39.9276 24.0418 40.1784 23.3087C40.4291 22.5769 40.5549 21.7094 40.5549 20.7057C40.5549 19.1008 40.2585 17.8268 39.667 16.8837C39.0747 15.9409 38.1067 15.4693 36.7629 15.4693C36.2614 15.4693 35.7795 15.5594 35.3187 15.7402C34.8566 15.9208 34.4456 16.1917 34.0844 16.5527C33.7234 16.9138 33.4325 17.3706 33.212 17.9222C32.9906 18.4745 32.8807 19.1309 32.8807 19.8935V26.153V26.1527L32.8806 26.1525ZM29.9012 13.2416C30.1052 13.2014 30.3109 13.1715 30.5181 13.1515C30.7332 13.1316 30.9492 13.1217 31.1653 13.1217C31.3653 13.1217 31.5758 13.1321 31.797 13.1515C32.0174 13.1719 32.228 13.2022 32.429 13.2418C32.4487 13.2826 32.4742 13.4074 32.5043 13.6182C32.5341 13.829 32.5643 14.0546 32.5946 14.2951C32.6247 14.5361 32.6547 14.7673 32.6848 14.9874C32.715 15.2084 32.73 15.3489 32.73 15.409C32.9302 15.0883 33.1711 14.777 33.4521 14.4761C33.7331 14.175 34.0695 13.9042 34.4607 13.6637C34.8519 13.4228 35.293 13.2324 35.7848 13.0917C36.2761 12.9514 36.8229 12.8806 37.4249 12.8806C38.3275 12.8806 39.1653 13.0313 39.9381 13.3324C40.7101 13.6338 41.3718 14.0995 41.9239 14.7317C42.4753 15.3638 42.9065 16.1664 43.2178 17.1392C43.5286 18.1131 43.6841 19.2615 43.6841 20.5855C43.6841 23.2337 42.9667 25.3058 41.5319 26.8002C40.0971 28.2951 38.0663 29.0422 35.438 29.0422C34.9965 29.0422 34.5453 29.012 34.0838 28.9519C33.622 28.8915 33.2211 28.8111 32.8798 28.7112V35.7837C32.6256 35.8251 32.3697 35.8552 32.1128 35.8739C31.8417 35.8936 31.5957 35.9038 31.375 35.9038C31.129 35.9027 30.8831 35.8928 30.6379 35.8739C30.3908 35.8564 30.1447 35.8263 29.9007 35.7837V13.2418L29.9012 13.2416Z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#Zapier_svg__clip0)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M35.917 16.758H26.14l6.871-6.87c-.529-.793-1.057-1.322-1.586-2.115a15.112 15.112 0 01-2.113-1.85l-6.87 6.871V3.281a8.984 8.984 0 00-2.643-.264 8.14 8.14 0 00-2.643.264v9.778L10.02 5.924a7.135 7.135 0 00-2.114 1.85c-.529.792-1.321 1.32-1.85 2.114l6.87 6.87H3.414L3.15 19.4a8.14 8.14 0 00.264 2.643h9.778l-7.135 7.134a14.164 14.164 0 003.964 3.964l6.87-6.87v9.778a8.984 8.984 0 002.643.264 8.137 8.137 0 002.642-.264v-9.777l6.87 6.87c.82-.47 1.54-1.099 2.114-1.85.681-.645 1.3-1.352 1.85-2.113l-6.87-6.872h9.777a8.985 8.985 0 00.265-2.642 9.91 9.91 0 00-.264-2.907zM23.761 19.4a13.393 13.393 0 01-.529 3.436 7.93 7.93 0 01-3.435.529 13.401 13.401 0 01-3.436-.529 7.93 7.93 0 01-.528-3.436c.026-1.163.204-2.318.528-3.435a7.928 7.928 0 013.436-.529c1.163.026 2.318.204 3.435.529a15.46 15.46 0 01.529 3.435z",
                            fill: "#9DA6C7"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "Zapier_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(3 3)",
                                d: "M0 0h33.33v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Hubspot.tsx

function Hubspot() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "94",
                height: "29",
                viewBox: "0 0 94 29",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Hubspot"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 5.871h3.278v7.282h6.913V5.871h3.281v17.875h-3.281v-7.434H3.277v7.434H0V5.872zm23.856 12.053a2.718 2.718 0 01-2.715 2.714 2.718 2.718 0 01-2.715-2.714v-7.696h-3.108v7.696a5.83 5.83 0 005.823 5.823 5.829 5.829 0 005.822-5.823v-7.696h-3.107v7.696zm11.785-7.605c-1.542 0-2.618.447-3.658 1.467V5.871h-3.118v10.962c0 4.103 2.966 6.914 6.3 6.914 3.705 0 6.951-2.86 6.951-6.714 0-3.805-2.993-6.715-6.475-6.715zm.077 10.542c-2.113 0-3.729-1.764-3.729-3.828 0-2.065 1.616-3.83 3.73-3.83 1.79 0 3.407 1.765 3.407 3.83 0 2.064-1.617 3.828-3.408 3.828zm11.636-9.757c0-1.568 1.044-2.065 2.188-2.065.92 0 2.139.697 2.934 1.542l2.038-2.387c-1.019-1.367-3.082-2.312-4.773-2.312-3.382 0-5.82 1.964-5.82 5.222 0 6.043 7.436 4.127 7.436 7.51 0 1.043-1.019 1.964-2.187 1.964-1.84 0-2.438-.895-3.283-1.84l-2.263 2.337c1.443 1.765 3.232 2.661 5.371 2.661 3.208 0 5.794-1.99 5.794-5.098 0-6.714-7.435-4.625-7.435-7.534zm15.645-.96c-3.333 0-6.3 2.808-6.3 6.912v10.99h3.118v-5.943c1.04 1.02 2.116 1.468 3.658 1.468 3.482 0 6.476-2.91 6.476-6.714 0-3.854-3.248-6.714-6.952-6.714zm.554 10.543c-2.113 0-3.73-1.768-3.73-3.83 0-2.064 1.617-3.83 3.73-3.83 1.79 0 3.407 1.766 3.407 3.83 0 2.063-1.617 3.83-3.407 3.83zm29.352.174c-1.84 0-2.362-.795-2.362-2.014v-5.396h2.86v-2.735h-2.86V7.111l-3.157 1.417v10.99c0 2.81 1.94 4.229 4.599 4.229.398 0 .945-.026 1.244-.1L94 20.813c-.348.024-.746.049-1.095.049z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M84.681 13.61c-.597-1.028-1.438-1.853-2.49-2.473a6.687 6.687 0 00-2.518-.873V6.996a2.413 2.413 0 001.488-2.259c0-1.372-1.1-2.483-2.471-2.483a2.49 2.49 0 00-2.491 2.483c0 1.007.537 1.87 1.455 2.26v3.269a7.189 7.189 0 00-2.192.687c-1.42-1.08-6.079-4.618-8.803-6.686.064-.233.114-.473.114-.726a2.75 2.75 0 10-2.75 2.751c.52 0 .999-.152 1.413-.4l.575.435 7.901 5.694c-.417.383-.806.82-1.118 1.309-.63.998-1.016 2.096-1.016 3.293v.25c0 .84.16 1.635.432 2.38.24.651.59 1.243 1.024 1.778l-2.623 2.63a2.112 2.112 0 00-2.233.49 2.111 2.111 0 00-.622 1.503c0 .568.221 1.101.623 1.503a2.113 2.113 0 001.503.623 2.114 2.114 0 001.504-.623 2.116 2.116 0 00.525-2.141l2.71-2.711c.372.257.773.473 1.205.659.85.368 1.79.592 2.818.592h.188a6.645 6.645 0 003.217-.813 6.657 6.657 0 002.52-2.373c.632-1.01.98-2.127.98-3.355v-.061c0-1.208-.28-2.322-.868-3.344zm-3.311 5.687c-.736.818-1.582 1.322-2.538 1.322h-.157c-.546 0-1.08-.151-1.603-.426-.59-.302-1.038-.733-1.404-1.28-.38-.535-.585-1.12-.585-1.74v-.188c0-.61.117-1.188.412-1.734a3.756 3.756 0 011.307-1.43 3.2 3.2 0 011.811-.547h.062c.6 0 1.167.119 1.703.393.546.292.992.691 1.337 1.217.336.525.536 1.092.6 1.71.01.128.016.26.016.385 0 .838-.32 1.614-.961 2.318z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#Hubspot_svg__clip0)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M33.584 18.832a8.467 8.467 0 00-3.075-3.054A8.286 8.286 0 0027.4 14.7v-4.061a2.975 2.975 0 001.836-2.79 3.05 3.05 0 00-3.051-3.066 3.077 3.077 0 00-3.077 3.066c0 1.246.661 2.31 1.798 2.79v4.038a8.873 8.873 0 00-2.706.85L11.33 7.294c.075-.287.142-.585.142-.898a3.397 3.397 0 10-3.395 3.398 3.37 3.37 0 001.744-.496l.712.539 9.752 7.031a8.11 8.11 0 00-1.38 1.617c-.779 1.234-1.254 2.589-1.254 4.069v.305a8.517 8.517 0 00.534 2.94 7.693 7.693 0 001.264 2.197l-3.24 3.247a2.613 2.613 0 00-2.759.605 2.628 2.628 0 003.715 3.713 2.625 2.625 0 00.646-2.645l3.347-3.346c.457.318.953.585 1.487.814a8.696 8.696 0 003.481.732h.23a8.21 8.21 0 003.971-1.004 8.214 8.214 0 003.113-2.932c.78-1.246 1.208-2.627 1.208-4.145v-.077c0-1.492-.346-2.868-1.068-4.13l.005.003zm-4.087 7.024c-.907 1.01-1.953 1.632-3.133 1.632h-.223c-.674 0-1.335-.185-1.979-.526a4.578 4.578 0 01-1.734-1.58c-.468-.66-.722-1.383-.722-2.148v-.229c0-.753.145-1.467.508-2.141.39-.763.916-1.31 1.615-1.765a3.959 3.959 0 012.238-.674h.076c.738 0 1.442.145 2.103.483a4.45 4.45 0 011.653 1.503 4.78 4.78 0 01.74 2.111l.018.476c0 1.034-.397 1.993-1.188 2.863l.028-.005z",
                            fill: "#9DA6C7"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "Hubspot_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(3 3)",
                                d: "M0 0h33.33v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Heroku.tsx

function Heroku() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "138",
                height: "39",
                viewBox: "0 0 138 39",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Heroku"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M31.396.122H3.862A3.44 3.44 0 00.408 3.576v31.468a3.44 3.44 0 003.454 3.453h27.534a3.44 3.44 0 003.454-3.453V3.576A3.44 3.44 0 0031.396.122zm1.535 34.922c0 .863-.671 1.535-1.535 1.535H3.862a1.515 1.515 0 01-1.535-1.535V3.576c0-.864.672-1.535 1.535-1.535h27.534c.864 0 1.535.671 1.535 1.535v31.468zM9.043 32.74l4.317-3.837-4.317-3.838v7.675zM24.585 17.2c-.768-.767-2.207-1.727-4.605-1.727-2.59 0-5.277.672-7.196 1.343V5.878H8.947v16.598l2.686-1.247s4.413-2.015 8.25-2.015c1.92 0 2.4 1.055 2.4 2.015V32.74h3.837V21.23c.096-.288.096-2.399-1.535-4.03zM19.5 12.114h3.837c1.727-2.014 2.59-4.03 2.879-6.236h-3.838c-.384 2.207-1.343 4.222-2.878 6.236zm106.012 9.019V12.69h3.837v8.443c0 1.918.672 2.878 2.207 2.878 1.535 0 2.111-.864 2.111-2.878V12.69h3.741v8.539c0 3.741-1.823 5.948-5.948 5.948-4.125-.096-5.948-2.303-5.948-6.044zm-16.118-8.443h3.838v5.18l3.933-5.18h4.413l-4.797 5.564 5.181 8.635h-4.317l-3.358-5.66-1.055 1.247v4.413h-3.838V12.69zm-18.228 7.004c0-5.181 3.55-7.388 7.003-7.388 3.454 0 7.004 2.207 7.004 7.388 0 5.18-3.55 7.387-7.004 7.387-3.453 0-7.003-2.11-7.003-7.387zm10.073 0c0-2.59-1.151-4.222-3.166-4.222-2.014 0-3.165 1.631-3.165 4.222 0 2.59 1.15 4.317 3.165 4.317s3.166-1.631 3.166-4.317zm-25.52-7.004h5.565c3.646 0 5.852 1.247 5.852 4.605 0 2.207-.959 3.55-2.782 4.125l2.974 5.469H83.3l-2.782-4.893H79.46v4.893H75.72V12.69zm5.47 6.332c1.534 0 2.302-.48 2.302-1.631s-.672-1.631-2.303-1.631h-1.63v3.262h1.63zM61.04 12.69h10.17v3.166h-6.332v2.303h4.509v2.974h-4.51v2.59h6.62v3.07H61.042V12.69zm-17.365 0h3.838v5.277h4.7V12.69h3.839v14.199h-3.838v-5.756h-4.701v5.756h-3.838V12.69z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.633 36.33V18.102s1.185-4.361-14.604 1.785C9 19.965 9 3.032 9 3.032L14.159 3v10.85s14.445-5.69 14.445 4.314V36.33h-4.971zm2.94-26.764H21.1c1.97-2.408 3.753-6.534 3.753-6.534h5.658s-.968 2.689-3.938 6.534zM9.093 36.298v-10.38l5.191 5.19-5.19 5.19z",
                    fill: "#fff"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/NextJS.tsx

function Nextjs() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 85,
                height: 51,
                viewBox: "0 0 85 51",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Next.js"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.5092 13.2023H36.3346V14.4601H21.9598V23.9269H35.4773V25.1847H21.9598V35.5783H36.4994V36.8361H20.5092V13.2023ZM37.7523 13.2023H39.4337L46.8848 23.5959L54.5008 13.2023L64.8598 0L47.8409 24.6882L56.6108 36.8361H54.8635L46.8848 25.7805L38.8732 36.8361H37.1588L45.9946 24.6882L37.7523 13.2023ZM57.2373 14.4601V13.2023H75.2716V14.4601H66.9633V36.8361H65.5126V14.4601H57.2373ZM0.710938 13.2023H2.52426L27.529 50.6194L17.1957 36.8361L2.22754 14.9897L2.1616 36.8361H0.710938V13.2023ZM75.1255 35.1987C74.8291 35.1987 74.6068 34.9691 74.6068 34.6723C74.6068 34.3755 74.8291 34.1459 75.1255 34.1459C75.4254 34.1459 75.6441 34.3755 75.6441 34.6723C75.6441 34.9691 75.4254 35.1987 75.1255 35.1987ZM76.5509 33.8138H77.3271C77.3377 34.2342 77.6447 34.5169 78.0963 34.5169C78.6009 34.5169 78.8867 34.213 78.8867 33.6442V30.0406H79.677V33.6477C79.677 34.6723 79.0843 35.2623 78.1034 35.2623C77.1825 35.2623 76.5509 34.69 76.5509 33.8138ZM80.7108 33.7679H81.4941C81.5612 34.2519 82.034 34.5592 82.7149 34.5592C83.35 34.5592 83.8158 34.2307 83.8158 33.7785C83.8158 33.3898 83.5194 33.1567 82.8455 32.9977L82.1892 32.8387C81.2683 32.6232 80.8484 32.178 80.8484 31.4291C80.8484 30.5211 81.5894 29.917 82.7008 29.917C83.7346 29.917 84.4897 30.5211 84.5355 31.3796H83.7664C83.6923 30.9097 83.283 30.6165 82.6902 30.6165C82.0657 30.6165 81.6494 30.9168 81.6494 31.3761C81.6494 31.74 81.9175 31.9484 82.5808 32.1039L83.1419 32.2416C84.1862 32.4854 84.6167 32.9094 84.6167 33.676C84.6167 34.6511 83.8616 35.2623 82.6549 35.2623C81.5259 35.2623 80.7673 34.6794 80.7108 33.7679Z",
                        fill: "#F8F9FB"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.573 3.009c-.071.006-.3.03-.505.046C13.335 3.48 8.9 6.035 6.092 9.96a16.494 16.494 0 00-2.942 7.28c-.134.916-.15 1.186-.15 2.427s.016 1.512.15 2.427c.906 6.258 5.36 11.516 11.4 13.464 1.082.348 2.222.586 3.518.73.505.055 2.688.055 3.194 0 2.238-.248 4.134-.802 6.004-1.756.287-.147.342-.186.303-.219-.026-.02-1.248-1.658-2.714-3.638l-2.665-3.6-3.34-4.942c-1.837-2.717-3.349-4.938-3.362-4.938-.013-.004-.026 2.192-.032 4.873-.01 4.694-.013 4.883-.072 4.994a.592.592 0 01-.287.296c-.104.052-.195.062-.687.062h-.564l-.15-.094a.609.609 0 01-.218-.238l-.069-.146.007-6.532.01-6.535.1-.127a.894.894 0 01.242-.199c.133-.065.186-.071.75-.071.664 0 .775.026.947.215.05.052 1.858 2.775 4.02 6.056 2.164 3.28 5.123 7.76 6.576 9.958l2.639 3.997.133-.088c1.183-.768 2.434-1.863 3.424-3.003a16.587 16.587 0 003.923-8.519c.134-.915.15-1.186.15-2.427 0-1.24-.016-1.511-.15-2.427-.906-6.258-5.36-11.515-11.4-13.463a17.499 17.499 0 00-3.47-.727c-.313-.032-2.466-.068-2.736-.042zm6.823 10.079a.658.658 0 01.329.384c.026.085.033 1.896.026 5.978l-.01 5.857-1.032-1.583-1.037-1.583v-4.258c0-2.753.014-4.3.033-4.375a.665.665 0 01.323-.41c.133-.069.182-.075.694-.075.482 0 .566.006.674.065z",
                    fill: "#F8F9FB"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/React.tsx

function React() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-10 w-10 md:h-[50px] md:w-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "React"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.08 27.067a36.455 36.455 0 01-2.912 3.625c2.787 2.705 5.38 3.971 6.817 3.14 1.44-.83 1.638-3.709.69-7.474a37.017 37.017 0 01-4.595.709zm-2.183.145c-1.264.052-2.53.052-3.794 0 .629.82 1.264 1.58 1.897 2.273a34.9 34.9 0 001.897-2.273zm8.4-13.157c4.441 1.273 7.341 3.39 7.341 5.945s-2.9 4.672-7.341 5.945c1.116 4.483.735 8.053-1.477 9.33-2.213 1.278-5.497-.175-8.82-3.383-3.323 3.208-6.607 4.661-8.82 3.383-2.212-1.277-2.595-4.847-1.477-9.33-4.441-1.273-7.341-3.39-7.341-5.945s2.9-4.672 7.341-5.945c-1.116-4.483-.735-8.053 1.477-9.33 2.213-1.278 5.497.175 8.82 3.383 3.323-3.208 6.607-4.661 8.82-3.383 2.212 1.277 2.595 4.847 1.477 9.33zm-1.622-.413c.95-3.767.75-6.644-.688-7.474-1.439-.831-4.032.435-6.817 3.14a36.75 36.75 0 012.91 3.625c1.63.15 3.173.39 4.595.709zm-17.35 12.716c-.95 3.767-.75 6.644.688 7.474 1.439.831 4.032-.435 6.817-3.14a36.462 36.462 0 01-2.91-3.625 36.466 36.466 0 01-4.595-.709zm6.778-13.57a45.874 45.874 0 013.794 0A34.226 34.226 0 0020 10.517a34.931 34.931 0 00-1.897 2.273v-.002zm-2.183.145a36.457 36.457 0 012.913-3.625c-2.788-2.705-5.383-3.971-6.818-3.14-1.44.83-1.638 3.709-.69 7.474a37.06 37.06 0 014.595-.709zm7.237 12.534A42.275 42.275 0 0026.312 20a42.283 42.283 0 00-3.155-5.467 42.29 42.29 0 00-6.314 0A42.283 42.283 0 0013.688 20a42.275 42.275 0 003.155 5.467c2.102.157 4.212.157 6.314 0zm2.14-.219c1.025-.133 2-.305 2.916-.506-.3-.94-.64-1.868-1.02-2.779a45.87 45.87 0 01-1.896 3.284v.001zM14.703 14.75c-1.025.133-2 .305-2.916.507.283.893.623 1.823 1.02 2.778a45.834 45.834 0 011.896-3.283v-.002zm-2.916 9.99a34.71 34.71 0 002.916.507 45.832 45.832 0 01-1.896-3.284 33.995 33.995 0 00-1.02 2.777zm-1.63-.408c.435-1.39 1-2.847 1.683-4.334a36.678 36.678 0 01-1.683-4.333c-3.737 1.062-6.129 2.673-6.129 4.333 0 1.66 2.392 3.272 6.129 4.334zm18.056-9.075a34.71 34.71 0 00-2.916-.507 45.87 45.87 0 011.896 3.283 34.07 34.07 0 001.02-2.776zm1.63.408c-.435 1.39-1 2.847-1.683 4.333a36.662 36.662 0 011.683 4.334c3.737-1.062 6.129-2.674 6.129-4.334 0-1.66-2.392-3.271-6.129-4.333zM20 23.133a3.132 3.132 0 110-6.264 3.132 3.132 0 010 6.264z",
                fill: "#F8F9FB"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Shopify.tsx

function Shopify() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "113",
                height: "34",
                viewBox: "0 0 113 34",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:inline",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Shopify"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.004 6.57c-.113 0-2.491-.226-2.491-.226s-1.698-1.698-1.925-1.811c-.113-.114-.113-.114-.226-.114l-1.36 27.854 9.738-2.151S24.344 7.024 24.344 6.797c0-.113-.227-.226-.34-.226z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13.199 1.953c-.133-.077-.239-.138-.404-.138-2.944 0-4.53 3.85-5.322 6.114l2.49-.68c.68-3.17 2.039-4.641 3.398-5.207-.061-.03-.114-.061-.162-.09zm1.294 3.712a7.897 7.897 0 00-.453-2.718c-1.019.453-2.151 1.472-2.83 3.85l3.283-.906v-.226zm1.019-.227l1.472-.453c-.34-1.132-1.02-2.15-1.812-2.377.227.679.34 1.472.34 2.49v.34zm8.605 1.133c.113 0 .227.113.227.226 0 .227 3.396 23.325 3.396 23.325l-9.737 2.151L0 28.876s2.265-17.89 2.378-18.456l.006-.042c.107-.754.123-.868 1.013-1.09.26-.087.513-.174.76-.258.722-.248 1.396-.48 2.07-.648.68-2.604 2.605-7.7 6.68-7.586.567 0 1.246.226 1.7.906h.112c1.699 0 2.718 1.472 3.284 3.057.566-.226.906-.34.906-.34.023 0 .054-.004.092-.01.152-.021.406-.058.587.124.227.113 1.925 1.811 1.925 1.811s2.378.227 2.604.227zm-10.643 9.058l1.246-3.623s-.793-.567-2.718-.453c-4.19 0-6.34 2.83-6.34 5.774 0 1.969 1.104 2.869 2.074 3.66.759.618 1.436 1.17 1.436 2.115 0 .566-.34 1.245-1.246 1.245-1.359 0-2.944-1.359-2.944-1.359l-.792 2.718s1.585 1.925 4.642 1.925c2.604 0 4.529-1.925 4.529-4.982 0-2.345-1.597-3.514-2.845-4.427-.8-.587-1.458-1.068-1.458-1.688 0-.34.114-1.471 2.038-1.471a5.37 5.37 0 012.378.566z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M39.176 18.686c-1.019-.566-1.472-1.02-1.472-1.585 0-.793.68-1.246 1.812-1.246 1.245 0 2.378.566 2.378.566l.906-2.717s-.793-.68-3.17-.68c-3.398 0-5.662 1.925-5.662 4.643 0 1.585 1.132 2.717 2.49 3.51 1.133.68 1.586 1.132 1.586 1.811 0 .68-.566 1.36-1.698 1.36-1.585 0-3.17-.793-3.17-.793l-.907 2.717s1.36.906 3.737.906c3.397 0 5.888-1.699 5.888-4.756 0-1.698-1.246-2.944-2.718-3.736zm13.7-5.775c-1.698 0-3.056.793-4.075 2.038l1.471-7.699h-3.85l-3.736 19.588h3.85l1.246-6.68c.453-2.491 1.811-4.076 3.057-4.076.906 0 1.245.566 1.245 1.472 0 .566 0 1.132-.113 1.698l-1.472 7.7h3.85l1.472-7.927c.113-.792.226-1.811.226-2.49 0-2.265-1.132-3.624-3.17-3.624zm9.851 11.21c-1.358 0-1.811-1.133-1.811-2.491 0-2.152 1.132-5.775 3.17-5.775 1.359 0 1.812 1.132 1.812 2.265 0 2.49-1.132 6-3.17 6zm1.925-11.21c-4.642 0-7.7 4.19-7.7 8.832 0 2.944 1.813 5.322 5.323 5.322 4.529 0 7.586-4.077 7.586-8.832 0-2.718-1.586-5.322-5.209-5.322zm11.323 11.323c-1.02 0-1.585-.566-1.585-.566l.68-3.623c.452-2.378 1.698-3.963 3.056-3.963 1.132 0 1.585 1.132 1.585 2.15-.113 2.492-1.585 6.002-3.736 6.002zM79.71 12.91c-2.604 0-4.076 2.265-4.076 2.265l.227-2.038h-3.397c-.113 1.358-.453 3.51-.793 5.095l-2.717 14.04h3.85l1.019-5.661h.113s.793.453 2.264.453c4.53 0 7.473-4.643 7.473-9.285 0-2.491-1.132-4.869-3.963-4.869zm9.398-5.435c-1.245 0-2.151 1.02-2.151 2.265 0 1.132.68 1.925 1.811 1.925 1.246 0 2.265-.793 2.265-2.265 0-1.132-.793-1.925-1.925-1.925zm-5.321 19.362h3.85l2.603-13.587h-3.85l-2.603 13.587zm16.191-13.587h-2.718l.114-.68c.226-1.358 1.019-2.49 2.264-2.49.68 0 1.246.226 1.246.226l.792-3.057s-.679-.34-2.038-.34c-1.358 0-2.717.34-3.736 1.246-1.359 1.132-1.925 2.717-2.265 4.302l-.113.68h-1.812l-.566 2.944h1.812L90.92 26.838h3.85l2.038-10.756h2.604l.566-2.831zm9.171 0s-2.377 6.001-3.51 9.284c-.113-1.018-.906-9.284-.906-9.284h-4.076l2.265 12.455c0 .226 0 .453-.113.68-.453.905-1.246 1.698-2.038 2.264-.68.566-1.586.906-2.152 1.132l1.02 3.284c.792-.114 2.377-.793 3.736-2.039 1.698-1.585 3.397-4.189 4.982-7.586L113 13.364l-3.85-.113z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "28",
                height: "33",
                viewBox: "0 0 28 33",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.199 1.953c-.133-.077-.239-.138-.404-.138-2.944 0-4.53 3.85-5.322 6.114l2.49-.68c.68-3.17 2.039-4.641 3.398-5.207-.061-.03-.114-.061-.162-.09zm1.294 3.712a7.897 7.897 0 00-.453-2.718c-1.019.453-2.151 1.472-2.83 3.85l3.283-.906v-.226zm1.019-.227l1.472-.453c-.34-1.132-1.02-2.15-1.812-2.377.227.679.34 1.472.34 2.49v.34zm8.605 1.133c.113 0 .227.113.227.226 0 .227 3.396 23.325 3.396 23.325l-9.737 2.151L0 28.876s2.265-17.89 2.378-18.456l.006-.042c.107-.754.123-.868 1.013-1.09.26-.087.513-.174.76-.258.722-.248 1.396-.48 2.07-.648.68-2.604 2.605-7.7 6.68-7.586.567 0 1.246.226 1.7.906h.112c1.699 0 2.718 1.472 3.284 3.057.566-.226.906-.34.906-.34.023 0 .054-.004.092-.01.152-.021.406-.058.587.124.227.113 1.925 1.811 1.925 1.811s2.378.227 2.604.227zm-10.643 9.058l1.246-3.623s-.793-.567-2.718-.453c-4.19 0-6.34 2.83-6.34 5.774 0 1.969 1.104 2.869 2.074 3.66.759.618 1.436 1.17 1.436 2.115 0 .566-.34 1.245-1.246 1.245-1.359 0-2.944-1.359-2.944-1.359l-.792 2.718s1.585 1.925 4.642 1.925c2.604 0 4.529-1.925 4.529-4.982 0-2.345-1.597-3.514-2.845-4.427-.8-.587-1.458-1.068-1.458-1.688 0-.34.114-1.471 2.038-1.471a5.37 5.37 0 012.378.566z",
                    fill: "#fff"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Vercel.tsx

function Vercel() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "129",
                height: "30",
                viewBox: "0 0 129 30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Vercel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M64.317 8.05969C59.3144 8.05969 55.7076 11.3222 55.7076 16.2159C55.7076 21.1097 59.7676 24.3722 64.7701 24.3722C67.7924 24.3722 70.4568 23.1759 72.1062 21.1595L68.6398 19.1567C67.7245 20.1581 66.3334 20.7427 64.7701 20.7427C62.5996 20.7427 60.7554 19.6098 60.0712 17.7973H72.7677C72.8674 17.2899 72.9263 16.7642 72.9263 16.2114C72.9263 11.3222 69.3195 8.05969 64.317 8.05969ZM60.0304 14.63C60.5968 12.822 62.1465 11.6847 64.3124 11.6847C66.4829 11.6847 68.0326 12.822 68.5945 14.63H60.0304ZM113.109 8.05969C108.107 8.05969 104.5 11.3222 104.5 16.2159C104.5 21.1097 108.56 24.3722 113.563 24.3722C116.585 24.3722 119.249 23.1759 120.899 21.1595L117.432 19.1567C116.517 20.1581 115.126 20.7427 113.563 20.7427C111.392 20.7427 109.548 19.6098 108.864 17.7973H121.56C121.66 17.2899 121.719 16.7642 121.719 16.2114C121.719 11.3222 118.112 8.05969 113.109 8.05969ZM108.827 14.63C109.394 12.822 110.944 11.6847 113.109 11.6847C115.28 11.6847 116.83 12.822 117.391 14.63H108.827ZM91.142 16.2159C91.142 18.9347 92.9182 20.7472 95.6732 20.7472C97.5401 20.7472 98.9402 19.8998 99.6607 18.5178L103.141 20.5252C101.7 22.9267 98.9991 24.3722 95.6732 24.3722C90.6662 24.3722 87.0638 21.1097 87.0638 16.2159C87.0638 11.3222 90.6707 8.05969 95.6732 8.05969C98.9991 8.05969 101.695 9.50516 103.141 11.9067L99.6607 13.9141C98.9402 12.532 97.5401 11.6847 95.6732 11.6847C92.9227 11.6847 91.142 13.4972 91.142 16.2159ZM128.516 3.07532V23.9191H124.438V3.07532H128.516ZM17.1512 0.809692L33.8941 29.8097H0.408203L17.1512 0.809692ZM59.0109 3.07532L46.4548 24.8253L33.8987 3.07532H38.6066L46.4548 16.6691L54.3029 3.07532H59.0109ZM85.7045 8.51282V12.9036C85.2513 12.7722 84.771 12.6816 84.2544 12.6816C81.6218 12.6816 79.7232 14.4941 79.7232 17.2128V23.9191H75.6451V8.51282H79.7232V12.6816C79.7232 10.3797 82.4012 8.51282 85.7045 8.51282Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#Vercel_svg__clip0)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M19.665 5.222L36.33 34.055H3L19.665 5.222z",
                            fill: "#F8F9FB"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "Vercel_svg__clip0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                transform: "translate(3 3)",
                                d: "M0 0h33.33v33.33H0z"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Commercetools.tsx

function Commercetools() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "217",
                height: "32",
                viewBox: "0 0 217 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "commercetools"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M204.016 4.15h-2.842v20.18h2.842V4.15zm-40.396 7.733h4.029v-2.41h-4.029v-3.31h-2.913v3.382l-2.123.252v2.05h2.123v7.914c0 2.77 1.295 4.533 4.748 4.676.503 0 1.762-.036 2.626-.18l-.18-2.518c-.827.108-1.691.18-2.554.108-1.547-.215-1.727-1.259-1.727-2.77v-7.194zM42.106 22.027c1.188 0 1.87-.072 3.382-.395l.36 2.518c-1.152.323-2.447.467-3.742.467-5.791 0-7.446-3.633-7.446-7.842.036-4.136 2.518-7.59 7.41-7.59 1.295 0 2.41.144 3.742.504l-.504 2.518c-1.439-.324-2.266-.36-3.166-.36-3.057.036-4.568 2.338-4.64 4.964.036 2.626 1.007 5.216 4.604 5.216zm11.835.036c3.022-.036 4.029-2.482 4.029-5.144-.036-2.446-1.043-5.18-4.029-5.18-2.914.036-4.029 2.734-4.029 5.18-.036 2.77 1.187 5.144 4.029 5.144zm0-12.842c4.748.036 6.87 3.561 6.87 7.698 0 4.03-1.834 7.662-6.906 7.698-4.964-.036-6.87-3.633-6.87-7.698 0-4.137 2.158-7.662 6.906-7.698zm26.547 5.612V24.366h2.95v-9.713c0-1.619-.108-5.504-4.928-5.432-1.367.036-3.166.648-4.389 1.799-.683-1.115-1.87-1.835-3.92-1.799-1.547 0-2.986.828-3.885 1.547V9.51h-2.914v14.857h2.913V13.25c1.152-.827 2.483-1.475 3.418-1.475 1.51 0 2.23.576 2.23 2.986v9.605h2.95v-10c0-.217-.036-.828-.072-1.152 1.043-.863 2.194-1.439 3.237-1.439 1.511 0 2.41.648 2.41 3.058zm23.238 9.496v-9.496c0-2.41-.899-3.058-2.41-3.058-1.043 0-2.194.576-3.238 1.44.036.323.072.934.072 1.15v10H95.2v-9.604c0-2.41-.719-2.986-2.23-2.986-.935 0-2.266.648-3.417 1.475v11.116h-2.914V9.509h2.914v1.26c.9-.72 2.338-1.548 3.885-1.548 2.05-.036 3.237.684 3.921 1.799 1.223-1.151 3.022-1.763 4.389-1.799 4.82-.072 4.928 3.813 4.928 5.432v9.713h-2.95v-.037zm14.713-9.136h-6.511c.252-2.159 1.295-3.67 3.49-3.634 1.402 0 2.913.612 3.021 3.634zm2.338 8.849l-.431-2.41c-1.619.36-2.842.503-4.029.467-2.914 0-4.497-1.762-4.533-4.676h9.353l.036-1.547c-.036-4.784-2.59-6.655-5.612-6.655-4.928 0-6.654 3.67-6.654 7.59 0 3.957 1.439 7.878 7.302 7.878 1.439 0 3.237-.216 4.568-.647zm11.187-11.835a8.289 8.289 0 00-1.906-.216c-1.835-.036-2.77.864-3.454 1.583v10.792h-2.913V9.509h2.913v1.331a4.904 4.904 0 013.418-1.51 6.404 6.404 0 012.446.395c0-.036-.504 2.482-.504 2.482zm11.943 9.425c-1.511.323-2.194.395-3.381.395-3.597 0-4.569-2.59-4.604-5.216.071-2.626 1.582-4.928 4.64-4.964.899 0 1.727.036 3.165.36l.504-2.518a13.567 13.567 0 00-3.741-.504c-4.856 0-7.374 3.454-7.41 7.59 0 4.21 1.654 7.842 7.446 7.842 1.295 0 2.59-.144 3.741-.467l-.36-2.518zm4.569-6.44h6.511c-.108-3.021-1.619-3.633-3.022-3.633-2.194-.036-3.238 1.475-3.489 3.634zm8.417 6.44l.432 2.41c-1.331.431-3.13.647-4.569.647-5.863 0-7.302-3.92-7.302-7.878 0-3.92 1.727-7.59 6.655-7.59 3.021 0 5.575 1.87 5.611 6.655l-.036 1.547h-9.352c.036 2.914 1.618 4.676 4.532 4.676 1.187.036 2.41-.108 4.029-.467zm19.281.431c3.021-.036 4.028-2.482 4.028-5.144-.036-2.446-1.043-5.18-4.028-5.18-2.914.036-4.029 2.734-4.029 5.18-.036 2.77 1.187 5.144 4.029 5.144zm0-12.842c4.748.036 6.87 3.561 6.87 7.698 0 4.03-1.834 7.662-6.906 7.698-4.965-.036-6.871-3.633-6.871-7.698.036-4.137 2.158-7.662 6.907-7.698zm19.82 7.698c0 2.662-1.007 5.108-4.029 5.144-2.841 0-4.064-2.374-4.028-5.144 0-2.446 1.115-5.144 4.028-5.18 2.986 0 3.993 2.734 4.029 5.18zm2.842 0c0-4.137-2.122-7.662-6.871-7.698-4.748.036-6.87 3.561-6.906 7.698 0 4.065 1.906 7.662 6.871 7.698 5.072-.036 6.906-3.669 6.906-7.698zm12.339 5.18c-.971 0-2.554-.216-4.209-.647l-.611 2.518c1.51.54 3.561.683 4.82.72 3.993.035 5.288-2.123 5.36-4.102.138-3.013-2.457-4.092-4.416-4.906l-.225-.094c-1.978-.791-2.77-1.33-2.734-2.338.072-1.187 1.044-1.583 2.303-1.583 1.115 0 2.302.18 3.849.54l.503-2.446a20.798 20.798 0 00-4.209-.576c-4.388-.144-5.215 2.554-5.251 3.921-.072 2.734 2.086 3.85 4.064 4.676l.439.177c1.567.629 2.829 1.135 2.763 2.486-.108 1.402-1.295 1.654-2.446 1.654z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.098 24.186a.64.64 0 000 1.15l12.59 5.9c.18.072.36.108.54.108v-13.13c-.18 0-.36.036-.54.108l-12.59 5.864z",
                        fill: "#9DA6C7",
                        fillOpacity: ".6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.191 18.214v13.13c.18 0 .396-.036.576-.108l12.554-5.863a.64.64 0 000-1.151l-12.554-5.864a1.234 1.234 0 00-.576-.144z",
                        fill: "#9DA6C7",
                        fillOpacity: ".8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M.702 6.991a.64.64 0 00.36.576l12.59 5.899c.18.072.36.108.54.108.144 0 .323-.036.467-.072.108-.072.108-.036.36-.18 1.295-.611.432-.216 12.303-5.755a.64.64 0 000-1.152L14.767.552a1.402 1.402 0 00-1.079 0L1.134 6.379a.646.646 0 00-.432.612z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.192 14.33v3.92c-.18 0-.36.036-.54.108L1.098 24.186a.64.64 0 00-.36.575V6.991a.64.64 0 00.36.576l12.59 5.899c.18.072.36.108.54.108.144 0 .324-.036.467-.072h-.036c-.395.18-.467.36-.467.827z",
                        fill: "#9DA6C7",
                        fillOpacity: ".4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: 40,
                height: 40,
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M33.323 27.852l-12.96-6.038a1.935 1.935 0 00-.328-.114v-3.669c0-.358.012-.364.245-.471l.513-.239c.871-.406.871-.406 5.979-2.798l6.55-3.067c.383-.179.627-.56.621-.979 0-.417-.244-.805-.626-.978L20.364 3.461a1.736 1.736 0 00-1.48 0l-12.96 6.02a1.09 1.09 0 00-.626.973v18.358c0 .418.245.806.62.979l12.978 6.074c.053.024.4.167.752.167.34 0 .68-.137.74-.167l12.94-6.056c.383-.18.627-.561.621-.979 0-.417-.244-.8-.626-.978zm-27.195-.114V11.534l12.774 5.978c.107.048.215.09.328.113.006 0 .006.006.012.006-.018.12-.03.25-.03.394V21.688c-.006 0-.018.006-.024.006a1.55 1.55 0 00-.304.108L6.128 27.738zm.149-17.511l12.959-6.02a.905.905 0 01.787 0l12.96 6.044a.257.257 0 010 .465l-6.552 3.067c-5.107 2.393-5.107 2.393-5.978 2.792l-.49.227a.718.718 0 01-.107.03c-.018.006-.035.012-.047.012-.054.012-.114.012-.173.012a.854.854 0 01-.382-.09L6.27 10.692a.214.214 0 01-.06-.042.29.29 0 01-.09-.196.268.268 0 01.156-.227zM6.27 29.045a.257.257 0 01-.15-.233c0-.024.007-.047.013-.071a.247.247 0 01.137-.161l12.935-6.014V35.1L6.271 29.045zm26.706.024l-12.942 6.056V22.572l12.942 6.032c.09.041.149.13.149.232a.27.27 0 01-.15.233z",
                        fill: "#9DA6C7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.648 36.33c-.424 0-.83-.173-.872-.19L5.794 30.06A1.37 1.37 0 015 28.811V10.454c.006-.537.322-1.02.8-1.241l12.959-6.02a2.041 2.041 0 011.73 0L33.442 9.23a1.375 1.375 0 01.006 2.494l-6.551 3.067c-5.107 2.393-5.107 2.393-5.978 2.798l-.514.24c-.03.011-.047.023-.071.029-.006.048-.006.125-.006.167v3.449c.053.017.107.041.155.065l12.959 6.038c.483.227.8.716.8 1.247a1.368 1.368 0 01-.794 1.247l-12.935 6.062a2.252 2.252 0 01-.865.197zm-.627-.734s.316.137.627.137c.268 0 .56-.113.608-.137l12.947-6.056a.772.772 0 00.448-.704.783.783 0 00-.454-.71l-12.959-6.044a1.555 1.555 0 00-.28-.095l-.22-.06v-3.902c0-.441.047-.573.417-.74l.513-.238c.871-.406.871-.406 5.978-2.799l6.551-3.066a.772.772 0 00.448-.705.777.777 0 00-.454-.71L20.238 3.73a1.43 1.43 0 00-1.229 0L6.05 9.75a.785.785 0 00-.453.705v18.358c0 .299.179.585.447.71l12.977 6.074zm.716 0v-13.49l13.365 6.229a.55.55 0 01.018.996l-.012.006-13.37 6.26zm.597-12.56v11.617l12.464-5.835-12.464-5.781zm-.83 12.536L6.146 29.313a.55.55 0 01-.323-.5c0-.06.012-.108.024-.144a.537.537 0 01.305-.358l13.358-6.21v13.471h-.006zM6.48 28.812l12.428 5.818v-11.6L6.48 28.813zm-.65-.608V11.062l13.197 6.175c.06.03.15.066.233.084l.322.006-.054.34c-.018.107-.024.22-.024.352v3.914l-.214.036-.06.018c-.072.018-.15.047-.227.083L5.83 28.204zm.596-16.2v15.269l12.333-5.74c.053-.024.101-.048.155-.065v-3.443c0-.066 0-.125.006-.185-.054-.018-.096-.042-.138-.06L6.426 12.005zm13.21 5.15c-.18 0-.358-.042-.513-.12L6.146 10.962a.575.575 0 01-.316-.49c.011-.25.143-.435.327-.519l12.96-6.02a1.23 1.23 0 011.044 0L33.12 9.976a.55.55 0 010 1.003l-6.563 3.072c-5.107 2.393-5.107 2.393-5.979 2.793l-.489.226c-.083.03-.131.048-.185.054l-.03.006v.006c-.09.018-.167.018-.238.018zm-13.198-6.67l12.941 6.014c.12.06.298.071.364.053l.066-.006c.018-.012.041-.018.06-.024l.459-.214c.87-.4.87-.4 5.978-2.793l6.474-3.03-12.882-6.009a.594.594 0 00-.53 0l-12.93 6.008z",
                        fill: "#9DA6C7"
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Postman.tsx

function Postman() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "130",
                height: "40",
                viewBox: "0 0 130 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Postman"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M49.645 13.47h-3.207a.495.495 0 00-.411.151.452.452 0 00-.174.347v11.374a.4.4 0 00.239.368.922.922 0 00.996 0 .4.4 0 00.239-.368v-4.398h2.21a3.911 3.911 0 002.643-.889 3.585 3.585 0 00.996-2.794v-.152c.087-.997-.238-2.015-.931-2.751a3.48 3.48 0 00-2.6-.889zm2.21 3.899c.043.65-.174 1.3-.585 1.798a2.298 2.298 0 01-1.712.65h-2.21v-5.07h2.21c.607-.043 1.213.196 1.668.607.434.498.65 1.148.585 1.798l.044.217zm7.366-3.076a3.633 3.633 0 00-.997 2.816v5.113a3.662 3.662 0 00.997 2.816 4.42 4.42 0 005.33 0 3.482 3.482 0 00.996-2.816v-5.07a3.573 3.573 0 00-.997-2.86c-1.581-1.191-3.77-1.191-5.33 0zm4.896 7.929a2.409 2.409 0 01-.585 1.82c-.433.433-1.04.65-1.646.606-1.495 0-2.21-.823-2.21-2.426v-5.07c0-1.603.736-2.426 2.21-2.426a2.119 2.119 0 011.646.606c.433.499.65 1.149.585 1.799v5.09zm11.85-3.033c-.563-.238-1.104-.477-1.646-.672a4.27 4.27 0 01-1.408-.78 1.522 1.522 0 01-.542-1.278 1.447 1.447 0 01.65-1.343 2.963 2.963 0 011.647-.412 3.35 3.35 0 011.581.325c.239.108.499.217.758.303a.474.474 0 00.434-.281c.087-.152.173-.325.173-.52 0-.347-.325-.628-.975-.845a6.98 6.98 0 00-2.015-.303c-.433 0-.866.043-1.3.151a4.73 4.73 0 00-1.191.477c-.39.238-.693.585-.91.997a3.495 3.495 0 00-.347 1.56 3.006 3.006 0 00.564 1.863c.368.476.845.845 1.408 1.104.563.239 1.105.456 1.646.65.52.195.997.499 1.409.889.39.411.585.953.563 1.516a2 2 0 01-.628 1.582c-.499.39-1.105.563-1.734.541a2.972 2.972 0 01-1.234-.216c-.304-.087-.564-.26-.802-.477l-.542-.52a.703.703 0 00-.39-.216.575.575 0 00-.411.238.914.914 0 00-.195.541c0 .412.346.824 1.105 1.235.78.455 1.668.672 2.556.65a4.081 4.081 0 002.708-.888 3.381 3.381 0 001.018-2.643c.087-1.343-.693-2.643-1.95-3.228zm13.628-5.72h-6.911a.426.426 0 00-.369.195.78.78 0 000 .91.482.482 0 00.369.195h2.751v10.573a.42.42 0 00.217.368.922.922 0 00.996 0c.152-.065.217-.217.217-.368V14.769h2.708a.364.364 0 00.368-.195c.087-.13.152-.303.13-.455a.78.78 0 00-.13-.433c-.065-.152-.195-.217-.346-.217zm13.714 0c-.434 0-.802.304-1.105.91l-2.687 5.113-2.664-5.113c-.304-.606-.694-.91-1.105-.91h-.304a.649.649 0 00-.52.715V25.32a.41.41 0 00.239.39.85.85 0 00.52.13c.173 0 .325-.065.476-.152.152-.065.217-.216.217-.368v-8.97l2.578 4.897a.553.553 0 00.52.412.637.637 0 00.563-.412l2.578-4.81v8.861a.42.42 0 00.217.369c.303.173.693.173.997 0 .151-.065.216-.217.216-.369V14.141a.236.236 0 000-.173c-.086-.325-.411-.564-.736-.499zm9.965 0c-.476 0-.78.174-.866.477l-3.488 11.2a.136.136 0 000 .13c0 .196.108.369.281.456.174.108.369.173.585.173a.473.473 0 00.52-.325l.737-2.47h4.398l.736 2.47c.065.217.304.347.52.325a.871.871 0 00.607-.173.424.424 0 00.282-.412l-4.312-11.85zm4.312 11.808v-.065l-3.467-11.244c-.086-.325-.368-.477-.845-.477l4.312 11.786zm-6.218-3.402l1.885-6.348 1.906 6.348h-3.791zm18.415-8.297a1.02 1.02 0 00-.997 0 .419.419 0 00-.216.368v8.71l-4.225-8.277a2.21 2.21 0 00-.476-.693.873.873 0 00-.607-.217c-.477 0-.715.174-.715.499v11.374a.35.35 0 00.217.368.921.921 0 00.996 0 .42.42 0 00.217-.368v-8.623l4.398 8.536c.151.368.498.628.888.65a.959.959 0 00.52-.152.447.447 0 00.217-.368V13.968a.455.455 0 00-.217-.39zM22.218.167C11.407-1.24 1.549 6.407.163 17.217c-1.387 10.811 6.24 20.69 17.05 22.077 10.81 1.386 20.668-6.261 22.076-17.05C40.676 11.433 33.05 1.554 22.217.167c.022 0 .022 0 0 0zm4.073 12.284c-.369.022-.715.152-.975.412l-7.323 7.322-1.56-1.56c7.214-7.192 8.514-7.257 9.858-6.174zm-7.995 7.994l7.301-7.236c.412-.39 1.04-.39 1.452 0 .195.195.303.477.303.737-.022.282-.13.542-.347.736l-7.712 6.803-.997-1.04zm.542 1.105l-1.82.455c-.043.022-.065.022-.108 0-.022-.043-.022-.086 0-.108l1.105-1.105.823.758zm-4.615-.758l1.928-1.928 1.452 1.495-3.315.715c-.065.021-.152-.044-.152-.109-.021-.043 0-.086.044-.108l.043-.065zm-5.98 10.03c-.043-.02-.086-.043-.108-.086a.138.138 0 010-.13l1.56-1.56 2.015 1.994-3.466-.217zm3.987-2.079c-.152.087-.238.238-.195.412l.325 1.43a.24.24 0 01-.087.238.17.17 0 01-.238 0l-2.015-2.08 6.175-6.196 2.99-.65 1.43 1.43A40.015 40.015 0 0112.23 28.7v.043zm8.688-5.633l-1.365-1.365 7.712-6.78c.065-.066.152-.13.195-.217-.26 2.188-3.358 5.33-6.542 8.362zm6-10.616a3.008 3.008 0 01.087-4.246 3.001 3.001 0 013.943-.173l-2.643 2.643a.228.228 0 000 .281l2.058 2.059a3.034 3.034 0 01-3.466-.585l.022.021zm4.247 0c-.152.13-.282.26-.455.369L28.74 10.89l2.513-2.513c1.083 1.148 1.061 2.968-.087 4.116z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M22.218.167C11.407-1.24 1.549 6.407.163 17.217c-1.387 10.811 6.24 20.69 17.05 22.077 10.81 1.386 20.668-6.261 22.076-17.05C40.676 11.433 33.05 1.554 22.217.167c.022 0 .022 0 0 0zm4.073 12.284c-.369.022-.715.152-.975.412l-7.323 7.322-1.56-1.56c7.214-7.192 8.514-7.257 9.858-6.174zm-7.995 7.994l7.301-7.236c.412-.39 1.04-.39 1.452 0 .195.195.303.477.303.737-.022.282-.13.542-.347.736l-7.712 6.803-.997-1.04zm.542 1.105l-1.82.455c-.043.022-.065.022-.108 0-.022-.043-.022-.086 0-.108l1.105-1.105.823.758zm-4.615-.758l1.928-1.928 1.452 1.495-3.315.715c-.065.021-.152-.044-.152-.109-.021-.043 0-.086.044-.108l.043-.065zm-5.98 10.03c-.043-.02-.086-.043-.108-.086a.138.138 0 010-.13l1.56-1.56 2.015 1.994-3.466-.217zm3.987-2.079c-.152.087-.238.238-.195.412l.325 1.43a.24.24 0 01-.087.238.17.17 0 01-.238 0l-2.015-2.08 6.175-6.196 2.99-.65 1.43 1.43A40.015 40.015 0 0112.23 28.7v.043zm8.688-5.633l-1.365-1.365 7.712-6.78c.065-.066.152-.13.195-.217-.26 2.188-3.358 5.33-6.542 8.362zm6-10.616a3.008 3.008 0 01.087-4.246 3.001 3.001 0 013.943-.173l-2.643 2.643a.228.228 0 000 .281l2.058 2.059a3.034 3.034 0 01-3.466-.585l.022.021zm4.247 0c-.152.13-.282.26-.455.369L28.74 10.89l2.513-2.513c1.083 1.148 1.061 2.968-.087 4.116z",
                    fill: "#fff"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/ServiceNow.tsx

function ServiceNow() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "158",
                height: "24",
                viewBox: "0 0 158 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ServiceNow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M61.717.048c.026.126.117.143.226.163l.013.002c1.401.285 2.32 1.419 2.21 2.724a2.706 2.706 0 01-2.505 2.508 2.705 2.705 0 01-2.772-2.104c-.267-1.365.497-2.622 1.84-3.09a.578.578 0 01.173-.021c.131-.004.264-.008.325-.184l.49.002zM0 20.914c.488-.381.795-.896 1.1-1.41.134-.223.268-.447.416-.66.331-.463.51-.672 1.103-.248a5.655 5.655 0 004.215 1.039c.636-.093 1.194-.376 1.325-1.054.131-.707-.368-1.095-.934-1.385-.637-.326-1.312-.556-1.988-.787-.65-.222-1.3-.444-1.914-.75-1.615-.802-2.622-1.988-2.6-3.84.023-1.897 1.06-3.22 2.71-3.986 2.788-1.298 5.508-.903 8.117.596.307.176.381.331.15.618-.15.186-.279.388-.407.59l-.145.227c-.108.162-.204.339-.301.515-.218.397-.434.792-.768 1.02-.364.248-.682.022-1.013-.214-.2-.141-.403-.286-.625-.334-.93-.202-1.83-.373-2.747.015-.43.182-.769.454-.792.95-.023.498.307.82.736.987.497.194 1 .375 1.503.556.737.265 1.473.53 2.191.837 3.009 1.285 4.022 4.615 2.107 6.902-.932 1.116-2.196 1.703-3.616 1.963-2.561.47-4.912-.096-7.107-1.428-.15-.09-.304-.172-.458-.254-.085-.045-.17-.09-.255-.137L0 20.914zm143.936-4.699l.793-2.105.063.167.004.012c.848 2.235 1.639 4.32 2.436 6.385.079.208.145.436.21.663.157.55.315 1.1.679 1.404.361.306.89.252 1.43.197.302-.03.608-.062.89-.031.556.068.803-.138 1.007-.663 1.033-2.651 2.09-5.293 3.146-7.936h.001c.373-.935.747-1.868 1.119-2.803.532-1.335 1.064-2.67 1.62-4.072-.349 0-.689.004-1.023.008-.764.008-1.494.017-2.221-.023-.679-.04-.995.166-1.237.829a298.345 298.345 0 01-2.225 5.814l-.001.002c-.275.704-.553 1.415-.832 2.136-.053-.12-.101-.224-.144-.318a7.92 7.92 0 01-.203-.47c-.347-.924-.693-1.85-1.038-2.775l-.002-.006-.008-.02v-.001l-.001-.001v-.001l-.001-.001c-.367-.984-.734-1.967-1.103-2.95a7.793 7.793 0 01-.206-.67c-.152-.55-.305-1.103-.667-1.404-.345-.289-.851-.238-1.371-.185-.322.033-.65.067-.949.02-.891-.141-1.216.275-1.491 1.043-.668 1.878-1.379 3.738-2.09 5.602l-.005.013c-.255.668-.511 1.336-.764 2.006-.191-.092-.235-.23-.276-.359a1.14 1.14 0 00-.029-.085c-.979-2.553-1.965-5.1-2.959-7.64-.015-.04-.029-.083-.043-.125-.073-.224-.146-.447-.52-.447-.885.02-1.77.016-2.682.013-.357-.002-.717-.003-1.084-.003l.09.268.001.004.003.009.001.005c.059.179.109.332.169.481a6252.24 6252.24 0 005.006 12.47c.084.207.154.435.225.665.18.58.361 1.168.759 1.436.365.245.917.205 1.477.165.292-.02.585-.042.856-.023.522.036.755-.134.939-.643.721-2.001 1.472-3.991 2.251-6.057zm-28.94.406c.011-5.165 3.731-9.198 8.331-9.502 4.897-.332 9.039 2.982 9.733 7.786.414 2.871-.474 5.341-2.4 7.465-.965 1.064-1.778 1.128-2.967.331a6.365 6.365 0 00-7.35.078c-.929.663-1.761.626-2.596-.166a8.53 8.53 0 01-2.751-5.992zm9.141 4.01c2.606 0 4.541-1.92 4.553-4.505.011-2.585-2.006-4.7-4.511-4.717a4.599 4.599 0 00-4.571 4.545c-.003 2.756 1.86 4.68 4.529 4.677zM111.609 9.35c-2.072-2.213-5.803-3.357-9.67-.688.456-1.273-.207-1.27-1.004-1.226-.797.043-1.6.03-2.399 0-.434-.017-.558.127-.558.556.013 4.79.013 9.58 0 14.372 0 .432.138.57.567.558.964-.031 1.931-.051 2.892 0 .621.033.795-.137.787-.765a209.19 209.19 0 01-.011-3.716v-.001c.004-1.554.008-3.107-.03-4.66-.019-.89.301-1.47.994-1.906 1.358-.853 2.808-1.359 4.363-.598 1.468.717 1.707 2.066 1.684 3.547-.023 1.455-.019 2.912-.016 4.368v.004c.002 1.034.004 2.068-.003 3.1-.003.432.065.644.574.624a53.754 53.754 0 013.058 0c.417.01.583-.076.583-.538-.018-1.085-.011-2.17-.003-3.256.013-1.87.026-3.741-.093-5.611-.101-1.56-.61-2.984-1.715-4.165zm-90.37 6.829h-.001c-1.154.003-2.308.006-3.461-.013-.515-.008-.58.133-.462.613.558 2.267 2.967 3.574 5.372 2.886a5.273 5.273 0 002.273-1.279c.28-.273.447-.296.723 0 .54.583 1.098 1.16 1.684 1.69.343.313.249.497-.034.777-2.217 2.24-6.296 3.058-9.293 1.84-2.957-1.199-4.804-4.072-4.814-7.47-.01-3.724 2.01-6.76 5.174-7.786 4.407-1.428 8.893 1.41 9.564 6.052.11.675.166 1.357.166 2.041-.01.477-.166.663-.68.663-1.205-.027-2.407-.023-3.608-.02h-.001l-1.271.003c-.444 0-.887.002-1.33.003h-.001zm-.626-3.016c.303 0 .606-.002.91-.004a83.226 83.226 0 011.815.004c.413.01.522-.093.406-.515a3.147 3.147 0 00-2.947-2.224c-1.388-.01-2.927 1.082-3.232 2.273-.1.384.044.472.404.464.573-.006 1.146-.004 1.719-.001l.925.003zm68.92 3.016h.002l1.315-.003 3.315-.002c2.427 0 2.476-.008 2.122-2.458-.401-2.778-1.778-4.963-4.452-6.073-2.674-1.11-5.281-.733-7.511 1.146-2.561 2.157-3.212 5.058-2.636 8.189.562 3.053 2.492 5.13 5.508 5.936 3.123.837 5.994.147 8.425-2.074.316-.295.293-.486 0-.772a32.734 32.734 0 01-1.596-1.657c-.256-.285-.422-.323-.719-.03a5.251 5.251 0 01-2.352 1.304c-2.392.651-4.755-.625-5.336-2.858-.134-.518-.032-.674.518-.662 1.129.022 2.264.018 3.398.014zm-2.154-3.02h-.001c-.539.002-1.08.004-1.626.004.38-1.566 1.556-2.595 3.007-2.716 1.284-.106 2.614.747 3.13 1.965.226.535.215.777-.486.764-1.335-.027-2.67-.022-4.024-.017zM73.62 23.22c-3.535.01-6.754-2.428-7.682-6.033a8.07 8.07 0 013.964-9.084c3.233-1.766 7.403-1.098 9.94 1.56.405.425.498.685-.038 1.076a18.562 18.562 0 00-1.878 1.602c-.358.341-.532.331-.895-.038-2.169-2.232-5.667-1.733-6.998.966a4.17 4.17 0 001.223 5.228c1.589 1.2 3.958 1.095 5.495-.243.994-.867.994-.867 2.071-.04.142.108.28.222.418.337.287.237.575.476.897.657.789.436.597.828.095 1.352-1.731 1.782-3.824 2.699-6.612 2.66zM57.737 8.101c.103-.185.213-.38.147-.66-.34 0-.68.003-1.021.005-.834.005-1.67.011-2.508-.016-.493-.017-.722.16-.916.596a703.757 703.757 0 01-3.644 8.063c-.023.048-.04.1-.057.154-.056.174-.115.359-.37.408-1.29-2.864-2.588-5.724-3.896-8.58a1.637 1.637 0 01-.063-.175c-.071-.22-.147-.453-.48-.453h-4.008c.064.15.117.281.166.4v.001c.069.171.129.318.194.46.566 1.23 1.141 2.454 1.715 3.68 1.399 2.98 2.796 5.959 4.073 8.99.66 1.56 1.447 2.223 3.123 1.97.53-.08.807-.205 1.027-.69 1.358-2.98 2.73-5.955 4.102-8.93l.003-.006c.777-1.686 1.555-3.372 2.33-5.06.024-.052.053-.104.083-.157zm-23.823.69c1.522-1.147 3.118-1.537 4.839-1.542.58 0 .845.155.802.796-.058.871-.03 1.75 0 2.624.011.447-.043.583-.585.497-1.67-.287-3.148.194-4.404 1.325a1.418 1.418 0 00-.475 1.16c.009 1.165.008 2.33.006 3.496-.002 1.65-.003 3.302.024 4.953.013.712-.206.87-.872.828-.932-.058-1.872-.03-2.808 0-.386 0-.521-.104-.521-.497.013-4.84.013-9.681 0-14.522 0-.365.124-.467.475-.46l.198.005c.87.017 1.744.034 2.618-.004.572-.03.819.126.72.712a4.9 4.9 0 00-.017.63zm25.551 4.385a603.7 603.7 0 00-.004 1.903l.002 2.043c.003 1.7.006 3.397-.008 5.087-.005.514.104.73.679.703.923-.039 1.846-.021 2.769-.004l.213.004c.386.008.53-.108.53-.509-.017-4.818-.017-9.635 0-14.453.003-.482-.205-.522-.595-.522-.942.027-1.882.05-2.816 0-.603-.033-.802.115-.79.754.03 1.664.026 3.329.02 4.994z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 23.645C.025 12.45 8.086 3.71 18.057 3.05c10.614-.718 19.59 6.464 21.095 16.876.898 6.223-1.027 11.576-5.203 16.18-2.09 2.305-3.852 2.445-6.43.718a13.792 13.792 0 00-15.928.169c-2.015 1.436-3.817 1.357-5.627-.36A18.505 18.505 0 010 23.645zm19.813 8.69c5.648 0 9.842-4.162 9.867-9.763.025-5.602-4.348-10.187-9.777-10.223a9.967 9.967 0 00-9.907 9.85c-.007 5.974 4.033 10.143 9.817 10.136z",
                    fill: "#9DA6C7"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Atlassian.tsx

function Atlassian() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "144",
                height: "19",
                viewBox: "0 0 144 19",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Atlassian"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.695 1.054a11.343 11.343 0 00-.663 11.199l2.888 5.774a.513.513 0 00.46.279h5.984a.514.514 0 00.46-.745S9.771 1.448 9.568 1.046a.486.486 0 00-.874 0v.008zM5.539 8.871a.5.5 0 00-.85.091l-4.3 8.6a.513.513 0 00.46.745h5.984a.496.496 0 00.463-.288A8.828 8.828 0 005.54 8.87zm84.521 5.175c0-2.524-1.338-3.71-5.115-4.521-2.087-.461-2.59-.922-2.59-1.582 0-.835.746-1.185 2.13-1.185 1.69.054 3.35.466 4.871 1.208V4.65a11.017 11.017 0 00-4.764-.988c-3.733 0-5.665 1.624-5.665 4.281l.006.003c0 2.129.99 3.818 4.852 4.564 2.305.484 2.783.856 2.783 1.624 0 .746-.484 1.23-2.107 1.23a11.894 11.894 0 01-5.598-1.515v3.468a11.453 11.453 0 005.555 1.208c4.036 0 5.642-1.8 5.642-4.478zm40.772-10.164v14.425h3.073V7.312l1.296 2.922 4.347 8.08h3.863V3.882h-3.073v9.309l-1.163-2.7-3.491-6.609h-4.852zm-22.91 0h3.358v14.425h-3.358V3.882zm-3.875 10.162c0-2.525-1.339-3.71-5.114-4.522-2.088-.46-2.59-.922-2.59-1.581 0-.835.745-1.186 2.129-1.186 1.691.055 3.351.466 4.871 1.208V4.65a11.013 11.013 0 00-4.764-.988c-3.733 0-5.665 1.624-5.665 4.281 0 2.13.989 3.821 4.852 4.567 2.305.484 2.784.856 2.784 1.624 0 .746-.485 1.23-2.107 1.23a11.894 11.894 0 01-5.598-1.515v3.468a11.453 11.453 0 005.554 1.208c4.037 0 5.643-1.8 5.643-4.478l.005-.003zm-51.21 4.263V3.882h3.382V15.19h4.61l-1.086 3.118h-6.905zM39.198 3.882v3.114h3.733v11.307h3.38V6.996h3.997V3.878l-11.11.004zm-9.333 0h4.43l5.027 14.425H35.48l-.713-2.429a9.547 9.547 0 01-5.379 0l-.713 2.429h-3.841l5.03-14.425zm.367 9.128a6.56 6.56 0 001.849.265v.003c.625 0 1.248-.088 1.848-.264L32.08 6.717 30.23 13.01zm41.414-9.128h-4.43l-5.03 14.425h3.841l.713-2.429a9.547 9.547 0 005.379 0l.713 2.429h3.84L71.646 3.882zm-2.216 9.393a6.56 6.56 0 01-1.848-.265l1.848-6.296 1.848 6.297c-.6.176-1.222.265-1.848.264zm49.526-9.393h4.43l5.029 14.425h-3.843l-.713-2.429a9.546 9.546 0 01-5.379 0l-.713 2.429h-3.841l5.03-14.425zm.364 9.128a6.566 6.566 0 003.697.001l-1.848-6.297-1.849 6.296z",
                        fill: "#9DA6C7"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.866 18.464a1.139 1.139 0 00-1.936.21L.125 38.28a1.171 1.171 0 001.047 1.698h13.645a1.13 1.13 0 001.057-.657 20.127 20.127 0 00-4.008-20.858zM19.062.643a25.862 25.862 0 00-1.51 25.532l6.584 13.166a1.171 1.171 0 001.047.634h13.645a1.172 1.172 0 001.047-1.697S21.518 1.54 21.055.624a1.107 1.107 0 00-1.993 0v.02z",
                    fill: "#9DA6C7"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/index.ts






















// EXTERNAL MODULE: ./src/components/icons/personas/index.ts + 3 modules
var icons_personas = __webpack_require__(39685);
;// CONCATENATED MODULE: ./src/pages/index.js



































function pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var cloudServices = [
    {
        animationClass: 'tick-1',
        nudge: true,
        group: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(vercel, {}),
                name: 'Vercel',
                description: 'Build and preview your sites with the native Vercel integration',
                hex: '#000000'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(zapier, {}),
                name: 'Zapier',
                description: 'Trigger custom zaps and workflows with webhooks',
                hex: '#FF4A00'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jira, {}),
                name: 'JIRA',
                description: 'Incorporate content changes into your workflow',
                hex: '#0052CC'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(gatsby_cloud, {}),
                name: 'Gatsby Cloud',
                description: "Build and preview your sites with the native Gatsby Cloud Integration",
                hex: '#663399'
            }, 
        ]
    },
    {
        animationClass: 'tick-2',
        group: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(slack_colour, {}),
                name: 'Slack',
                description: 'Configure notifications in Slack when content changes are made',
                hex: '#451B4A'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shopify, {}),
                name: 'Shopify',
                description: 'Display all your products and variations within the GUI',
                hex: '#002E25'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bynder, {}),
                name: 'Bynder',
                description: 'Query all your assets from Bynder and serve them via GraphCMS',
                hex: '#00AAFF'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(asana, {}),
                name: 'Asana',
                description: 'Content management adapting to your preferred workflows',
                hex: '#F6F8F9'
            }, 
        ]
    },
    {
        animationClass: 'tick-3',
        nudge: true,
        group: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(netlify, {}),
                name: 'Netlify',
                description: 'Build and preview your sites with the Netlify integration',
                hex: '#00AD9F'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(webhooks_2, {}),
                name: 'Webhooks',
                description: 'Create more custom integrations with granular webhooks',
                hex: '#6246EA'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_drive, {}),
                name: 'Google Drive',
                description: 'Import assets via your folders and upload to GraphCMS',
                hex: '#F8F9FB'
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(spotify, {}),
                name: 'Spotify',
                description: 'Send an RSS feed of all your podcast episodes to Spotify',
                hex: '#1ED760'
            }, 
        ]
    }, 
];
var forEngineeringSectionLogos = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(React, {}),
        id: 'react'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nextjs, {}),
        id: 'nextjs'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heroku, {}),
        id: 'heroku'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vercel, {}),
        id: 'vercel'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Postman, {}),
        id: 'postman'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AWS, {}),
        id: 'aws'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shopify, {}),
        id: 'shopify'
    }, 
];
var forCreatorsSectionLogos = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Segment, {}),
        id: 'segment'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAnalytics, {}),
        id: 'ga'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Zapier, {}),
        id: 'zapier'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicYield, {}),
        id: 'dy'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hubspot, {}),
        id: 'hubspot'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveCampaign, {}),
        id: 'ac'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slack, {}),
        id: 'slack'
    }, 
];
var forBusinessesSectionLogos = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SAP, {}),
        id: 'sap'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commercetools, {}),
        id: 'commercetools'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Salesforce, {}),
        id: 'salesforce'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Adobe, {}),
        id: 'adobe'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Oracle, {}),
        id: 'oracle'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceNow, {}),
        id: 'service'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Atlassian, {}),
        id: 'atlassian'
    }, 
];
var __N_SSG = true;
function Home(param1) {
    var page = param1.page, ratings = param1.ratings, testimonials = param1.testimonials, preview = param1.preview;
    var refEng = (0,react.useRef)(null);
    var refCreators = (0,react.useRef)(null);
    var refBusinesses = (0,react.useRef)(null);
    var personas = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_personas/* Engineering */.se, {
                className: "text-cornflower"
            }),
            title: 'For Engineering Teams',
            description: 'GraphCMS is the ultimate content platform that enables you to deliver ambitious applications at scale, API first, using your preferred frameworks.',
            theme: 'light',
            anchorTo: function() {
                return (0,lib_scroll/* scrollTo */.X)(refEng);
            },
            anchor: 'GraphCMS for Engineering'
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_personas/* Creators */.y2, {
                className: "text-rose"
            }),
            title: 'For Content Creators',
            description: 'GraphCMS empowers content creators, editors, and marketing teams to create exceptional digital experiences in the way they’ve defined.',
            theme: 'pink',
            anchorTo: function() {
                return (0,lib_scroll/* scrollTo */.X)(refCreators);
            },
            anchor: 'GraphCMS for Creators'
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_personas/* Businesses */.Jl, {
                className: "text-strong-blue"
            }),
            title: 'For Businesses',
            description: 'Inflexible technologies keep your business from innovating. Integrate all your existing services to deliver content from a single source.',
            theme: 'royal',
            anchorTo: function() {
                return (0,lib_scroll/* scrollTo */.X)(refBusinesses);
            },
            anchor: 'GraphCMS for Businesses'
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Vanilla/* default */.Z, {
        seo: page,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-full overflow-hidden sm:pt-12 lg:relative lg:py-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                    page: page
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoReel/* DefaultLogoReel */.x, {
                className: "mt-12 md:mb-24 lg:mt-28"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-white py-12 lg:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto max-w-4xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto w-full space-y-6 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-3xl font-bold leading-tight text-haiti md:text-5xl",
                                        children: "Empowering Teams With Better Content Management"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-3xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-zodiac",
                                            children: "GraphCMS is the Headless CMS allowing you to build digital experiences the way you envisioned them - with all your backends, frontends, and services, working together in harmony."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-x-6 pt-12 md:grid-cols-2 md:pb-6 lg:grid-cols-3 lg:pt-20",
                            children: personas.map(function(persona) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(USPCardRedesigned/* default */.Z, pages_objectSpread({}, persona), persona.title);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-haiti py-12 lg:py-30",
                ref: refEng,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EngineeringTabs, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos, {
                            title: "Works with all your preferred frameworks, backends, and headless APIs",
                            className: "text-white",
                            logos: forEngineeringSectionLogos
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-whisper py-12 lg:py-30",
                ref: refCreators,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatorsTab, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos, {
                            title: "Don’t give up working with your favorite tools and workflows",
                            className: "text-haiti",
                            logos: forCreatorsSectionLogos
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-white py-12 lg:py-30",
                ref: refBusinesses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessesTabs, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos, {
                            title: "Reduce time to market by unifying your stack",
                            className: "text-haiti",
                            logos: forBusinessesSectionLogos
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-whisper py-12 lg:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex md:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:w-2/5 md:flex-shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-6 lg:pr-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                                            title: "Start Building With GraphCMS For Free",
                                            description: "Create a free-forever account today, and begin unifying, structuring, enriching, and distributing your content across devices."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            href: "https://app.graphcms.com/signup",
                                            colour: "purple",
                                            size: "large",
                                            children: "Get Started →"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative -my-6 -mx-6 mt-12 overflow-hidden md:my-0 md:mx-0 md:-mr-96 md:w-4/5 md:py-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ticker absolute left-0 top-0 z-20 hidden h-full w-full md:block"
                                    }),
                                    cloudServices.map(function(param, index) {
                                        var nudge = param.nudge, animationClass = param.animationClass, group = param.group;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()([
                                                'flex-nowrap',
                                                {
                                                    '-ml-12 hidden md:flex': nudge,
                                                    flex: !nudge
                                                }, 
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()([
                                                        'flex items-center justify-center transition md:flex-nowrap',
                                                        animationClass, 
                                                    ]),
                                                    children: group.map(function(service) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "flex w-84 p-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full rounded bg-white px-4 pb-4 shadow-sm",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex items-end pb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                style: {
                                                                                    backgroundColor: service.hex
                                                                                },
                                                                                className: "mr-3 -mt-4 flex h-12 w-12 items-center justify-center rounded-sm",
                                                                                children: service.icon
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "font-medium text-haiti",
                                                                                children: service.name
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-sm text-light-haiti",
                                                                        children: service.description
                                                                    })
                                                                ]
                                                            })
                                                        }, service.name);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()([
                                                        'flex flex-nowrap items-center justify-center transition',
                                                        animationClass, 
                                                    ]),
                                                    children: group.map(function(service) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "flex w-84 p-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full rounded bg-white px-4 pb-4 shadow-sm",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex items-end pb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                style: {
                                                                                    backgroundColor: service.hex
                                                                                },
                                                                                className: "mr-3 -mt-4 flex h-12 w-12 items-center justify-center rounded-sm",
                                                                                children: service.icon
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "font-medium text-haiti",
                                                                                children: service.name
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-sm text-light-haiti",
                                                                        children: service.description
                                                                    })
                                                                ]
                                                            })
                                                        }, service.name);
                                                    })
                                                })
                                            ]
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "relative overflow-hidden bg-haiti",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative z-20 py-12 md:py-30 lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-8 lg:space-y-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "space-y-6 lg:pr-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "text-3xl font-bold leading-snug text-white lg:text-5xl",
                                                    children: [
                                                        "Content",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                            className: "hidden lg:block"
                                                        }),
                                                        " Management That",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                            className: "hidden lg:block"
                                                        }),
                                                        " Scales With You"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-lg text-white",
                                                    children: "With industry leading performance, security, and scalability, GraphCMS is trusted by teams ranging from the Fortune 500, to governments and public services."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-wrap md:flex-nowrap md:space-x-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-1/2 md:w-auto md:flex-initial",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-white",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "block text-2xl font-black uppercase md:text-3xl",
                                                                children: "1B+/m"
                                                            }),
                                                            "API Requests"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-1/2 md:w-auto md:flex-initial",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-white",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "block text-2xl font-black uppercase md:text-3xl",
                                                                children: "40k+"
                                                            }),
                                                            "Active Teams"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6 w-1/2 md:mt-0 md:w-auto md:flex-initial",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-white",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "block text-2xl font-black uppercase md:text-3xl",
                                                                children: '<100ms'
                                                            }),
                                                            "Average Latency"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6 w-1/2 md:mt-0 md:w-auto md:flex-initial",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-white",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "block text-2xl font-black uppercase md:text-3xl",
                                                                children: "99.99%"
                                                            }),
                                                            "Average API Uptime"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " relative z-10 lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute -mt-64 lg:right-0 lg:top-0 lg:-mt-32 lg:-mr-96",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/images/home/globe.svg",
                                        width: 950,
                                        height: 883,
                                        alt: "Globe",
                                        className: "bg-transparent"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-white py-12 lg:py-30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-5xl px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-3xl font-bold leading-snug text-haiti md:text-4xl lg:text-center",
                            children: "Delivering Millions Of Digital Experiences For Over 50,000 Teams Globally"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-10 mx-auto w-full px-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings, {
                                ratings: ratings
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto w-full max-w-3xl pt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                items: testimonials,
                                Component: SliderTestimonial
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-whisper py-12 lg:py-30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-5xl px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-3xl font-bold leading-snug text-haiti md:text-4xl lg:text-center",
                            children: "Get A Quickstart On Building Better Digital Experiences"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-8 flex flex-col justify-between md:flex-row lg:mt-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative h-72 rounded-lg bg-haiti bg-cover bg-no-repeat shadow-image transition-all duration-300 ease-in-out hover:shadow-xl md:h-auto lg:w-full lg:max-w-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute h-full w-full overflow-hidden rounded-lg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                alt: "Woman thinking with a blue background overlay in the image",
                                                src: "/images/home/report-image-home.png",
                                                layout: "fill",
                                                objectFit: "cover",
                                                quality: 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/resources/dxp-report-2020",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "relative flex h-full flex-col p-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm font-medium uppercase tracking-wide text-whisper",
                                                        children: "Report"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-auto",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "mb-4 text-xl font-bold leading-6 text-white",
                                                                children: "Modernizing enterprise tech stacks by embracing modular DXPs"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "flex items-center font-medium text-white",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "mr-2 block",
                                                                        children: "Download the report"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {
                                                                        className: "h-5 w-5 rotate-180 transform fill-current"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml-0 mt-6 md:ml-6 md:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-lg bg-white shadow-image transition-all duration-300 ease-in-out hover:shadow-card-hover",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://www.youtube.com/watch?v=H3iEXqjYRkE",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "block h-full py-6 px-4 lg:p-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm font-medium uppercase tracking-wide text-rose",
                                                        children: "Webinar"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                        className: "mt-4 mb-2 text-xl font-bold leading-6 text-haiti md:mt-8",
                                                        children: [
                                                            "High performance & personalization for eCommerce experiences",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {
                                                                className: "ml-2 inline-block h-5 w-5 rotate-180 transform fill-current"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm leading-normal text-light-haiti",
                                                        children: "Learn more about why you shouldn't have to compromise when you want to deliver modern, high-performance eCommerce experiences, alongside personalization and AB Testing."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative mt-6 overflow-hidden rounded-lg bg-white shadow-image transition-all duration-300 ease-in-out hover:shadow-card-hover",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://slack.graphcms.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "block h-full py-6 px-4 lg:p-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm font-medium uppercase tracking-wide text-rose",
                                                        children: "Community"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                        className: "relative z-10 mb-2 mt-4 text-xl font-bold leading-6 text-haiti md:mt-16",
                                                        children: [
                                                            "Join our engaged community on Slack",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow/* default */.Z, {
                                                                className: "ml-2 inline-block h-5 w-5 rotate-180 transform fill-current"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm leading-normal text-light-haiti",
                                                        children: "Connect with an engaged community of 7,000+ developers and creators to get your questions resolved and learn about new opportunities in the GraphQL space."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(slack/* default */.Z, {
                                                        className: "absolute top-0 right-0 z-0 -mt-2 -mr-2 h-24 w-24 text-catskill-white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 46467:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"Ratings_grid__ZQmiL"};

/***/ }),

/***/ 34591:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__0J6m_"};

/***/ }),

/***/ 80529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridBusinesses":"home_gridBusinesses__rxIr_","gridCreators":"home_gridCreators___BDVI","gridEng":"home_gridEng__TRcWJ","gridTabs":"home_gridTabs___f4sk"};

/***/ }),

/***/ 23746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ dist; },
  "lG": function() { return /* binding */ defaultProps; }
});

// UNUSED EXPORTS: Prism

// EXTERNAL MODULE: ./node_modules/prism-react-renderer/prism/index.js
var prism = __webpack_require__(87410);
;// CONCATENATED MODULE: ./node_modules/prism-react-renderer/themes/duotoneDark/index.js
// Duotone Dark
// Author: Simurai, adapted from DuoTone themes for Atom (http://simurai.com/projects/2016/01/01/duotone-themes)
// Conversion: Bram de Haan (http://atelierbram.github.io/Base2Tone-prism/output/prism/prism-base2tone-evening-dark.css)
// Generated with Base16 Builder (https://github.com/base16-builder/base16-builder)
var theme = {
  plain: {
    backgroundColor: "#2a2734",
    color: "#9a86fd"
  },
  styles: [{
    types: ["comment", "prolog", "doctype", "cdata", "punctuation"],
    style: {
      color: "#6c6783"
    }
  }, {
    types: ["namespace"],
    style: {
      opacity: 0.7
    }
  }, {
    types: ["tag", "operator", "number"],
    style: {
      color: "#e09142"
    }
  }, {
    types: ["property", "function"],
    style: {
      color: "#9a86fd"
    }
  }, {
    types: ["tag-id", "selector", "atrule-id"],
    style: {
      color: "#eeebff"
    }
  }, {
    types: ["attr-name"],
    style: {
      color: "#c4b9fe"
    }
  }, {
    types: ["boolean", "string", "entity", "url", "attr-value", "keyword", "control", "directive", "unit", "statement", "regex", "at-rule", "placeholder", "variable"],
    style: {
      color: "#ffcc99"
    }
  }, {
    types: ["deleted"],
    style: {
      textDecorationLine: "line-through"
    }
  }, {
    types: ["inserted"],
    style: {
      textDecorationLine: "underline"
    }
  }, {
    types: ["italic"],
    style: {
      fontStyle: "italic"
    }
  }, {
    types: ["important", "bold"],
    style: {
      fontWeight: "bold"
    }
  }, {
    types: ["important"],
    style: {
      color: "#c4b9fe"
    }
  }]
};

/* harmony default export */ var duotoneDark = (theme);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/prism-react-renderer/dist/index.js





var defaultProps = {
  // $FlowFixMe
  Prism: prism/* default */.Z,
  theme: duotoneDark
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var newlineRe = /\r\n|\r|\n/; // Empty lines need to contain a single empty token, denoted with { empty: true }

var normalizeEmptyLines = function (line) {
  if (line.length === 0) {
    line.push({
      types: ["plain"],
      content: "\n",
      empty: true
    });
  } else if (line.length === 1 && line[0].content === "") {
    line[0].content = "\n";
    line[0].empty = true;
  }
};

var appendTypes = function (types, add) {
  var typesSize = types.length;

  if (typesSize > 0 && types[typesSize - 1] === add) {
    return types;
  }

  return types.concat(add);
}; // Takes an array of Prism's tokens and groups them by line, turning plain
// strings into tokens as well. Tokens can become recursive in some cases,
// which means that their types are concatenated. Plain-string tokens however
// are always of type "plain".
// This is not recursive to avoid exceeding the call-stack limit, since it's unclear
// how nested Prism's tokens can become


var normalizeTokens = function (tokens) {
  var typeArrStack = [[]];
  var tokenArrStack = [tokens];
  var tokenArrIndexStack = [0];
  var tokenArrSizeStack = [tokens.length];
  var i = 0;
  var stackIndex = 0;
  var currentLine = [];
  var acc = [currentLine];

  while (stackIndex > -1) {
    while ((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]) {
      var content = void 0;
      var types = typeArrStack[stackIndex];
      var tokenArr = tokenArrStack[stackIndex];
      var token = tokenArr[i]; // Determine content and append type to types if necessary

      if (typeof token === "string") {
        types = stackIndex > 0 ? types : ["plain"];
        content = token;
      } else {
        types = appendTypes(types, token.type);

        if (token.alias) {
          types = appendTypes(types, token.alias);
        }

        content = token.content;
      } // If token.content is an array, increase the stack depth and repeat this while-loop


      if (typeof content !== "string") {
        stackIndex++;
        typeArrStack.push(types);
        tokenArrStack.push(content);
        tokenArrIndexStack.push(0);
        tokenArrSizeStack.push(content.length);
        continue;
      } // Split by newlines


      var splitByNewlines = content.split(newlineRe);
      var newlineCount = splitByNewlines.length;
      currentLine.push({
        types: types,
        content: splitByNewlines[0]
      }); // Create a new line for each string on a new line

      for (var i$1 = 1; i$1 < newlineCount; i$1++) {
        normalizeEmptyLines(currentLine);
        acc.push(currentLine = []);
        currentLine.push({
          types: types,
          content: splitByNewlines[i$1]
        });
      }
    } // Decreate the stack depth


    stackIndex--;
    typeArrStack.pop();
    tokenArrStack.pop();
    tokenArrIndexStack.pop();
    tokenArrSizeStack.pop();
  }

  normalizeEmptyLines(currentLine);
  return acc;
};

var themeToDict = function (theme, language) {
  var plain = theme.plain; // $FlowFixMe

  var base = Object.create(null);
  var themeDict = theme.styles.reduce(function (acc, themeEntry) {
    var languages = themeEntry.languages;
    var style = themeEntry.style;

    if (languages && !languages.includes(language)) {
      return acc;
    }

    themeEntry.types.forEach(function (type) {
      // $FlowFixMe
      var accStyle = _extends({}, acc[type], style);

      acc[type] = accStyle;
    });
    return acc;
  }, base); // $FlowFixMe

  themeDict.root = plain; // $FlowFixMe

  themeDict.plain = _extends({}, plain, {
    backgroundColor: null
  });
  return themeDict;
};

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];

  return target;
}

var Highlight = /*@__PURE__*/function (Component) {
  function Highlight() {
    var this$1 = this;
    var args = [],
        len = arguments.length;

    while (len--) args[len] = arguments[len];

    Component.apply(this, args);

    _defineProperty(this, "getThemeDict", function (props) {
      if (this$1.themeDict !== undefined && props.theme === this$1.prevTheme && props.language === this$1.prevLanguage) {
        return this$1.themeDict;
      }

      this$1.prevTheme = props.theme;
      this$1.prevLanguage = props.language;
      var themeDict = props.theme ? themeToDict(props.theme, props.language) : undefined;
      return this$1.themeDict = themeDict;
    });

    _defineProperty(this, "getLineProps", function (ref) {
      var key = ref.key;
      var className = ref.className;
      var style = ref.style;
      var rest$1 = objectWithoutProperties(ref, ["key", "className", "style", "line"]);
      var rest = rest$1;

      var output = _extends({}, rest, {
        className: "token-line",
        style: undefined,
        key: undefined
      });

      var themeDict = this$1.getThemeDict(this$1.props);

      if (themeDict !== undefined) {
        output.style = themeDict.plain;
      }

      if (style !== undefined) {
        output.style = output.style !== undefined ? _extends({}, output.style, style) : style;
      }

      if (key !== undefined) {
        output.key = key;
      }

      if (className) {
        output.className += " " + className;
      }

      return output;
    });

    _defineProperty(this, "getStyleForToken", function (ref) {
      var types = ref.types;
      var empty = ref.empty;
      var typesSize = types.length;
      var themeDict = this$1.getThemeDict(this$1.props);

      if (themeDict === undefined) {
        return undefined;
      } else if (typesSize === 1 && types[0] === "plain") {
        return empty ? {
          display: "inline-block"
        } : undefined;
      } else if (typesSize === 1 && !empty) {
        return themeDict[types[0]];
      }

      var baseStyle = empty ? {
        display: "inline-block"
      } : {}; // $FlowFixMe

      var typeStyles = types.map(function (type) {
        return themeDict[type];
      });
      return Object.assign.apply(Object, [baseStyle].concat(typeStyles));
    });

    _defineProperty(this, "getTokenProps", function (ref) {
      var key = ref.key;
      var className = ref.className;
      var style = ref.style;
      var token = ref.token;
      var rest$1 = objectWithoutProperties(ref, ["key", "className", "style", "token"]);
      var rest = rest$1;

      var output = _extends({}, rest, {
        className: "token " + token.types.join(" "),
        children: token.content,
        style: this$1.getStyleForToken(token),
        key: undefined
      });

      if (style !== undefined) {
        output.style = output.style !== undefined ? _extends({}, output.style, style) : style;
      }

      if (key !== undefined) {
        output.key = key;
      }

      if (className) {
        output.className += " " + className;
      }

      return output;
    });

    _defineProperty(this, "tokenize", function (Prism, code, grammar, language) {
      var env = {
        code: code,
        grammar: grammar,
        language: language,
        tokens: []
      };
      Prism.hooks.run("before-tokenize", env);
      var tokens = env.tokens = Prism.tokenize(env.code, env.grammar, env.language);
      Prism.hooks.run("after-tokenize", env);
      return tokens;
    });
  }

  if (Component) Highlight.__proto__ = Component;
  Highlight.prototype = Object.create(Component && Component.prototype);
  Highlight.prototype.constructor = Highlight;

  Highlight.prototype.render = function render() {
    var ref = this.props;
    var Prism = ref.Prism;
    var language = ref.language;
    var code = ref.code;
    var children = ref.children;
    var themeDict = this.getThemeDict(this.props);
    var grammar = Prism.languages[language];
    var mixedTokens = grammar !== undefined ? this.tokenize(Prism, code, grammar, language) : [code];
    var tokens = normalizeTokens(mixedTokens);
    return children({
      tokens: tokens,
      className: "prism-code language-" + language,
      style: themeDict !== undefined ? themeDict.root : {},
      getLineProps: this.getLineProps,
      getTokenProps: this.getTokenProps
    });
  };

  return Highlight;
}(react.Component);

/* harmony default export */ var dist = (Highlight);



/***/ }),

/***/ 95424:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// Original: https://github.com/sdras/night-owl-vscode-theme
// Converted automatically using ./tools/themeFromVsCode
var theme = {
  plain: {
    color: "#d6deeb",
    backgroundColor: "#011627"
  },
  styles: [{
    types: ["changed"],
    style: {
      color: "rgb(162, 191, 252)",
      fontStyle: "italic"
    }
  }, {
    types: ["deleted"],
    style: {
      color: "rgba(239, 83, 80, 0.56)",
      fontStyle: "italic"
    }
  }, {
    types: ["inserted", "attr-name"],
    style: {
      color: "rgb(173, 219, 103)",
      fontStyle: "italic"
    }
  }, {
    types: ["comment"],
    style: {
      color: "rgb(99, 119, 119)",
      fontStyle: "italic"
    }
  }, {
    types: ["string", "url"],
    style: {
      color: "rgb(173, 219, 103)"
    }
  }, {
    types: ["variable"],
    style: {
      color: "rgb(214, 222, 235)"
    }
  }, {
    types: ["number"],
    style: {
      color: "rgb(247, 140, 108)"
    }
  }, {
    types: ["builtin", "char", "constant", "function"],
    style: {
      color: "rgb(130, 170, 255)"
    }
  }, {
    // This was manually added after the auto-generation
    // so that punctuations are not italicised
    types: ["punctuation"],
    style: {
      color: "rgb(199, 146, 234)"
    }
  }, {
    types: ["selector", "doctype"],
    style: {
      color: "rgb(199, 146, 234)",
      fontStyle: "italic"
    }
  }, {
    types: ["class-name"],
    style: {
      color: "rgb(255, 203, 139)"
    }
  }, {
    types: ["tag", "operator", "keyword"],
    style: {
      color: "rgb(127, 219, 202)"
    }
  }, {
    types: ["boolean"],
    style: {
      color: "rgb(255, 88, 116)"
    }
  }, {
    types: ["property"],
    style: {
      color: "rgb(128, 203, 196)"
    }
  }, {
    types: ["namespace"],
    style: {
      color: "rgb(178, 204, 214)"
    }
  }]
};

/* harmony default export */ __webpack_exports__["Z"] = (theme);


/***/ }),

/***/ 90874:
/***/ (function() {

Prism.languages.swift = {
	'comment': {
		// Nested comments are supported up to 2 levels
		pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
		lookbehind: true,
		greedy: true
	},
	'string-literal': [
		// https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
		{
			pattern: RegExp(
				/(^|[^"#])/.source
				+ '(?:'
				// single-line string
				+ /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source
				+ '|'
				// multi-line string
				+ /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source
				+ ')'
				+ /(?!["#])/.source
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
					lookbehind: true,
					inside: null // see below
				},
				'interpolation-punctuation': {
					pattern: /^\)|\\\($/,
					alias: 'punctuation'
				},
				'punctuation': /\\(?=[\r\n])/,
				'string': /[\s\S]+/
			}
		},
		{
			pattern: RegExp(
				/(^|[^"#])(#+)/.source
				+ '(?:'
				// single-line string
				+ /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source
				+ '|'
				// multi-line string
				+ /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source
				+ ')'
				+ '\\2'
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
					lookbehind: true,
					inside: null // see below
				},
				'interpolation-punctuation': {
					pattern: /^\)|\\#+\($/,
					alias: 'punctuation'
				},
				'string': /[\s\S]+/
			}
		},
	],

	'directive': {
		// directives with conditions
		pattern: RegExp(
			/#/.source
			+ '(?:'
			+ (
				/(?:elseif|if)\b/.source
				+ '(?:[ \t]*'
				// This regex is a little complex. It's equivalent to this:
				//   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
				// where <round> is a general parentheses expression.
				+ /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source
				+ ')+'
			)
			+ '|'
			+ /(?:else|endif)\b/.source
			+ ')'
		),
		alias: 'property',
		inside: {
			'directive-name': /^#\w+/,
			'boolean': /\b(?:false|true)\b/,
			'number': /\b\d+(?:\.\d+)*\b/,
			'operator': /!|&&|\|\||[<>]=?/,
			'punctuation': /[(),]/
		}
	},
	'literal': {
		pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
		alias: 'constant'
	},
	'other-directive': {
		pattern: /#\w+\b/,
		alias: 'property'
	},

	'attribute': {
		pattern: /@\w+/,
		alias: 'atrule'
	},

	'function-definition': {
		pattern: /(\bfunc\s+)\w+/,
		lookbehind: true,
		alias: 'function'
	},
	'label': {
		// https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
		pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
		lookbehind: true,
		alias: 'important'
	},

	'keyword': /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
	'boolean': /\b(?:false|true)\b/,
	'nil': {
		pattern: /\bnil\b/,
		alias: 'constant'
	},

	'short-argument': /\$\d+\b/,
	'omit': {
		pattern: /\b_\b/,
		alias: 'keyword'
	},
	'number': /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,

	// A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
	'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
	'function': /\b[a-z_]\w*(?=\s*\()/i,
	'constant': /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,

	// Operators are generic in Swift. Developers can even create new operators (e.g. +++).
	// https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
	// This regex only supports ASCII operators.
	'operator': /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
	'punctuation': /[{}[\]();,.:\\]/
};

Prism.languages.swift['string-literal'].forEach(function (rule) {
	rule.inside['interpolation'].inside = Prism.languages.swift;
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,2283,5026,8575,684,5343,1635,8953,1985,5374,2528,9774,2888,179], function() { return __webpack_exec__(78581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);